import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  LicensePlateInput: { input: string; output: string; }
  URL: { input: string; output: string; }
  VinInput: { input: any; output: any; }
};

export type AcceptBidInput = {
  key: Scalars['String']['input'];
};

/** Deprecated. Use VehicleAccident instead */
export type Accident = {
  __typename?: 'Accident';
  area?: Maybe<AccidentArea>;
  damageIds?: Maybe<Array<Scalars['String']['output']>>;
  hash?: Maybe<Scalars['String']['output']>;
  invoiceImages: Array<VehicleImage>;
  isBadlyRepaired?: Maybe<Scalars['Boolean']['output']>;
  isRepairCostsAvailable?: Maybe<Scalars['Boolean']['output']>;
  isTotalLoss?: Maybe<Scalars['Boolean']['output']>;
  repairCost?: Maybe<Scalars['Decimal']['output']>;
  repairStatus?: Maybe<AccidentAreaRepairStatus>;
  repairedBy?: Maybe<AccidentAreaRepairedBy>;
};

export type AccidentArea =
  | 'FRONT'
  | 'INTERIOR'
  | 'LEFT'
  | 'REAR'
  | 'RIGHT'
  | 'ROOF'
  | 'UNDERBODY';

export type AccidentAreaOption = {
  __typename?: 'AccidentAreaOption';
  area: AccidentArea;
  reasons?: Maybe<Array<AccidentReasonOption>>;
};

export type AccidentAreaRepairStatus =
  | 'NOT_REPAIRED'
  | 'POOR_OR_PARTIALLY_REPAIRED'
  | 'REPAIRED';

export type AccidentAreaRepairedBy =
  | 'INDEPENDENT'
  | 'OEM_FRANCHISE_DEALERSHIP'
  | 'UNKNOWN';

export type AccidentReason =
  | 'BODY_GAPS_OR_MISALIGNED_PANELS'
  | 'DATABASE_PROOF_OF_ACCIDENT'
  | 'INSURANCE_OR_REPAIR_INVOICE'
  | 'OTHER'
  | 'PANELS_DEFORMED_DUE_TO_DAMAGE'
  | 'PANELS_REPLACED_DUE_TO_DAMAGE'
  | 'PANELS_WITH_DIFFERENT_TONES'
  | 'PANELS_WITH_HIGH_PAINT_THICKNESS'
  | 'SIGNS_OF_STRUCTURAL_REPAIR'
  | 'UNDERLYING_STRUCTURE_DEFORMED'
  | 'WATER_FIRE_OR_HAIL_DAMAGE';

export type AccidentReasonOption = {
  __typename?: 'AccidentReasonOption';
  maxImageCount?: Maybe<Scalars['Int']['output']>;
  minImageCount?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<AccidentReason>;
};

export type ActionCheckResult = {
  relatedInspection?: Maybe<Inspection>;
  /** Indicates how long in seconds the user agent should wait before making a follow-up request */
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type ActionOptions = {
  __typename?: 'ActionOptions';
  startPriceRequire?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionOptionsInput = {
  actionName: InspectionActionName;
};

export type AdditionalDataInput = {
  carRegistrationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  certificateImages?: InputMaybe<Array<VehicleImageInput>>;
  co2Emission?: InputMaybe<Scalars['Decimal']['input']>;
  co2EmissionAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  cocEmissionKeyNumber?: InputMaybe<Scalars['Int']['input']>;
  commercialUseType?: InputMaybe<VehicleConditionCommercialType>;
  countryOfOrigin?: InputMaybe<Country>;
  currentOwnerType?: InputMaybe<OwnerType>;
  deductibleType?: InputMaybe<Scalars['Decimal']['input']>;
  deregistrationDate?: InputMaybe<Scalars['Date']['input']>;
  documentImages?: InputMaybe<Array<VehicleImageInput>>;
  envClass?: InputMaybe<VehicleEngineEmissionNorm>;
  firstRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  firstRegistrationDateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  hasCocDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasLpg?: InputMaybe<Scalars['Boolean']['input']>;
  hasTuning?: InputMaybe<Scalars['Boolean']['input']>;
  isDeregistered?: InputMaybe<Scalars['Boolean']['input']>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  keyCount?: InputMaybe<Scalars['Int']['input']>;
  kmEngineExchange?: InputMaybe<Scalars['Int']['input']>;
  lastRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  lastRegistrationDateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  licensePlateType?: InputMaybe<LicensePlateType>;
  lpgNote?: InputMaybe<Scalars['String']['input']>;
  modifiedNote?: InputMaybe<Scalars['String']['input']>;
  originalEngine?: InputMaybe<Scalars['Boolean']['input']>;
  otherNotes?: InputMaybe<Scalars['String']['input']>;
  previousOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  previousOwnersNumberAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  technicalInspectionCertificateExpiryAtDate?: InputMaybe<Scalars['Date']['input']>;
  titleBriefAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  vatType?: InputMaybe<VatType>;
  wasInCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AdvancedSelfInspectionInput = {
  equipment?: InputMaybe<Array<EquipmentItemInput>>;
  hasTechnicalInspectionCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lastDriveBeltChangeDate?: InputMaybe<Scalars['Date']['input']>;
  lastDriveBeltChangeMileage?: InputMaybe<Scalars['Int']['input']>;
  lastServiceDate?: InputMaybe<Scalars['Date']['input']>;
  lastServiceMileage?: InputMaybe<Scalars['Int']['input']>;
  otherNote?: InputMaybe<Scalars['String']['input']>;
  selfEvaVehicleId: Scalars['Int']['input'];
  selfInspection: SelfInspectionInput;
  serviceBookType?: InputMaybe<VehicleServiceBookType>;
  technicalInspectionCertificateIssueDate?: InputMaybe<Scalars['Date']['input']>;
  technicalInspectionCertificateIssueMileage?: InputMaybe<Scalars['Int']['input']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  appointmentStartTime?: Maybe<Scalars['String']['output']>;
  appointmentStatus: AppointmentStatusEnum;
  branch: Branch;
  carName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  leadCreatedTime?: Maybe<Scalars['String']['output']>;
  stockNumber: Scalars['String']['output'];
};

export type AppointmentList = {
  __typename?: 'AppointmentList';
  entities: Array<Appointment>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type AppointmentStatusEnum =
  | 'CANCELED'
  | 'CONFIRMED'
  | 'RESCHEDULED';

export type AssignedUser = {
  __typename?: 'AssignedUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Auction = {
  __typename?: 'Auction';
  auctionType: Scalars['Int']['output'];
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  startDateTime: Scalars['DateTime']['output'];
  statusId: Scalars['Int']['output'];
  underbiddingThreshold?: Maybe<Scalars['Float']['output']>;
};

export type AuctionOption = {
  __typename?: 'AuctionOption';
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type AuctionType =
  | 'BATCH_AUCTION'
  | 'CUSTOM_AUCTION'
  | 'CUSTOM_AUCTION_TRACKS'
  | 'DCB_AUCTION'
  | 'DIRECT_AUCTION'
  | 'ZRT_24H_AUCTION';

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  actions: UserActions;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inspectionTypes: Array<UserInspectionType>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  settings: UserSettings;
  userType: UserType;
};


export type AuthenticatedUserInspectionTypesArgs = {
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Auto1AuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated. Use termsAccepted */
  termsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Auto1BatchAuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type Auto1DirectAuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type AutoPrice = {
  __typename?: 'AutoPrice';
  priceInMinorUnits?: Maybe<Scalars['Int']['output']>;
  status: AutoPriceStatus;
};

export type AutoPriceStatus =
  | 'FINISHED'
  | 'RUNNING';

export type BeforeSubmitLicensePlateCheckResult = ActionCheckResult & {
  __typename?: 'BeforeSubmitLicensePlateCheckResult';
  relatedInspection?: Maybe<Inspection>;
  /** Indicates how long in seconds the user agent should wait before making a follow-up request */
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type BeforeSubmitToAuctionCheckResult = ActionCheckResult & {
  __typename?: 'BeforeSubmitToAuctionCheckResult';
  relatedInspection?: Maybe<Inspection>;
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type BeforeSubmitVinCheckResult = ActionCheckResult & {
  __typename?: 'BeforeSubmitVinCheckResult';
  relatedInspection?: Maybe<Inspection>;
  /** Indicates how long in seconds the user agent should wait before making a follow-up request */
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type Branch = {
  __typename?: 'Branch';
  city: Scalars['String']['output'];
  country: Country;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  licensePlateCallEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  vat?: Maybe<CountryVat>;
  zipcode: Scalars['String']['output'];
};

export type BranchInput = {
  city: Scalars['String']['input'];
  country: Country;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type BranchList = {
  __typename?: 'BranchList';
  entities: Array<Branch>;
  name?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type BuyerInfo = {
  __typename?: 'BuyerInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Car = {
  __typename?: 'Car';
  carLeadId?: Maybe<Scalars['String']['output']>;
  carName?: Maybe<Scalars['String']['output']>;
  guaranteedPriceOptions?: Maybe<GuaranteedPriceOptions>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isGuaranteedPriceAvailable: GuaranteedPriceAvailabilityStatus;
  state?: Maybe<CarState>;
  stockNumber?: Maybe<Scalars['String']['output']>;
  transportStatus?: Maybe<TransportStatus>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type CarAction = {
  __typename?: 'CarAction';
  name?: Maybe<CarActionName>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CarActionName =
  | 'ACCEPT_BID'
  | 'ACCEPT_COUNTER_OFFER'
  | 'ACCEPT_GUARANTEED_PRICE'
  | 'ACCEPT_PRICE'
  | 'ACCEPT_SPECIFIC_BID'
  | 'ACCEPT_TOP_BID'
  | 'ADD_INVOICE'
  | 'ADD_TO_AUTO1_AUCTION'
  | 'ADD_TO_AUTO1_BATCH_AUCTION'
  | 'ADD_TO_AUTO1_DIRECT_AUCTION'
  | 'ADD_TO_FULL_EVALUATION'
  | 'ARCHIVE_CAR'
  | 'DECREASE_EXPECTED_PRICE'
  | 'EDIT_PRICE_INDICATOR'
  | 'GENERATE_PDF'
  | 'MAKE_COUNTER_OFFER'
  | 'REJECT_COUNTER_OFFER'
  | 'REJECT_GUARANTEED_PRICE'
  | 'REJECT_OFFER'
  | 'REQUEST_TRANSPORT'
  | 'RE_RUN_AUTO1_AUCTION'
  | 'RE_RUN_AUTO1_BATCH_AUCTION'
  | 'RE_RUN_AUTO1_DIRECT_AUCTION'
  | 'RE_RUN_CUSTOM_AUCTION'
  | 'RE_RUN_CUSTOM_TRACK_AUCTION'
  | 'STOP_AUCTION'
  | 'UNARCHIVE_CAR';

export type CarBid = {
  __typename?: 'CarBid';
  comment?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  fees?: Maybe<Scalars['Int']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  maxPrice?: Maybe<Scalars['Int']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type CarBidStatus =
  | 'HIGHER_BID'
  | 'REJECTED'
  | 'UNDER_BID';

export type CarChannel =
  | 'EVALUATION_DRAFT'
  | 'MY_AUCTION'
  | 'REMARKETING';

export type CarCurrentBid = {
  __typename?: 'CarCurrentBid';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  localCurrency?: Maybe<Currency>;
  localCurrencyAmount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<CarBidStatus>;
};

export type CarDataItem = {
  __typename?: 'CarDataItem';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CarDetailsInput = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  countryOfRegistration?: InputMaybe<Scalars['String']['input']>;
  damageValue?: InputMaybe<Scalars['Int']['input']>;
  doorCount?: InputMaybe<Scalars['Int']['input']>;
  emissionNorm?: InputMaybe<Scalars['String']['input']>;
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  gearBox?: InputMaybe<Scalars['String']['input']>;
  hasAccident?: InputMaybe<Scalars['Boolean']['input']>;
  hasMetallicColor?: InputMaybe<Scalars['Boolean']['input']>;
  isOriginalColor?: InputMaybe<Scalars['Boolean']['input']>;
  isUpholsteryOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  keyCount?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  otherNotes?: InputMaybe<Scalars['String']['input']>;
  previousOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  technicalInspectionCertificateExpiryAtDate?: InputMaybe<Scalars['Date']['input']>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  upholstery?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type CarProperties = {
  __typename?: 'CarProperties';
  acceptableOffer?: Maybe<Scalars['Int']['output']>;
  auctionEndTime?: Maybe<Scalars['DateTime']['output']>;
  auctionStartTime?: Maybe<Scalars['DateTime']['output']>;
  counterOffer?: Maybe<CounterOffer>;
  currentBid?: Maybe<CarCurrentBid>;
  evaluationEndTime?: Maybe<Scalars['DateTime']['output']>;
  evaluationStartDatetime?: Maybe<Scalars['DateTime']['output']>;
  expectedPrice?: Maybe<Price>;
  offerExpireOn?: Maybe<Scalars['DateTime']['output']>;
  rerunCount?: Maybe<Scalars['Int']['output']>;
  rerunLimit?: Maybe<Scalars['Int']['output']>;
  sellerOfferThresholdDifferenceInMinorUnits?: Maybe<Scalars['Int']['output']>;
  soldPrice?: Maybe<Price>;
  statistics?: Maybe<CarStatistics>;
  status?: Maybe<CarStatus>;
  vat?: Maybe<CarVatData>;
};

export type CarState = {
  __typename?: 'CarState';
  /** Deprecated. Use inspection.actions */
  actions: Array<CarAction>;
  auctionType?: Maybe<AuctionType>;
  bids?: Maybe<Array<CarBid>>;
  channel?: Maybe<CarChannel>;
  guaranteedPrice?: Maybe<GuaranteedPrice>;
  instantPrice: InstantPriceProperties;
  /** Deprecated. Use car.state.properties.soldPrice */
  onsitePrice?: Maybe<Scalars['Int']['output']>;
  previousOffer?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<CarProperties>;
  purchasePrice?: Maybe<Scalars['Int']['output']>;
  topBid?: Maybe<CarTopBid>;
};


export type CarStateBidsArgs = {
  showEverything?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarStatistics = {
  __typename?: 'CarStatistics';
  bids?: Maybe<Scalars['Int']['output']>;
  watches?: Maybe<Scalars['Int']['output']>;
};

export type CarStatus =
  | 'AUCTION_ENDED'
  | 'AUCTION_RUNNING'
  | 'ENDED'
  | 'FAST_PRICE_GIVEN'
  | 'FAST_PRICE_PENDING'
  | 'INCOMPLETE'
  | 'INVALID'
  | 'IN_REVIEW'
  | 'OFFER_EXPIRED'
  | 'OFFER_REJECTED'
  | 'PENDING_BATCH_ASSIGNMENT'
  | 'PRICE_GIVEN'
  | 'PRICE_INDICATOR_INCOMPLETE'
  | 'PRICE_PENDING'
  | 'PURCHASED'
  | 'RUNNING'
  | 'SOLD'
  | 'VERIFICATION_FAILED'
  | 'WAITING_FOR_DECISION';

export type CarTopBid = {
  __typename?: 'CarTopBid';
  key: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  offer: Scalars['Int']['output'];
};

export type CarVatData = {
  __typename?: 'CarVatData';
  rate?: Maybe<Scalars['Decimal']['output']>;
};

export type CheckoutType = {
  __typename?: 'CheckoutType';
  enabled: Scalars['Boolean']['output'];
  reason?: Maybe<CheckoutTypeReason>;
  type: CheckoutTypeTypes;
};

export type CheckoutTypeReason =
  | 'RISK_FREE';

export type CheckoutTypeTypes =
  | 'AUCTION'
  | 'BATCH_AUCTION'
  | 'CUSTOM_AUCTION'
  | 'CUSTOM_AUCTION_TRACKS'
  | 'DIRECT_AUCTION'
  | 'PRICING'
  | 'PURCHASE';

export type Company = {
  __typename?: 'Company';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanyVatType =
  | 'DEDUCTIBLE'
  | 'NOT_DEDUCTIBLE'
  | 'UNKNOWN';

export type ConditionDamageEnum =
  | 'BUMP'
  | 'DENT'
  | 'FADED_PAINT'
  | 'HAIL_DAMAGE'
  | 'RUST'
  | 'SCRATCH'
  | 'STONE_CHIPS'
  | 'WEAR_AND_TEAR_OF_SEATS_AND_INTERIOR';

export type CounterOffer = {
  __typename?: 'CounterOffer';
  buyerOffer?: Maybe<Price>;
  extras?: Maybe<CounterOfferExtras>;
  negotiationEndTime?: Maybe<Scalars['DateTime']['output']>;
  sellerOffer?: Maybe<Price>;
  status?: Maybe<CounterOfferStatus>;
};

export type CounterOfferExtras = {
  __typename?: 'CounterOfferExtras';
  acceptedOn?: Maybe<Scalars['DateTime']['output']>;
  rejectedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type CounterOfferStatus =
  | 'BUYER_OFFER_ACCEPTED'
  | 'BUYER_OFFER_EXPIRED'
  | 'BUYER_OFFER_PENDING'
  | 'BUYER_OFFER_REJECTED'
  | 'SELLER_OFFER_ACCEPTED'
  | 'SELLER_OFFER_EXPIRED'
  | 'SELLER_OFFER_PENDING'
  | 'SELLER_OFFER_REJECTED';

export type Country =
  | 'AC'
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'IC'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

export type CountryVat = {
  __typename?: 'CountryVat';
  rate: Scalars['Decimal']['output'];
};

export type CreatedVideo = {
  __typename?: 'CreatedVideo';
  getUrl: Scalars['String']['output'];
  /** Deprecated. Use preSignedUrl */
  postRequestData: S3RequestDataForPost;
  preSignedUrl: Scalars['String']['output'];
};

export type Currency =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BOV'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BWP'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHE'
  | 'CHF'
  | 'CHW'
  | 'CLF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'COU'
  | 'CRC'
  | 'CUC'
  | 'CUP'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KMF'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRU'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MXV'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SSP'
  | 'STN'
  | 'SVC'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMT'
  | 'TND'
  | 'TOP'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'USN'
  | 'UYI'
  | 'UYU'
  | 'UYW'
  | 'UZS'
  | 'VES'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XAF'
  | 'XAG'
  | 'XAU'
  | 'XBA'
  | 'XBB'
  | 'XBC'
  | 'XBD'
  | 'XCD'
  | 'XDR'
  | 'XOF'
  | 'XPD'
  | 'XPF'
  | 'XPT'
  | 'XSU'
  | 'XTS'
  | 'XUA'
  | 'XXX'
  | 'YER'
  | 'ZAR'
  | 'ZMW'
  | 'ZWL';

export type CurrentPrice = {
  __typename?: 'CurrentPrice';
  amountInMinorUnits?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createddOn?: Maybe<Scalars['Date']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  modifiedOn?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomAuctionInput = {
  auctionDays: Scalars['Int']['input'];
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  groups: Scalars['String']['input'];
  minimumBid: Scalars['Int']['input'];
};

export type CustomAuctionTracksInput = {
  expectedPrice: Scalars['Int']['input'];
  minimumBid: Scalars['Int']['input'];
};

export type CustomChannel = {
  __typename?: 'CustomChannel';
  isOperatedByAuto1: Scalars['Boolean']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  companyName?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<CustomerSalutation>;
  sellerType?: Maybe<CustomerSellerType>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerSalutation =
  | 'MR'
  | 'MRS'
  | 'MRS_DR'
  | 'MRS_PROF'
  | 'MR_DR'
  | 'MR_PROF';

export type CustomerSellerType =
  | 'COMPANY'
  | 'DEALER'
  | 'PRIVATE';

export type DamageArea = {
  __typename?: 'DamageArea';
  area: VehicleDamageArea;
  /** Translation Key for area value */
  areaTranslationKey?: Maybe<Scalars['String']['output']>;
  carParts: Array<DamageCarPart>;
};

export type DamageCarPart = {
  __typename?: 'DamageCarPart';
  damageTypes: Array<DamageType>;
  translationKey: Scalars['String']['output'];
  value: VehicleDamagePart;
};

export type DamageInput = {
  area?: InputMaybe<VehicleDamageArea>;
  images?: InputMaybe<Array<VehicleImageInput>>;
  isAccidentReason?: InputMaybe<Scalars['Boolean']['input']>;
  part?: InputMaybe<VehicleDamagePart>;
  repairMethod?: InputMaybe<VehicleDamageRepairMethod>;
  severity?: InputMaybe<VehicleDamageSeverity>;
  severityDetail?: InputMaybe<DamageSeverityDetailInput>;
  type?: InputMaybe<VehicleDamageType>;
};

export type DamageSeverityDetailInput = {
  depth?: InputMaybe<VehicleDamageDepthType>;
  length?: InputMaybe<Scalars['Int']['input']>;
  paintThickness?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type DamageType = {
  __typename?: 'DamageType';
  repairMethods?: Maybe<Array<VehicleQualityOption>>;
  secondSeverities?: Maybe<Array<VehicleQualityOption>>;
  severities?: Maybe<Array<VehicleQualityOption>>;
  translationKey: Scalars['String']['output'];
  value: VehicleDamageType;
};

export type DentsFromHail =
  | 'ALL'
  | 'NONE'
  | 'SOME';

export type ElectricCarDetailsInput = {
  batteryHealth?: InputMaybe<VehicleBatteryHealth>;
  batteryLeased?: InputMaybe<Scalars['Boolean']['input']>;
  batteryLeasingCostPerMonthInMinorUnits?: InputMaybe<Scalars['Int']['input']>;
  hasChargingCables?: InputMaybe<Scalars['Boolean']['input']>;
  isBatteryChargeLevelGuaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  isBatteryConditionReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isBatteryLeasingCostAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<VehicleImageInput>>;
};

export type EquipmentGroup = {
  __typename?: 'EquipmentGroup';
  canBeAdded: Scalars['Boolean']['output'];
  canBeRemoved: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  exists?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<EquipmentItem>>;
  name: Scalars['String']['output'];
  translationKey: Scalars['String']['output'];
};

export type EquipmentGroupDetails = {
  __typename?: 'EquipmentGroupDetails';
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type EquipmentGroupItemInput = {
  equipmentItems: Array<EquipmentItemInput>;
  group: Scalars['String']['input'];
};

export type EquipmentItem = {
  __typename?: 'EquipmentItem';
  description?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type EquipmentItemInput = {
  id: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};

export type EquipmentMeta = {
  __typename?: 'EquipmentMeta';
  cataloguePrice?: Maybe<EquipmentMoney>;
  description?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  featureRef?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupDetails?: Maybe<EquipmentGroupDetails>;
  id?: Maybe<Scalars['Int']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isRemovable?: Maybe<Scalars['Boolean']['output']>;
  parentRef?: Maybe<Scalars['Int']['output']>;
  replacementForRef?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subGroup?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EquipmentMoney = {
  __typename?: 'EquipmentMoney';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type EvaluationType =
  | 'MSI_APP'
  | 'PI_APP';

export type Evaluator = {
  __typename?: 'Evaluator';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EvaluatorType>;
};

export type EvaluatorType =
  | 'ADMIN'
  | 'MERCHANT';

export type ExpectedPriceLimit = {
  __typename?: 'ExpectedPriceLimit';
  notFoundReason?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
};

export type ExpectedPriceOptions = {
  __typename?: 'ExpectedPriceOptions';
  expectedPriceLimit: ExpectedPriceLimit;
  merchantSaleSuccessScore?: Maybe<Scalars['Decimal']['output']>;
  saleConfidenceLevels?: Maybe<Array<SaleConfidenceLevel>>;
  suggestedPrice: SuggestedPrice;
};

export type ExteriorQuestions = {
  hasBigDents?: InputMaybe<Scalars['Boolean']['input']>;
  hasBigScratches?: InputMaybe<Scalars['Boolean']['input']>;
  hasDentsFromHail?: InputMaybe<DentsFromHail>;
  hasMultipleDents?: InputMaybe<Scalars['Boolean']['input']>;
  hasMultipleScratches?: InputMaybe<Scalars['Boolean']['input']>;
  isWindshieldChipped?: InputMaybe<Scalars['Boolean']['input']>;
  multipleDentsThreshold?: InputMaybe<Scalars['Int']['input']>;
  multipleScratchesThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type ExtraWheelsCompleteness =
  | 'RIMS'
  | 'RIMS_AND_TIRES'
  | 'TIRES';

export type FailedReason = {
  __typename?: 'FailedReason';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  reasonName: Scalars['String']['output'];
};

export type FileUploadUrl = {
  __typename?: 'FileUploadUrl';
  url: Scalars['String']['output'];
};

export type Flow = {
  __typename?: 'Flow';
  history: Array<Scalars['String']['output']>;
  inspectionId: Scalars['Int']['output'];
};

export type FlowHistoryItem = {
  __typename?: 'FlowHistoryItem';
  method: Scalars['String']['output'];
  proceedAt: Scalars['DateTime']['output'];
};

export type GenericPrices = {
  __typename?: 'GenericPrices';
  buyPrice?: Maybe<Scalars['Int']['output']>;
  expectedPrice?: Maybe<Scalars['Int']['output']>;
  expectedPriceTarget?: Maybe<Scalars['Int']['output']>;
  mpPrice?: Maybe<Scalars['Int']['output']>;
  onsitePrice?: Maybe<Scalars['Int']['output']>;
  sellPrice?: Maybe<Scalars['Int']['output']>;
};

export type GuaranteedPrice = {
  __typename?: 'GuaranteedPrice';
  expectedTradeInDate?: Maybe<Scalars['Date']['output']>;
  expireOn?: Maybe<Scalars['DateTime']['output']>;
  /** Deprecated. use price */
  guaranteedPrice?: Maybe<Price>;
  /** Deprecated. Use status */
  guaranteedPriceRequested?: Maybe<Scalars['Boolean']['output']>;
  previousPrice?: Maybe<Price>;
  price?: Maybe<Price>;
  status?: Maybe<GuaranteedPriceStatus>;
};

export type GuaranteedPriceAvailabilityStatus =
  | 'INSPECTION_ELIGIBLE'
  | 'INSPECTION_NOT_ELIGIBLE'
  | 'NOT_AVAILABLE'
  | 'UNKNOWN';

export type GuaranteedPriceFields = {
  __typename?: 'GuaranteedPriceFields';
  rejectReasons: Array<RejectReason>;
};

export type GuaranteedPriceOptions = {
  __typename?: 'GuaranteedPriceOptions';
  futureTradeInDateLimit?: Maybe<Scalars['Date']['output']>;
  isFutureTradeInAvailable: Scalars['Boolean']['output'];
};

export type GuaranteedPriceRequestInput = {
  expectedTradeInDate?: InputMaybe<Scalars['Date']['input']>;
  expectedTradeInMileage?: InputMaybe<Scalars['Int']['input']>;
  isFutureTradeIn: Scalars['Boolean']['input'];
};

export type GuaranteedPriceStatus =
  | 'ACCEPTED'
  | 'EXPIRED'
  | 'PENDING_ACTION'
  | 'REJECTED'
  | 'REQUESTED';

export type Highlight = {
  __typename?: 'Highlight';
  area?: Maybe<VehicleDamageArea>;
  /** Translation Key for area value */
  areaTranslationKey?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  /** @deprecated Error in the type definition, use imagesV2 instead */
  images: Array<VehicleImage>;
  imagesV2: Array<HighlightImage>;
  part?: Maybe<VehicleDamagePart>;
  /** Translation Key for part value */
  partTranslationKey?: Maybe<Scalars['String']['output']>;
};

export type HighlightImage = {
  __typename?: 'HighlightImage';
  absoluteUrl: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  mimeType: VehicleMimeType;
};

export type HighlightInput = {
  area?: InputMaybe<VehicleDamageArea>;
  hash?: InputMaybe<Scalars['String']['input']>;
  images: Array<VehicleImageInput>;
  part?: InputMaybe<VehicleDamagePart>;
};

export type ImportRegion =
  | 'EU'
  | 'OTHER'
  | 'UK'
  | 'USA_CANADA';

export type Inspection = {
  __typename?: 'Inspection';
  actions: Array<InspectionAction>;
  appointmentStartTime: Scalars['DateTime']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedOn?: Maybe<Scalars['DateTime']['output']>;
  branch: Branch;
  buyer?: Maybe<BuyerInfo>;
  car: Car;
  checkInTime?: Maybe<Scalars['DateTime']['output']>;
  customer: Customer;
  editable: Scalars['Boolean']['output'];
  fields?: Maybe<InspectionFields>;
  finishedTime?: Maybe<Scalars['DateTime']['output']>;
  flags?: Maybe<InspectionFlags>;
  flowHistory?: Maybe<Array<Scalars['String']['output']>>;
  flowHistoryLastMutationCalls: Array<FlowHistoryItem>;
  hash: Scalars['String']['output'];
  inspectionId: Scalars['Int']['output'];
  lastChangedTime?: Maybe<Scalars['DateTime']['output']>;
  leadCreatedTime: Scalars['DateTime']['output'];
  meta?: Maybe<MetaPurchasing>;
  seller?: Maybe<SellerInfo>;
  sourceType: InspectionSourceType;
  status: InspectionStatus;
  type: InspectionType;
  user: User;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type InspectionAction = {
  __typename?: 'InspectionAction';
  name?: Maybe<InspectionActionName>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type InspectionActionName =
  | 'ACCEPT_BID'
  | 'ACCEPT_COUNTER_OFFER'
  | 'ACCEPT_GUARANTEED_PRICE'
  | 'ACCEPT_PRICE'
  | 'ACCEPT_SPECIFIC_BID'
  | 'ACCEPT_TOP_BID'
  | 'ADD_INVOICE'
  | 'ADD_TO_AUTO1_AUCTION'
  | 'ADD_TO_AUTO1_BATCH_AUCTION'
  | 'ADD_TO_AUTO1_DIRECT_AUCTION'
  | 'ADD_TO_FULL_EVALUATION'
  | 'ARCHIVE_CAR'
  | 'DECREASE_EXPECTED_PRICE'
  | 'EDIT_PRICE_INDICATOR'
  | 'GENERATE_PDF'
  | 'MAKE_COUNTER_OFFER'
  | 'REJECT_COUNTER_OFFER'
  | 'REJECT_GUARANTEED_PRICE'
  | 'REJECT_OFFER'
  | 'REQUEST_TRANSPORT'
  | 'RE_RUN_AUTO1_AUCTION'
  | 'RE_RUN_AUTO1_BATCH_AUCTION'
  | 'RE_RUN_AUTO1_DIRECT_AUCTION'
  | 'RE_RUN_CUSTOM_AUCTION'
  | 'RE_RUN_CUSTOM_TRACK_AUCTION'
  | 'STOP_AUCTION'
  | 'UNARCHIVE_CAR';

export type InspectionAggregates = {
  __typename?: 'InspectionAggregates';
  archived: Scalars['Int']['output'];
  statuses: Array<StatusCount>;
};

export type InspectionCollection = {
  __typename?: 'InspectionCollection';
  archivedCount: Scalars['Int']['output'];
  inspections: Array<Inspection>;
  pageInfo?: Maybe<PageInformationV2>;
  statuses: Array<StatusCount>;
  totalCount: Scalars['Int']['output'];
};

export type InspectionFields = {
  __typename?: 'InspectionFields';
  guaranteedPrice?: Maybe<GuaranteedPriceFields>;
  vehicle?: Maybe<VehicleFields>;
};

export type InspectionFlags = {
  __typename?: 'InspectionFlags';
  canReadMileage?: Maybe<Scalars['Boolean']['output']>;
  carRegistrationAvailable?: Maybe<Scalars['Boolean']['output']>;
  co2EmissionAvailable?: Maybe<Scalars['Boolean']['output']>;
  firstRegistrationDateAvailable?: Maybe<Scalars['Boolean']['output']>;
  isDamagesSubmitted?: Maybe<Scalars['Boolean']['output']>;
  isDeregistered?: Maybe<Scalars['Boolean']['output']>;
  isHighlightsSubmitted?: Maybe<Scalars['Boolean']['output']>;
  isPaintThicknessChecked?: Maybe<Scalars['Boolean']['output']>;
  lastRegistrationDateAvailable?: Maybe<Scalars['Boolean']['output']>;
  previousOwnersNumberAvailable?: Maybe<Scalars['Boolean']['output']>;
  totalOwnersNumberAvailable?: Maybe<Scalars['Boolean']['output']>;
  vinNoteAvailable?: Maybe<Scalars['Boolean']['output']>;
  wasInCommercialUse?: Maybe<Scalars['Boolean']['output']>;
};

export type InspectionFromPdfStatus = {
  __typename?: 'InspectionFromPdfStatus';
  inspectionId?: Maybe<Scalars['Int']['output']>;
  status: PdfJobStatus;
};

export type InspectionPage = {
  __typename?: 'InspectionPage';
  inspections: Array<Inspection>;
  pageInfo: PageInformation;
  statuses: Array<StatusCount>;
};

export type InspectionSourceType =
  | 'CATALOGUE_AUCTION'
  | 'MSI_APP'
  | 'PA_APP'
  | 'PDF_INSPECTION'
  | 'PI_APP'
  | 'PUBAPI_APP'
  | 'SELF_APP'
  | 'WALKIN_INSPECTION';

export type InspectionStatus =
  | 'A1_PRICE_INDICATOR_GIVEN'
  | 'APPOINTMENT'
  | 'BATCH_AUCTION_PREBIDDING'
  | 'BATCH_AUCTION_PREVIEW'
  | 'BATCH_AUCTION_WAITING_FOR_ASSIGNMENT'
  | 'FAILED'
  | 'GP_ACCEPTED'
  | 'GP_EXPIRED'
  | 'GP_PENDING_ACTION'
  | 'GP_REJECTED'
  | 'GP_REQUESTED'
  | 'PI_FAILED'
  | 'PI_UNFINISHED'
  | 'POST_PURCHASE_INVOICE_IN_VERIFICATION'
  | 'POST_PURCHASE_INVOICE_PENDING'
  | 'PRICE_GIVEN'
  | 'PURCHASE_DOCS_IN_VERIFICATION'
  | 'PURCHASE_DOCS_PENDING'
  | 'PURCHASE_DOCS_VERIFIED'
  | 'UNFINISHED'
  | 'VERIFIED'
  | 'WAITING_A1_PRICE_INDICATOR'
  | 'WAITING_PRICE'
  | 'WAITING_VERIFICATION';

export type InspectionType =
  | 'HANDOVER'
  | 'INSPECTION';

export type InspectionsQuery = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  branch?: InputMaybe<Array<Scalars['Int']['input']>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InspectionStatus>>;
};

export type InstantPriceProperties = {
  __typename?: 'InstantPriceProperties';
  acceptedOn?: Maybe<Scalars['DateTime']['output']>;
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  /** Deprecated. Use priceValue */
  onsitePrice?: Maybe<Scalars['Int']['output']>;
  priceValue?: Maybe<Price>;
  rejectedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type InteriorQuestions = {
  hasDashboardOrPanelsDamage?: InputMaybe<Trinary>;
  hasMultimediaOrNavigationDamage?: InputMaybe<Trinary>;
  hasPersistentOdours?: InputMaybe<Trinary>;
  hasStains?: InputMaybe<Trinary>;
  hasTears?: InputMaybe<Trinary>;
};

export type InventoryType =
  | 'DAMAGED'
  | 'FLEET'
  | 'LEASING'
  | 'NEW'
  | 'OTHER'
  | 'RENTAL'
  | 'TRADE_IN';

export type KeyValueStringPair = {
  __typename?: 'KeyValueStringPair';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LicensePlateType =
  | 'DEALER'
  | 'EXPORT'
  | 'NORMAL'
  | 'OLD_TIMER'
  | 'SEASON'
  | 'SHORT_TIME';

export type LoginLocalInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginLocalReturn = {
  __typename?: 'LoginLocalReturn';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginWithGoogleCodeInput = {
  authCode: Scalars['String']['input'];
};

export type LoginWithGoogleCodeReturn = {
  __typename?: 'LoginWithGoogleCodeReturn';
  data?: Maybe<LoginWithGoogleCodeReturnData>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginWithGoogleCodeReturnData = {
  __typename?: 'LoginWithGoogleCodeReturnData';
  accessToken: Scalars['String']['output'];
  adminGroupIds: Array<Scalars['Int']['output']>;
  expiresIn: Scalars['Int']['output'];
  googleAccessToken: Scalars['String']['output'];
  googleRefreshToken: Scalars['String']['output'];
  jti: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  userChksum: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userLocale: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
};

export type LogoutReturn = {
  __typename?: 'LogoutReturn';
  errormessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Merchant = {
  __typename?: 'Merchant';
  assignedTo?: Maybe<AssignedUser>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  customChannels?: Maybe<CustomChannel>;
  defaultBranchId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  score?: Maybe<MerchantScore>;
};

export type MerchantInput = {
  defaultBranchId?: InputMaybe<Scalars['Int']['input']>;
};

export type MerchantSalutation =
  | 'MR'
  | 'MRS'
  | 'MRS_DR'
  | 'MRS_PROF'
  | 'MR_DR'
  | 'MR_PROF';

export type MerchantScore = {
  __typename?: 'MerchantScore';
  metrics?: Maybe<Array<MerchantScoreMetric>>;
  totalScore?: Maybe<Scalars['Decimal']['output']>;
};

export type MerchantScoreMetric = {
  __typename?: 'MerchantScoreMetric';
  code?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<MerchantScoreMetricTranslation>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type MerchantScoreMetricTranslation = {
  __typename?: 'MerchantScoreMetricTranslation';
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
};

export type MerchantUser = {
  __typename?: 'MerchantUser';
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<MerchantSalutation>;
};

export type MetaChannels = {
  __typename?: 'MetaChannels';
  pricing?: Maybe<MetaPricing>;
  purchasing?: Maybe<MetaPurchasing>;
};

export type MetaEvaluation = {
  __typename?: 'MetaEvaluation';
  accidentRepairCost?: Maybe<Scalars['Int']['output']>;
  additionalDamagesRepairCost?: Maybe<Scalars['Int']['output']>;
  batteryLeasingCostPerMonthInMinorUnits?: Maybe<Scalars['Int']['output']>;
  bodyTypeId?: Maybe<Scalars['String']['output']>;
  cocEmissionKeyNumber?: Maybe<Scalars['Int']['output']>;
  companyVatType?: Maybe<CompanyVatType>;
  /** @deprecated Moved to vehicle.condition */
  countryOfRegistration?: Maybe<Scalars['String']['output']>;
  currentOwnerType?: Maybe<OwnerType>;
  deductibleType?: Maybe<Scalars['Decimal']['output']>;
  driveBeltChanged?: Maybe<Scalars['Boolean']['output']>;
  engineName?: Maybe<Scalars['String']['output']>;
  equipmentNote?: Maybe<Scalars['String']['output']>;
  evaluatedBy?: Maybe<Evaluator>;
  expectedPrice?: Maybe<Scalars['Int']['output']>;
  exteriorConditions?: Maybe<Array<Maybe<VehicleConditionDamageExternal>>>;
  exteriorQuestions?: Maybe<MetaExteriorQuestions>;
  extraWheelsCompleteness?: Maybe<ExtraWheelsCompleteness>;
  futureTradeInExpectedMileage?: Maybe<Scalars['Int']['output']>;
  hasAdditionalMechanicalDamages?: Maybe<Scalars['Boolean']['output']>;
  hasChargingCables?: Maybe<Scalars['Boolean']['output']>;
  hasExtraWheelSet?: Maybe<Scalars['Boolean']['output']>;
  hasLpg?: Maybe<Scalars['Boolean']['output']>;
  hasTuning?: Maybe<Scalars['Boolean']['output']>;
  hasWarningLights?: Maybe<Scalars['Boolean']['output']>;
  importRegion?: Maybe<ImportRegion>;
  interiorConditions?: Maybe<Array<Maybe<VehicleConditionDamageInternal>>>;
  interiorQuestions?: Maybe<MetaInteriorQuestions>;
  inventoryType?: Maybe<InventoryType>;
  isBatteryChargeLevelGuaranteed?: Maybe<Scalars['Boolean']['output']>;
  isBatteryConditionReportAvailable?: Maybe<Scalars['Boolean']['output']>;
  isBatteryLeasingCostAvailable?: Maybe<Scalars['Boolean']['output']>;
  isCarImported?: Maybe<Trinary>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  isLeased?: Maybe<Scalars['Boolean']['output']>;
  isMileageManipulated?: Maybe<Scalars['Boolean']['output']>;
  issuesFreeText?: Maybe<Scalars['String']['output']>;
  kmEngineExchange?: Maybe<Scalars['Int']['output']>;
  kw?: Maybe<Scalars['String']['output']>;
  licensePlateType?: Maybe<LicensePlateType>;
  lpgNote?: Maybe<Scalars['String']['output']>;
  mainType?: Maybe<Scalars['String']['output']>;
  manufacturerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated. Use vehicle.mileageManipulationSuspicions instead */
  mileageManipulatedReason?: Maybe<Scalars['String']['output']>;
  mileageManipulationSuspicions?: Maybe<MileageManipulationSuspicions>;
  modifiedNote?: Maybe<Scalars['String']['output']>;
  otherDocuments?: Maybe<Array<VehicleImage>>;
  otherNote?: Maybe<Scalars['String']['output']>;
  outstandingFinancingDueAmountInMinorUnits?: Maybe<Scalars['Int']['output']>;
  paintThickness?: Maybe<MetaPaintThickness>;
  piVehicleCondition?: Maybe<PiVehicleCondition>;
  /** @deprecated Deprecated */
  priceIndicatorPrice?: Maybe<PriceIndicatorPrice>;
  purchasePrice?: Maybe<Scalars['Int']['output']>;
  replacementLetterDate?: Maybe<Scalars['Date']['output']>;
  serviceBookAppointments?: Maybe<ServiceBookAppointmentsEnum>;
  serviceBookAppointmentsAvailable?: Maybe<Scalars['Boolean']['output']>;
  serviceBookImages?: Maybe<Array<VehicleImage>>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  technicalInspection?: Maybe<TechnicalInspectionEnum>;
  technicalInspectionCompanyId?: Maybe<Scalars['Int']['output']>;
  technicalInspectionReport?: Maybe<VehicleFile>;
  testDrivePerformed?: Maybe<Scalars['Boolean']['output']>;
  tiresGoodForOneSeason?: Maybe<Trinary>;
  titleBriefAvailable?: Maybe<Scalars['Boolean']['output']>;
  totalOwnerCount?: Maybe<Scalars['Int']['output']>;
  totalOwnersNumberAvailable?: Maybe<Scalars['Boolean']['output']>;
  tuningImages?: Maybe<Array<VehicleImage>>;
  tuningNote?: Maybe<Scalars['String']['output']>;
  tuningNoteTags?: Maybe<Array<TuningNoteTag>>;
  vatType?: Maybe<VatType>;
  vinNote?: Maybe<Scalars['String']['output']>;
};

export type MetaExteriorQuestions = {
  __typename?: 'MetaExteriorQuestions';
  hasBigDents?: Maybe<Scalars['Boolean']['output']>;
  hasBigScratches?: Maybe<Scalars['Boolean']['output']>;
  hasDentsFromHail?: Maybe<DentsFromHail>;
  hasMultipleDents?: Maybe<Scalars['Boolean']['output']>;
  hasMultipleScratches?: Maybe<Scalars['Boolean']['output']>;
  isWindshieldChipped?: Maybe<Scalars['Boolean']['output']>;
  multipleDentsThreshold?: Maybe<Scalars['Int']['output']>;
  multipleScratchesThreshold?: Maybe<Scalars['Int']['output']>;
};

export type MetaInteriorQuestions = {
  __typename?: 'MetaInteriorQuestions';
  hasDashboardOrPanelsDamage?: Maybe<Trinary>;
  hasMultimediaOrNavigationDamage?: Maybe<Trinary>;
  hasPersistentOdours?: Maybe<Trinary>;
  hasStains?: Maybe<Trinary>;
  hasTears?: Maybe<Trinary>;
};

export type MetaPaintThickness = {
  __typename?: 'MetaPaintThickness';
  back?: Maybe<Scalars['Boolean']['output']>;
  hood?: Maybe<Scalars['Boolean']['output']>;
  left?: Maybe<Scalars['Boolean']['output']>;
  right?: Maybe<Scalars['Boolean']['output']>;
  roof?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaPaintThicknessInput = {
  back?: InputMaybe<Scalars['Boolean']['input']>;
  hood?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Boolean']['input']>;
  right?: InputMaybe<Scalars['Boolean']['input']>;
  roof?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetaPricing = {
  __typename?: 'MetaPricing';
  branch?: Maybe<Branch>;
  currentPrices: Array<Maybe<CurrentPrice>>;
  equipments?: Maybe<Array<Maybe<PricingEquipmentMeta>>>;
  futureTradeInExpectedDate?: Maybe<Scalars['Date']['output']>;
  genericPrices?: Maybe<GenericPrices>;
  isFastPrice?: Maybe<Scalars['Boolean']['output']>;
  isInPricingLists?: Maybe<Scalars['Boolean']['output']>;
  isSelfEvaluation?: Maybe<Scalars['Boolean']['output']>;
  isTradeIn?: Maybe<Scalars['Boolean']['output']>;
  offerPrice?: Maybe<Scalars['Int']['output']>;
  offers: Array<Maybe<Offer>>;
  vehicleId: Scalars['Int']['output'];
};

export type MetaPurchasing = {
  __typename?: 'MetaPurchasing';
  /** @deprecated Use `vehicle.accidents` instead */
  accidents?: Maybe<Array<Accident>>;
  customer: Customer;
  equipment?: Maybe<Array<EquipmentMeta>>;
  evaluation?: Maybe<MetaEvaluation>;
  highlights?: Maybe<Array<Highlight>>;
  testDrive?: Maybe<TestDrive>;
  verification?: Maybe<MetaVerification>;
};

export type MetaVerification = {
  __typename?: 'MetaVerification';
  failedReasons?: Maybe<Array<FailedReason>>;
  verificationComment?: Maybe<Scalars['String']['output']>;
};

export type MileageManipulationSuspicions = {
  __typename?: 'MileageManipulationSuspicions';
  isMileageConflictingCarCondition?: Maybe<Scalars['Boolean']['output']>;
  isMileageConflictingDatabase?: Maybe<Scalars['Boolean']['output']>;
  isMileageConflictingServiceHistory?: Maybe<Scalars['Boolean']['output']>;
  isOdometerBroken?: Maybe<Scalars['Boolean']['output']>;
  isTachometerReplaced?: Maybe<Scalars['Boolean']['output']>;
  isTachometerReplacementMileageAvailable?: Maybe<Scalars['Boolean']['output']>;
  tachometerReplacementMileage?: Maybe<Scalars['Int']['output']>;
};

export type MileageManipulationSuspicionsInput = {
  isMileageConflictingCarCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isMileageConflictingDatabase?: InputMaybe<Scalars['Boolean']['input']>;
  isMileageConflictingServiceHistory?: InputMaybe<Scalars['Boolean']['input']>;
  isOdometerBroken?: InputMaybe<Scalars['Boolean']['input']>;
  isTachometerReplaced?: InputMaybe<Scalars['Boolean']['input']>;
  isTachometerReplacementMileageAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  tachometerReplacementMileage?: InputMaybe<Scalars['Int']['input']>;
};

export type MimeType =
  | 'PDF';

export type MpUser = {
  __typename?: 'MpUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<Merchant>;
  userName: Scalars['String']['output'];
};

export type MsiAccidentInput = {
  areas?: InputMaybe<Array<VehicleAccidentAreaInput>>;
  files?: InputMaybe<Array<VehicleFileInput>>;
  /** Deprecated. Use files with type invoice */
  invoiceImages?: InputMaybe<Array<VehicleImageInput>>;
  isRepairCostsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalLoss?: InputMaybe<Scalars['Boolean']['input']>;
  repairCost?: InputMaybe<Scalars['Decimal']['input']>;
  repairStatus?: InputMaybe<AccidentAreaRepairStatus>;
  repairedBy?: InputMaybe<AccidentAreaRepairedBy>;
};

export type MsiAdditionalDataInput = {
  carRegistrationImages?: InputMaybe<Array<VehicleImageInput>>;
  certificateImages?: InputMaybe<Array<VehicleImageInput>>;
  co2Emission?: InputMaybe<Scalars['Decimal']['input']>;
  co2EmissionAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  commercialUseType?: InputMaybe<VehicleConditionCommercialType>;
  countryOfOrigin?: InputMaybe<Country>;
  countryOfRegistration?: InputMaybe<Country>;
  currentOwnerType?: InputMaybe<OwnerType>;
  envClass?: InputMaybe<VehicleEngineEmissionNorm>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  firstRegistrationDateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryType?: InputMaybe<InventoryType>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  titleBriefAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  totalOwnersNumberAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  vatType?: InputMaybe<VatType>;
  wasInCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MsiOtherInfoInput = {
  exteriorColor?: InputMaybe<VehicleExteriorColor>;
  hasChargingCables?: InputMaybe<Scalars['Boolean']['input']>;
  hasLpg?: InputMaybe<Scalars['Boolean']['input']>;
  hasTuning?: InputMaybe<Scalars['Boolean']['input']>;
  isMetallic?: InputMaybe<Scalars['Boolean']['input']>;
  isOriginalColor?: InputMaybe<Scalars['Boolean']['input']>;
  isUpholsteryOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  keyCount?: InputMaybe<Scalars['Int']['input']>;
  lpgNote?: InputMaybe<Scalars['String']['input']>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  tuningImages?: InputMaybe<Array<VehicleImageInput>>;
  tuningNote?: InputMaybe<Scalars['String']['input']>;
  upholstery?: InputMaybe<VehicleInteriorUpholstery>;
};

export type MsiServiceInput = {
  cannotBeRolled?: InputMaybe<Scalars['Boolean']['input']>;
  driveBeltChanged?: InputMaybe<Scalars['Boolean']['input']>;
  driveBeltDate?: InputMaybe<Scalars['Date']['input']>;
  driveBeltMileage?: InputMaybe<Scalars['Int']['input']>;
  inspectionExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Deprecated. Use submitMileageSuspicions mutation */
  isMileageManipulated?: InputMaybe<Scalars['Boolean']['input']>;
  isOriginalEngine?: InputMaybe<Scalars['Boolean']['input']>;
  isRoadworthy?: InputMaybe<Scalars['Boolean']['input']>;
  kmEngineExchange?: InputMaybe<Scalars['Int']['input']>;
  lastServiceDate?: InputMaybe<Scalars['Date']['input']>;
  lastServiceMileage?: InputMaybe<Scalars['Int']['input']>;
  /** Deprecated. Use submitMileageSuspicions mutation */
  mileageManipulatedReason?: InputMaybe<Scalars['String']['input']>;
  serviceBook?: InputMaybe<VehicleServiceBookType>;
  serviceBookAppointments?: InputMaybe<ServiceBookAppointmentsEnum>;
  serviceBookAppointmentsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  serviceBookAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  serviceBookImages?: InputMaybe<Array<VehicleImageInput>>;
};

/** All Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  acceptBuyerCounterOffer: Inspection;
  acceptGuaranteedPrice: Inspection;
  createBranch: Branch;
  createInspectionFromPdf?: Maybe<InspectionFromPdfStatus>;
  createSellerCounterOffer: Inspection;
  createVideo: CreatedVideo;
  createWalkinInspection: Inspection;
  deleteVehicleImage: Inspection;
  evaAcceptBid: Inspection;
  evaAcceptPrice: Inspection;
  evaAcceptSpecificBid: Inspection;
  evaAcceptTopBid: Inspection;
  evaAddToAuto1Auction: Inspection;
  evaAddToAuto1BatchAuction: Inspection;
  evaAddToAuto1DirectAuction: Inspection;
  evaArchiveInspection: Inspection;
  evaDecreaseExpectedPrice: Inspection;
  evaPurchase: Inspection;
  evaRegisterDeviceForNotifications: Scalars['Boolean']['output'];
  evaRejectOffer: Inspection;
  evaReplaceAccidents: Inspection;
  evaRerunAuto1Auction: Inspection;
  evaRerunAuto1BatchAuction: Inspection;
  evaRerunAuto1DirectAuction: Inspection;
  evaStopCurrentAuction: Inspection;
  evaSubmitElectricCarDetails: Inspection;
  evaSubmitToAuction: Inspection;
  evaSubmitToBatchAuction: Inspection;
  evaSubmitToCustomAuction: Inspection;
  evaSubmitToCustomAuctionTracks: Inspection;
  evaSubmitToDirectAuction: Inspection;
  evaUnarchiveInspection: Inspection;
  loginLocal: LoginLocalReturn;
  loginWithGoogleCode: LoginWithGoogleCodeReturn;
  logout: LogoutReturn;
  msiPdfSubmitEcode?: Maybe<Inspection>;
  msiPdfSubmitService?: Maybe<Inspection>;
  msiPdfSubmitTechnicalInspection?: Maybe<Inspection>;
  msiPdfSubmitVin?: Maybe<Inspection>;
  /** @deprecated Don't support hasHadAccident use evaReplaceAccidents */
  msiReplaceAccidents: Inspection;
  msiReplaceBrakeConditions?: Maybe<Inspection>;
  msiReplaceDamages: Inspection;
  msiReplaceHighlights: Inspection;
  msiSubmitAdditionalData?: Maybe<Inspection>;
  msiSubmitEcode?: Maybe<Inspection>;
  msiSubmitEquipment: Inspection;
  msiSubmitOtherDocuments: Inspection;
  msiSubmitOtherInfo?: Maybe<Inspection>;
  /** Deprecated. use submitPaintThickness */
  msiSubmitPaintThickness: Inspection;
  msiSubmitService?: Maybe<Inspection>;
  msiSubmitTechnicalInspection?: Maybe<Inspection>;
  msiSubmitToAuction?: Maybe<Inspection>;
  msiSubmitVin?: Maybe<Inspection>;
  newInspection?: Maybe<Inspection>;
  patchVehicleBooleansByCarLeadId: VehicleObject;
  piConvertInspectionToFullEva: Inspection;
  piDeleteVehicleImage: Inspection;
  piReplaceAccidents: Inspection;
  piReplaceDamageTags?: Maybe<Inspection>;
  piReplaceDamages: Inspection;
  piReplaceVehicleImages: Inspection;
  piSetupInspectionForEdit: Inspection;
  piSubmitAdditionalData: Inspection;
  piSubmitAdditionalInformation: Inspection;
  piSubmitCondition: Inspection;
  piSubmitEcode?: Maybe<Inspection>;
  piSubmitForPrice?: Maybe<Inspection>;
  piSubmitForPriceV2p5?: Maybe<Inspection>;
  piSubmitLicensePlate?: Maybe<Inspection>;
  piSubmitOtherNote: Inspection;
  piSubmitService: Inspection;
  piSubmitServiceAndTechnicalInspection: Inspection;
  piSubmitTechnicalInspection: Inspection;
  piSubmitVehicleCondition: Inspection;
  piSubmitVehicleImage: Inspection;
  piSubmitVin?: Maybe<Inspection>;
  piSubmitWheels: Inspection;
  pubapiCreateCatalogueAuctionInspectionFromVin: Inspection;
  pubapiCreateInspection: Inspection;
  pubapiPiSubmitAdditionalInformation: Inspection;
  pubapiPiSubmitCondition: Inspection;
  pubapiPiSubmitServiceAndTechnicalInspection: Inspection;
  pubapiPiSubmitVehicleCondition: Inspection;
  pubapiSubmitAdditionalData: Inspection;
  pubapiSubmitToAuction: Inspection;
  pubapiSubmitToCatalogueAuction: Inspection;
  rejectBuyerCounterOffer: Inspection;
  rejectGuaranteedPrice: Inspection;
  /** Deprecated. Use evaReplaceAccidents */
  replaceAccidents: Inspection;
  replaceAdditionalCarImages: Inspection;
  replaceCarImages: Inspection;
  replaceDamages?: Maybe<Inspection>;
  replaceHighlights?: Maybe<Inspection>;
  replaceMainCarImages: Inspection;
  replaceVehicleByEcode: Inspection;
  replaceVehicleByVin: Inspection;
  replaceVehicleFiles: VehicleObject;
  replaceVehicleImagesAndDamages: VehicleObject;
  replaceVinByCarLeadId: Inspection;
  requestTransport: Inspection;
  retrySelfInspection: Inspection;
  saveFeedback?: Maybe<Scalars['Boolean']['output']>;
  startAppointment?: Maybe<Appointment>;
  submitAdditionalData: Inspection;
  submitAdvancedSelfInspection: Inspection;
  submitCarDetails: Inspection;
  submitEquipment?: Maybe<Inspection>;
  submitLicensePlate?: Maybe<Inspection>;
  submitMileage: Inspection;
  submitMileageManipulationSuspicions: Inspection;
  submitOtherNote: Inspection;
  submitOtherNoteByVehicle: VehicleObject;
  submitPaintThickness: Inspection;
  submitPurchaseDocs: Inspection;
  submitSelfInspection: Inspection;
  submitSellerInfo: Inspection;
  submitTestDriveAnswers: Inspection;
  submitToGuaranteedPrice: Inspection;
  submitToInstantPrice: Inspection;
  submitUserSettings: AuthenticatedUser;
  submitVin: Inspection;
  submitVinEquipment: Inspection;
  submitVinNote: Inspection;
  submitWheels: Inspection;
  updateBranch: Branch;
  updateCarVatType?: Maybe<Scalars['Boolean']['output']>;
  updateExteriorQuestions: MetaExteriorQuestions;
  updateRemarketingPurchaseDetails?: Maybe<Scalars['Boolean']['output']>;
  updateUnroadworthy?: Maybe<Scalars['Boolean']['output']>;
  updateUserMerchant: Merchant;
  updateWalkinCustomer?: Maybe<Inspection>;
  upsertVehicleImageBulk: Inspection;
};


/** All Mutations */
export type MutationAcceptBuyerCounterOfferArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationAcceptGuaranteedPriceArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationCreateBranchArgs = {
  branch: BranchInput;
};


/** All Mutations */
export type MutationCreateInspectionFromPdfArgs = {
  branch: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  pdfUrl: Scalars['URL']['input'];
  vin?: InputMaybe<Scalars['String']['input']>;
};


/** All Mutations */
export type MutationCreateSellerCounterOfferArgs = {
  inspectionId: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationCreateVideoArgs = {
  inspectionId: Scalars['Int']['input'];
  type: VideoType;
};


/** All Mutations */
export type MutationCreateWalkinInspectionArgs = {
  branch: Scalars['Int']['input'];
  customer: WalkinCustomerInput;
};


/** All Mutations */
export type MutationDeleteVehicleImageArgs = {
  inspectionId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


/** All Mutations */
export type MutationEvaAcceptBidArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAcceptPriceArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAcceptSpecificBidArgs = {
  data: AcceptBidInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAcceptTopBidArgs = {
  data: AcceptBidInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAddToAuto1AuctionArgs = {
  data: Auto1AuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAddToAuto1BatchAuctionArgs = {
  data: Auto1BatchAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaAddToAuto1DirectAuctionArgs = {
  data: Auto1DirectAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaArchiveInspectionArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaDecreaseExpectedPriceArgs = {
  expectedPrice: Scalars['Int']['input'];
  inspectionId: Scalars['Int']['input'];
  startPrice?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationEvaPurchaseArgs = {
  data: PurchaseInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaRegisterDeviceForNotificationsArgs = {
  clientDeviceId: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  mobileAppVersion: Scalars['String']['input'];
};


/** All Mutations */
export type MutationEvaRejectOfferArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaReplaceAccidentsArgs = {
  accidents: Array<MsiAccidentInput>;
  hasHadAccident?: InputMaybe<Scalars['Boolean']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaRerunAuto1AuctionArgs = {
  data: Auto1AuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaRerunAuto1BatchAuctionArgs = {
  data: Auto1BatchAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaRerunAuto1DirectAuctionArgs = {
  data: Auto1DirectAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaStopCurrentAuctionArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitElectricCarDetailsArgs = {
  data: ElectricCarDetailsInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitToAuctionArgs = {
  data: SubmitToAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitToBatchAuctionArgs = {
  data: SubmitToBatchAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitToCustomAuctionArgs = {
  data: CustomAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitToCustomAuctionTracksArgs = {
  data: CustomAuctionTracksInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaSubmitToDirectAuctionArgs = {
  data: SubmitToDirectAuctionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationEvaUnarchiveInspectionArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationLoginLocalArgs = {
  input: LoginLocalInput;
};


/** All Mutations */
export type MutationLoginWithGoogleCodeArgs = {
  authCode: Scalars['String']['input'];
};


/** All Mutations */
export type MutationMsiPdfSubmitEcodeArgs = {
  branch: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiPdfSubmitServiceArgs = {
  data: MsiServiceInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiPdfSubmitTechnicalInspectionArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  inspectionReport?: InputMaybe<VehicleFileInput>;
};


/** All Mutations */
export type MutationMsiPdfSubmitVinArgs = {
  branch?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  vinCheckDigit?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationMsiReplaceAccidentsArgs = {
  accidents: Array<MsiAccidentInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiReplaceBrakeConditionsArgs = {
  brakeConditions: Array<VehicleConditionBrakeInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiReplaceDamagesArgs = {
  damages: Array<DamageInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiReplaceHighlightsArgs = {
  highlights: Array<HighlightInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitAdditionalDataArgs = {
  data: MsiAdditionalDataInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitEcodeArgs = {
  branch: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitEquipmentArgs = {
  equipment: Array<EquipmentGroupItemInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitOtherDocumentsArgs = {
  inspectionId: Scalars['Int']['input'];
  otherDocuments: Array<VehicleImageInput>;
};


/** All Mutations */
export type MutationMsiSubmitOtherInfoArgs = {
  data: MsiOtherInfoInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitPaintThicknessArgs = {
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  paintThickness: MetaPaintThicknessInput;
};


/** All Mutations */
export type MutationMsiSubmitServiceArgs = {
  data: MsiServiceInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationMsiSubmitTechnicalInspectionArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  inspectionReport?: InputMaybe<VehicleFileInput>;
};


/** All Mutations */
export type MutationMsiSubmitToAuctionArgs = {
  expectedPrice: Scalars['Int']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  inspectionId: Scalars['Int']['input'];
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};


/** All Mutations */
export type MutationMsiSubmitVinArgs = {
  branch?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  vinCheckDigit?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationNewInspectionArgs = {
  input: NewInspectionInput;
};


/** All Mutations */
export type MutationPatchVehicleBooleansByCarLeadIdArgs = {
  carLeadId: Scalars['Int']['input'];
  patches: Array<PatchVehicleBooleanInput>;
};


/** All Mutations */
export type MutationPiConvertInspectionToFullEvaArgs = {
  stockNumber: Scalars['String']['input'];
};


/** All Mutations */
export type MutationPiDeleteVehicleImageArgs = {
  inspectionId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


/** All Mutations */
export type MutationPiReplaceAccidentsArgs = {
  accidents: Array<PiAccidentInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiReplaceDamageTagsArgs = {
  damages: Array<DamageInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiReplaceDamagesArgs = {
  damages: Array<DamageInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiReplaceVehicleImagesArgs = {
  images: Array<VehicleImageInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSetupInspectionForEditArgs = {
  stockNumber: Scalars['String']['input'];
};


/** All Mutations */
export type MutationPiSubmitAdditionalDataArgs = {
  data: PiAdditionalDataInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitAdditionalInformationArgs = {
  data: PiAdditionalInformationInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitConditionArgs = {
  data: PiConditionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitEcodeArgs = {
  branch: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitForPriceArgs = {
  data?: InputMaybe<PiRequestInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitForPriceV2p5Args = {
  data?: InputMaybe<PiRequestV2p5Input>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitLicensePlateArgs = {
  branch: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate: Scalars['LicensePlateInput']['input'];
};


/** All Mutations */
export type MutationPiSubmitOtherNoteArgs = {
  inspectionId: Scalars['Int']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
};


/** All Mutations */
export type MutationPiSubmitServiceArgs = {
  data: PiServiceInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitServiceAndTechnicalInspectionArgs = {
  inspectionId: Scalars['Int']['input'];
  technicalInspection: PiTechnicalInspectionInput;
};


/** All Mutations */
export type MutationPiSubmitTechnicalInspectionArgs = {
  data?: InputMaybe<VehicleFileInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitVehicleConditionArgs = {
  data: PiVehicleConditionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitVehicleImageArgs = {
  image: VehicleImageInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPiSubmitVinArgs = {
  branch?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
};


/** All Mutations */
export type MutationPiSubmitWheelsArgs = {
  inspectionId: Scalars['Int']['input'];
  isPrimarySet: Scalars['Boolean']['input'];
  wheels: Array<PiVehicleExteriorWheelDetailInput>;
};


/** All Mutations */
export type MutationPubapiCreateCatalogueAuctionInspectionFromVinArgs = {
  branchId: Scalars['Int']['input'];
  data: PubApiAdditionalDataInput;
  vin: Scalars['String']['input'];
};


/** All Mutations */
export type MutationPubapiCreateInspectionArgs = {
  branchId: Scalars['Int']['input'];
  data: PubApiAdditionalDataInput;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPubapiPiSubmitAdditionalInformationArgs = {
  data: PubApiPiAdditionalInformationInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPubapiPiSubmitConditionArgs = {
  data: PubapiPiConditionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPubapiPiSubmitServiceAndTechnicalInspectionArgs = {
  inspectionId: Scalars['Int']['input'];
  technicalInspection: PubApiPiTechnicalInspectionInput;
};


/** All Mutations */
export type MutationPubapiPiSubmitVehicleConditionArgs = {
  data: PubApiPiVehicleConditionInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPubapiSubmitAdditionalDataArgs = {
  data: PubApiAdditionalDataInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationPubapiSubmitToAuctionArgs = {
  expectedPrice: Scalars['Int']['input'];
  inspectionId: Scalars['Int']['input'];
  termsAccepted: Scalars['Boolean']['input'];
};


/** All Mutations */
export type MutationPubapiSubmitToCatalogueAuctionArgs = {
  expectedPrice: Scalars['Int']['input'];
  inspectionId: Scalars['Int']['input'];
  termsAccepted: Scalars['Boolean']['input'];
};


/** All Mutations */
export type MutationRejectBuyerCounterOfferArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationRejectGuaranteedPriceArgs = {
  data: RejectGuaranteedPriceInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceAccidentsArgs = {
  accidents: Array<VehicleAccidentInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceAdditionalCarImagesArgs = {
  images: Array<VehicleImageInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceCarImagesArgs = {
  images: Array<VehicleImageInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceDamagesArgs = {
  area: VehicleDamageArea;
  damages: Array<DamageInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceHighlightsArgs = {
  area: VehicleDamageArea;
  highlights: Array<HighlightInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceMainCarImagesArgs = {
  images: Array<VehicleImageInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceVehicleByEcodeArgs = {
  ecode: Scalars['String']['input'];
  vehicleId: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationReplaceVehicleByVinArgs = {
  vehicleId: Scalars['Int']['input'];
  vin: Scalars['String']['input'];
  vinCheckDigit?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationReplaceVehicleFilesArgs = {
  files: Array<InputMaybe<VehicleFileInput>>;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceVehicleImagesAndDamagesArgs = {
  damages?: InputMaybe<Array<DamageInput>>;
  images?: InputMaybe<Array<VehicleImageInput>>;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationReplaceVinByCarLeadIdArgs = {
  carLeadId: Scalars['Int']['input'];
  vin: Scalars['String']['input'];
};


/** All Mutations */
export type MutationRequestTransportArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationRetrySelfInspectionArgs = {
  carLeadId: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  inspection: SelfInspectionInput;
  stockNumber: Scalars['String']['input'];
};


/** All Mutations */
export type MutationSaveFeedbackArgs = {
  feedback: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


/** All Mutations */
export type MutationStartAppointmentArgs = {
  input: StartAppointmentInput;
};


/** All Mutations */
export type MutationSubmitAdditionalDataArgs = {
  data: AdditionalDataInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitAdvancedSelfInspectionArgs = {
  carLeadId: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  inspection: AdvancedSelfInspectionInput;
  sourceId: Scalars['Int']['input'];
  stockNumber: Scalars['String']['input'];
};


/** All Mutations */
export type MutationSubmitCarDetailsArgs = {
  data: CarDetailsInput;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitEquipmentArgs = {
  equipment: Array<EquipmentItemInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitLicensePlateArgs = {
  branch: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate: Scalars['LicensePlateInput']['input'];
};


/** All Mutations */
export type MutationSubmitMileageArgs = {
  canReadMileage: Scalars['Boolean']['input'];
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  mileage?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationSubmitMileageManipulationSuspicionsArgs = {
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  mileageManipulationSuspicions?: InputMaybe<MileageManipulationSuspicionsInput>;
};


/** All Mutations */
export type MutationSubmitOtherNoteArgs = {
  inspectionId: Scalars['Int']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
};


/** All Mutations */
export type MutationSubmitOtherNoteByVehicleArgs = {
  otherNote?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitPaintThicknessArgs = {
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  isPaintThicknessChecked: Scalars['Boolean']['input'];
  paintThickness?: InputMaybe<Array<VehiclePaintThicknessInput>>;
};


/** All Mutations */
export type MutationSubmitPurchaseDocsArgs = {
  data: PurchaseDocsDataInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitSelfInspectionArgs = {
  carLeadId: Scalars['Int']['input'];
  ecode: Scalars['String']['input'];
  inspection: SelfInspectionInput;
  sourceId: Scalars['Int']['input'];
  stockNumber: Scalars['String']['input'];
};


/** All Mutations */
export type MutationSubmitSellerInfoArgs = {
  input: SubmitSellerInfoInput;
};


/** All Mutations */
export type MutationSubmitTestDriveAnswersArgs = {
  answers: Array<Scalars['Int']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitToGuaranteedPriceArgs = {
  data?: InputMaybe<GuaranteedPriceRequestInput>;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitToInstantPriceArgs = {
  inspectionId: Scalars['Int']['input'];
  termsAccepted: Scalars['Boolean']['input'];
};


/** All Mutations */
export type MutationSubmitUserSettingsArgs = {
  settings: UserSettingsInput;
};


/** All Mutations */
export type MutationSubmitVinArgs = {
  inspectionId: Scalars['Int']['input'];
  vin: Scalars['String']['input'];
  vinCheckDigit?: InputMaybe<Scalars['Int']['input']>;
};


/** All Mutations */
export type MutationSubmitVinEquipmentArgs = {
  equipmentNote: Scalars['String']['input'];
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationSubmitVinNoteArgs = {
  inspectionId: Scalars['Int']['input'];
  vinNote: Scalars['String']['input'];
};


/** All Mutations */
export type MutationSubmitWheelsArgs = {
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionId: Scalars['Int']['input'];
  isPrimarySet: Scalars['Boolean']['input'];
  wheels: Array<VehicleExteriorWheelDetailInput>;
};


/** All Mutations */
export type MutationUpdateBranchArgs = {
  branch: BranchInput;
  id: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpdateCarVatTypeArgs = {
  carVatType: VatType;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpdateExteriorQuestionsArgs = {
  data: ExteriorQuestions;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpdateRemarketingPurchaseDetailsArgs = {
  data: RemarketingPurchaseDetailsInput;
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpdateUnroadworthyArgs = {
  cannotBeRolled?: InputMaybe<Scalars['Boolean']['input']>;
  unroadworthy: Scalars['Boolean']['input'];
  vehicleId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpdateUserMerchantArgs = {
  merchant: MerchantInput;
};


/** All Mutations */
export type MutationUpdateWalkinCustomerArgs = {
  customer: WalkinCustomerInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Mutations */
export type MutationUpsertVehicleImageBulkArgs = {
  images: Array<VehicleImageInput>;
  inspectionId: Scalars['Int']['input'];
};

export type NewInspectionInput = {
  branchId: Scalars['Int']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerEmail: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  salutation: CustomerSalutation;
  sellerType: CustomerSellerType;
  zipCode: Scalars['String']['input'];
};

export type NotificationsUserSettings = {
  __typename?: 'NotificationsUserSettings';
  a1PriceIndicatorReceived: Scalars['Boolean']['output'];
  auctionEnded: Scalars['Boolean']['output'];
  counterOfferExpiring: Scalars['Boolean']['output'];
  counterOfferReceived: Scalars['Boolean']['output'];
  failedReview: Scalars['Boolean']['output'];
  finalOfferExpiring: Scalars['Boolean']['output'];
  instantOfferReceived: Scalars['Boolean']['output'];
  purchaseDocsPending: Scalars['Boolean']['output'];
};

export type NotificationsUserSettingsInput = {
  a1PriceIndicatorReceived?: InputMaybe<Scalars['Boolean']['input']>;
  auctionEnded?: InputMaybe<Scalars['Boolean']['input']>;
  counterOfferExpiring?: InputMaybe<Scalars['Boolean']['input']>;
  counterOfferReceived?: InputMaybe<Scalars['Boolean']['input']>;
  failedReview?: InputMaybe<Scalars['Boolean']['input']>;
  finalOfferExpiring?: InputMaybe<Scalars['Boolean']['input']>;
  instantOfferReceived?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseDocsPending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Offer = {
  __typename?: 'Offer';
  auction: Auction;
  auctionFee?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isWinner?: Maybe<Scalars['Int']['output']>;
  offer: Scalars['Int']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  type: Scalars['Int']['output'];
  user: MpUser;
};

export type OwnerType =
  | 'COMPANY'
  | 'DEALER'
  | 'PRIVATE'
  | 'UNKNOWN';

export type PageInformation = {
  __typename?: 'PageInformation';
  hasNext: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type PageInformationV2 = {
  __typename?: 'PageInformationV2';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type PainThicknessOption = {
  __typename?: 'PainThicknessOption';
  area: VehicleConditionPaintThicknessArea;
  canBeFabric: Scalars['Boolean']['output'];
  canBePlastic: Scalars['Boolean']['output'];
};

export type PatchOperation =
  | 'ADD'
  | 'REMOVE'
  | 'REPLACE';

export type PatchVehicleBooleanInput = {
  op: PatchOperation;
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PdfJobStatus =
  | 'FAILED'
  | 'FINISHED'
  | 'IN_PROGRESS'
  | 'PENDING';

export type PiAccidentInput = {
  isRepairCostsAvailable: Scalars['Boolean']['input'];
  repairCost?: InputMaybe<Scalars['Decimal']['input']>;
  repairStatus: AccidentAreaRepairStatus;
};

export type PiAdditionalDataInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate: Scalars['Date']['input'];
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  mileage: Scalars['Int']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  vatType: VatType;
};

export type PiAdditionalInformationInput = {
  countryOfOrigin: Country;
  exteriorColor: VehicleExteriorColor;
  interiorUpholstery: VehicleInteriorUpholstery;
  keyCount: Scalars['Int']['input'];
};

export type PiConditionInput = {
  exteriorCondition: VehicleConditionCondition;
  hasTuning: Scalars['Boolean']['input'];
  interiorCondition: VehicleConditionCondition;
  tuningNote?: InputMaybe<Scalars['String']['input']>;
  tuningNoteTags?: InputMaybe<Array<TuningNoteTag>>;
};

export type PiRequestInput = {
  /** Use submitToGuaranteedPrice mutation */
  guaranteedPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PiRequestV2p5Input = {
  /** Use submitToGuaranteedPrice mutation */
  guaranteedPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PiServiceInput = {
  inspectionExpiryDate: Scalars['Date']['input'];
  serviceBookAppointments: ServiceBookAppointmentsEnum;
};

export type PiTechnicalInspectionInput = {
  hasServiceBook: Scalars['Boolean']['input'];
  serviceBookType?: InputMaybe<VehicleServiceBookType>;
};

export type PiVehicleCondition = {
  __typename?: 'PiVehicleCondition';
  areBrakesOk?: Maybe<Scalars['Boolean']['output']>;
  isAirConditioningOk?: Maybe<Trinary>;
  isEngineOk?: Maybe<Scalars['Boolean']['output']>;
  isGearboxOk?: Maybe<Scalars['Boolean']['output']>;
  isSteeringOk?: Maybe<Scalars['Boolean']['output']>;
  isSuspensionOk?: Maybe<Scalars['Boolean']['output']>;
};

export type PiVehicleConditionInput = {
  areBrakesOk: Scalars['Boolean']['input'];
  hasWarningLights: Scalars['Boolean']['input'];
  isAirConditioningOk: Trinary;
  isEngineOk: Scalars['Boolean']['input'];
  isGearboxOk: Scalars['Boolean']['input'];
  isRoadworthy: Scalars['Boolean']['input'];
  isSteeringOk: Scalars['Boolean']['input'];
  isSuspensionOk: Scalars['Boolean']['input'];
};

export type PiVehicleExteriorWheelDetailInput = {
  area: VehicleExteriorWheelDetailArea;
  rimType?: InputMaybe<VehicleExteriorWheelRimType>;
  tireType?: InputMaybe<VehicleExteriorWheelType>;
};

export type PointOfInterest = {
  __typename?: 'PointOfInterest';
  type?: Maybe<PointOfInterestType>;
  x: Array<Scalars['Int']['output']>;
  y: Array<Scalars['Int']['output']>;
};

export type PointOfInterestInput = {
  type?: InputMaybe<PointOfInterestType>;
  x: Array<Scalars['Int']['input']>;
  y: Array<Scalars['Int']['input']>;
};

export type PointOfInterestType =
  | 'DAMAGE'
  | 'HIGHLIGHT';

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  localCurrency?: Maybe<Currency>;
  localCurrencyAmount?: Maybe<Scalars['Int']['output']>;
};

export type PriceIndicatorPrice = {
  __typename?: 'PriceIndicatorPrice';
  /** Deprecated. Use fixedPriceValue */
  fixedPrice?: Maybe<Scalars['Int']['output']>;
  fixedPriceValue?: Maybe<Price>;
  /** Deprecated. Use maxPriceValue */
  maxPrice?: Maybe<Scalars['Int']['output']>;
  maxPriceValue?: Maybe<Price>;
  /** Deprecated. Use minPriceValue */
  minPrice?: Maybe<Scalars['Int']['output']>;
  minPriceValue?: Maybe<Price>;
  /** Deprecated. Use originalPriceValue */
  originalPrice?: Maybe<Scalars['Int']['output']>;
  originalPriceValue?: Maybe<Price>;
};

export type PricingEquipmentMeta = {
  __typename?: 'PricingEquipmentMeta';
  cataloguePrice?: Maybe<EquipmentMoney>;
  description?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  featureRef?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupDetails?: Maybe<EquipmentGroupDetails>;
  id?: Maybe<Scalars['Int']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isRemovable?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<EquipmentMeta>>>;
  parentRef?: Maybe<Scalars['Int']['output']>;
  replacementForRef?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subGroup?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PubApiActionCheckResult = {
  relatedInspection?: Maybe<PubApiInspection>;
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type PubApiBeforeSubmitLicensePlateCheckResult = PubApiActionCheckResult & {
  __typename?: 'PubAPIBeforeSubmitLicensePlateCheckResult';
  relatedInspection?: Maybe<PubApiInspection>;
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type PubApiBeforeSubmitVinCheckResult = PubApiActionCheckResult & {
  __typename?: 'PubAPIBeforeSubmitVinCheckResult';
  relatedInspection?: Maybe<PubApiInspection>;
  retryAfter?: Maybe<Scalars['Int']['output']>;
  vinStatus: VinStatus;
};

export type PubApiCar = {
  __typename?: 'PubAPICar';
  carLeadId?: Maybe<Scalars['String']['output']>;
  guaranteedPriceOptions?: Maybe<GuaranteedPriceOptions>;
  isGuaranteedPriceAvailable: GuaranteedPriceAvailabilityStatus;
  stockNumber?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type PubApiInspection = {
  __typename?: 'PubAPIInspection';
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedOn?: Maybe<Scalars['DateTime']['output']>;
  branch: Branch;
  car: PubApiCar;
  customer: Customer;
  finishedTime?: Maybe<Scalars['DateTime']['output']>;
  flags?: Maybe<InspectionFlags>;
  hash: Scalars['String']['output'];
  inspectionId: Scalars['Int']['output'];
  lastChangedTime?: Maybe<Scalars['DateTime']['output']>;
  leadCreatedTime: Scalars['DateTime']['output'];
  meta?: Maybe<PubApiMetaChannels>;
  sourceType: InspectionSourceType;
  status: InspectionStatus;
  type: InspectionType;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type PubApiMeta = {
  __typename?: 'PubAPIMeta';
  guaranteedPrice?: Maybe<GuaranteedPrice>;
  priceIndicatorPrice?: Maybe<PriceIndicatorPrice>;
};

export type PubApiMetaChannels = {
  __typename?: 'PubAPIMetaChannels';
  accidents?: Maybe<Array<Accident>>;
  evaluation?: Maybe<MetaEvaluation>;
  highlights?: Maybe<Array<Highlight>>;
  publicAPI?: Maybe<PubApiMeta>;
  testDrive?: Maybe<TestDrive>;
};

export type PubApiAdditionalDataInput = {
  commercialType?: InputMaybe<VehicleConditionCommercialType>;
  countryOfCurrentRegistration?: InputMaybe<Country>;
  currentOwnerType?: InputMaybe<OwnerType>;
  /** Expected Price in Minor Units */
  expectedPrice?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  hasBeenCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  hasHadAccident?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryType?: InputMaybe<InventoryType>;
  isUnroadWorthy?: InputMaybe<Scalars['Boolean']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  otherNotes?: InputMaybe<Scalars['String']['input']>;
  submittedBy: Scalars['String']['input'];
  testDrivePerformed?: InputMaybe<Scalars['Boolean']['input']>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type PubApiPiAdditionalInformationInput = {
  countryOfOrigin?: InputMaybe<Country>;
  exteriorColor?: InputMaybe<VehicleExteriorColor>;
  interiorUpholstery?: InputMaybe<VehicleInteriorUpholstery>;
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  keyCount?: InputMaybe<Scalars['Int']['input']>;
};

export type PubApiPiTechnicalInspectionInput = {
  hasServiceBook?: InputMaybe<Scalars['Boolean']['input']>;
  serviceBookType?: InputMaybe<VehicleServiceBookType>;
};

export type PubApiPiVehicleConditionInput = {
  areBrakesOk?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarningLights?: InputMaybe<Scalars['Boolean']['input']>;
  isAirConditioningOk?: InputMaybe<Trinary>;
  isEngineOk?: InputMaybe<Scalars['Boolean']['input']>;
  isGearboxOk?: InputMaybe<Scalars['Boolean']['input']>;
  isRoadworthy?: InputMaybe<Scalars['Boolean']['input']>;
  isSteeringOk?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspensionOk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PubapiPiConditionInput = {
  exteriorCondition?: InputMaybe<VehicleConditionCondition>;
  hasTuning?: InputMaybe<Scalars['Boolean']['input']>;
  interiorCondition?: InputMaybe<VehicleConditionCondition>;
  tuningNote?: InputMaybe<Scalars['String']['input']>;
  tuningNoteTags?: InputMaybe<Array<TuningNoteTag>>;
};

export type PurchaseDoc = {
  fileName: Scalars['String']['input'];
  fileType: PurchaseDocType;
  fileUrl: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseDocType =
  | 'INVOICE'
  | 'SERVICE_DOCUMENT';

export type PurchaseDocsDataInput = {
  fileList: Array<PurchaseDoc>;
};

export type PurchaseInput = {
  offeredPrice: Scalars['Int']['input'];
};

/** All Queries */
export type Query = {
  __typename?: 'Query';
  appointments: AppointmentList;
  branch: Branch;
  /** Deprecated. use checkBeforeSubmitLicensePlateV2 */
  checkBeforeSubmitLicensePlate: ActionCheckResult;
  checkBeforeSubmitLicensePlateV2: ActionCheckResult;
  checkBeforeSubmitToAuction: ActionCheckResult;
  /** Deprecated. use checkBeforeSubmitVinV2 */
  checkBeforeSubmitVin: ActionCheckResult;
  checkBeforeSubmitVinV2: ActionCheckResult;
  damageOptions: Array<DamageArea>;
  flow: Flow;
  getActionOptions?: Maybe<ActionOptions>;
  getAuctionOptions?: Maybe<Array<AuctionOption>>;
  getAutoPrice: AutoPrice;
  getBodyTypes: Array<Maybe<CarDataItem>>;
  getBuiltDates: Array<Maybe<CarDataItem>>;
  getExpectedPriceOptions?: Maybe<ExpectedPriceOptions>;
  getFileUploadUrl: FileUploadUrl;
  getMainTypeDetails: Array<Maybe<CarDataItem>>;
  getMainTypeSubs: Array<Maybe<CarDataItem>>;
  getMainTypes: Array<Maybe<CarDataItem>>;
  getMandatoryEquipment?: Maybe<Array<EquipmentGroup>>;
  getMandatoryEquipmentByVehicle?: Maybe<Array<EquipmentGroup>>;
  getManufacturers: Array<Maybe<CarDataItem>>;
  getPurchaseDocUploadUrl: FileUploadUrl;
  getStartPrice?: Maybe<Price>;
  getSubTypes: Array<Maybe<CarDataItem>>;
  inspection?: Maybe<Inspection>;
  inspectionAggregates: InspectionAggregates;
  inspectionByCarLeadId?: Maybe<Inspection>;
  inspectionFromPdfStatus?: Maybe<InspectionFromPdfStatus>;
  inspections?: Maybe<InspectionPage>;
  inspectionsByStockNumberAllRevisions?: Maybe<Array<Inspection>>;
  inspectionsV2: InspectionCollection;
  merchantUser?: Maybe<MerchantUser>;
  msiGetCheckoutTypes: Array<Maybe<CheckoutType>>;
  myUser: AuthenticatedUser;
  resolveLicensePlate?: Maybe<Scalars['String']['output']>;
  search?: Maybe<Inspection>;
  /** @deprecated Use checkBeforeSubmitVin instead */
  searchDuplicateInspection?: Maybe<Inspection>;
  technicalInspectionCompanies: Array<Company>;
  testDriveQuestions?: Maybe<Array<QuestionItem>>;
  testDriveQuestionsByVehicle?: Maybe<Array<QuestionItem>>;
  user: User;
  userBranches: Array<Branch>;
  userBranchesPaginated: BranchList;
  userMerchant?: Maybe<Merchant>;
  vehicleObject?: Maybe<VehicleObject>;
  vehicleObjectByVin?: Maybe<VehicleObject>;
  vehicleObjects: Array<Maybe<VehicleObject>>;
  viewer?: Maybe<Viewer>;
};


/** All Queries */
export type QueryAppointmentsArgs = {
  branches?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** All Queries */
export type QueryBranchArgs = {
  id: Scalars['Int']['input'];
};


/** All Queries */
export type QueryCheckBeforeSubmitLicensePlateArgs = {
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
  licensePlate: Scalars['LicensePlateInput']['input'];
};


/** All Queries */
export type QueryCheckBeforeSubmitLicensePlateV2Args = {
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
  licensePlate: Scalars['LicensePlateInput']['input'];
};


/** All Queries */
export type QueryCheckBeforeSubmitToAuctionArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryCheckBeforeSubmitVinArgs = {
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
  vin: Scalars['VinInput']['input'];
};


/** All Queries */
export type QueryCheckBeforeSubmitVinV2Args = {
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
  vin: Scalars['VinInput']['input'];
};


/** All Queries */
export type QueryFlowArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetActionOptionsArgs = {
  data: ActionOptionsInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetAuctionOptionsArgs = {
  checkoutType?: InputMaybe<CheckoutTypeTypes>;
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetAutoPriceArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetBodyTypesArgs = {
  builtDate: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mainTypeId: Scalars['String']['input'];
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetBuiltDatesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  mainTypeId: Scalars['String']['input'];
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetExpectedPriceOptionsArgs = {
  auctionType: AuctionType;
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetFileUploadUrlArgs = {
  mimeType: MimeType;
  s3FileType: S3FileType;
};


/** All Queries */
export type QueryGetMainTypeDetailsArgs = {
  bodyTypeId: Scalars['String']['input'];
  builtDate: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mainTypeId: Scalars['String']['input'];
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetMainTypeSubsArgs = {
  bodyTypeId: Scalars['String']['input'];
  builtDate: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mainTypeDetailId: Scalars['String']['input'];
  mainTypeId: Scalars['String']['input'];
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetMainTypesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetMandatoryEquipmentArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetMandatoryEquipmentByVehicleArgs = {
  vehicleId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetManufacturersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** All Queries */
export type QueryGetPurchaseDocUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


/** All Queries */
export type QueryGetStartPriceArgs = {
  data: StartPriceInput;
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryGetSubTypesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  mainTypeId: Scalars['String']['input'];
  manufacturerId: Scalars['String']['input'];
};


/** All Queries */
export type QueryInspectionArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryInspectionByCarLeadIdArgs = {
  carLeadId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryInspectionFromPdfStatusArgs = {
  pdfUrl: Scalars['URL']['input'];
};


/** All Queries */
export type QueryInspectionsArgs = {
  branch: Array<InputMaybe<Scalars['Int']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status: Array<InputMaybe<InspectionStatus>>;
};


/** All Queries */
export type QueryInspectionsByStockNumberAllRevisionsArgs = {
  stockNumber: Scalars['String']['input'];
};


/** All Queries */
export type QueryInspectionsV2Args = {
  query: InspectionsQuery;
};


/** All Queries */
export type QueryMsiGetCheckoutTypesArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryResolveLicensePlateArgs = {
  data: ResolveLicensePlateInput;
};


/** All Queries */
export type QuerySearchArgs = {
  stockNumberOrVin: Scalars['String']['input'];
};


/** All Queries */
export type QuerySearchDuplicateInspectionArgs = {
  branch: Scalars['Int']['input'];
  evaluationType: EvaluationType;
  vin: Scalars['String']['input'];
};


/** All Queries */
export type QueryTechnicalInspectionCompaniesArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryTestDriveQuestionsArgs = {
  inspectionId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryTestDriveQuestionsByVehicleArgs = {
  vehicleId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryUserBranchesPaginatedArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** All Queries */
export type QueryVehicleObjectArgs = {
  vehicleId: Scalars['Int']['input'];
};


/** All Queries */
export type QueryVehicleObjectByVinArgs = {
  vin: Scalars['String']['input'];
};


/** All Queries */
export type QueryVehicleObjectsArgs = {
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QuestionItem = {
  __typename?: 'QuestionItem';
  allowedOptions: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  options?: Maybe<Array<QuestionItem>>;
  translationKey: Scalars['String']['output'];
};

export type RejectGuaranteedPriceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reasonId: Scalars['Int']['input'];
};

export type RejectReason = {
  __typename?: 'RejectReason';
  commentRequired: Scalars['Boolean']['output'];
  reasonId: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type RemarketingPurchaseDetailsInput = {
  countryOfRegistration?: InputMaybe<Country>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
};

export type ResolveLicensePlateInput = {
  branch: Scalars['Int']['input'];
  licensePlate: Scalars['LicensePlateInput']['input'];
};

export type S3FileType =
  | 'EVA_TEMP';

export type S3RequestDataForPost = {
  __typename?: 'S3RequestDataForPost';
  formData: Array<KeyValueStringPair>;
  url: Scalars['String']['output'];
};

export type SaleConfidenceLevel = {
  __typename?: 'SaleConfidenceLevel';
  endPrice: Price;
  key: SaleConfidenceLevelKey;
  startPrice: Price;
};

export type SaleConfidenceLevelKey =
  | 'HIGH'
  | 'LOW'
  | 'MODERATE';

export type SelfInspectionInput = {
  accidentRepairCost?: InputMaybe<Scalars['Int']['input']>;
  additionalDamagesRepairCost?: InputMaybe<Scalars['Int']['input']>;
  companyVatType?: InputMaybe<CompanyVatType>;
  conditionDamages?: InputMaybe<Array<ConditionDamageEnum>>;
  damages?: InputMaybe<Array<DamageInput>>;
  exteriorColor: VehicleExteriorColor;
  exteriorCondition: VehicleConditionCondition;
  exteriorQuestions?: InputMaybe<ExteriorQuestions>;
  extraWheelsCompleteness?: InputMaybe<ExtraWheelsCompleteness>;
  firstRegistrationDate: Scalars['Date']['input'];
  hasAdditionalMechanicalDamages?: InputMaybe<Scalars['Boolean']['input']>;
  hasExtraWheelSet: Scalars['Boolean']['input'];
  hasHadAccident: Scalars['Boolean']['input'];
  hasTuning?: InputMaybe<Scalars['Boolean']['input']>;
  importRegion?: InputMaybe<ImportRegion>;
  interiorColor?: InputMaybe<VehicleInteriorColor>;
  interiorCondition: VehicleConditionCondition;
  interiorQuestions?: InputMaybe<InteriorQuestions>;
  interiorUpholstery: VehicleInteriorUpholstery;
  isCarImported?: InputMaybe<Trinary>;
  isDamagedAndUnrepaired: Scalars['Boolean']['input'];
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  isLeased?: InputMaybe<Scalars['Boolean']['input']>;
  isNonSmokerVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  isUnroadworthy?: InputMaybe<Scalars['Boolean']['input']>;
  keyCount: Scalars['Int']['input'];
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  outstandingFinancingDueAmountInMinorUnits?: InputMaybe<Scalars['Int']['input']>;
  replacementLetterDate?: InputMaybe<Scalars['Date']['input']>;
  rimType?: InputMaybe<VehicleExteriorWheelRimType>;
  sellerType?: InputMaybe<CustomerSellerType>;
  serviceBookAppointments?: InputMaybe<ServiceBookAppointmentsEnum>;
  serviceBookAppointmentsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  steeringWheelPosition?: InputMaybe<SteeringWheelPosition>;
  technicalInspection?: InputMaybe<TechnicalInspectionEnum>;
  technicalInspectionCertificateExpiryAtDate?: InputMaybe<Scalars['Date']['input']>;
  testDriveAnswers?: InputMaybe<Array<Scalars['Int']['input']>>;
  tireType?: InputMaybe<VehicleExteriorWheelType>;
  tiresGoodForOneSeason?: InputMaybe<Trinary>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  totalOwnersNumberAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  tuningNote?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type SellerInfo = {
  __typename?: 'SellerInfo';
  address?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationCountryCode?: Maybe<Country>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ServiceBookAppointmentsEnum =
  | 'ALL'
  | 'NONE'
  | 'NOT_DUE_YET'
  | 'SOME';

export type StartAppointmentInput = {
  appointmentStartTime: Scalars['String']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  stockNumber: Scalars['String']['input'];
};

export type StartPriceInput = {
  /** Not in use, value will be ignore. */
  currency?: InputMaybe<Currency>;
  expectedPrice: Scalars['Int']['input'];
};

export type StatusCount = {
  __typename?: 'StatusCount';
  count: Scalars['Int']['output'];
  status: InspectionStatus;
};

export type SteeringWheelPosition =
  | 'CENTER'
  | 'LEFT'
  | 'RIGHT';

export type SubmitSellerInfoInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  inspectionId: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  salutation: CustomerSalutation;
  sellerType: CustomerSellerType;
  zipCode: Scalars['String']['input'];
};

export type SubmitToAuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type SubmitToBatchAuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type SubmitToDirectAuctionInput = {
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Expected Price in Minor Units */
  expectedPrice: Scalars['Int']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Start Price in Minor Units */
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
};

export type SuggestedPrice = {
  __typename?: 'SuggestedPrice';
  notFoundReason?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
};

export type TechnicalInspectionEnum =
  | 'NO'
  | 'NOT_VALID_ANYMORE'
  | 'YES';

export type TestDrive = {
  __typename?: 'TestDrive';
  answers?: Maybe<Array<Scalars['Int']['output']>>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishImage?: Maybe<TestDriveImage>;
  id: Scalars['Int']['output'];
  inspectionId: Scalars['Int']['output'];
  startImage?: Maybe<TestDriveImage>;
};

export type TestDriveImage = {
  __typename?: 'TestDriveImage';
  absoluteUrl: Scalars['String']['output'];
};

export type TransportStatus =
  | 'EVALUATION_COMPLETED'
  | 'TRANSPORT_REQUESTED'
  | 'UNDEFINED';

export type Trinary =
  | 'NO'
  | 'UNKNOWN'
  | 'YES';

export type TuningNoteTag =
  | 'BODY_CONVERSIONS'
  | 'ENGINE_CHANGES'
  | 'VEHICLE_FOILING';

export type User = {
  __typename?: 'User';
  actions: UserActions;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inspectionTypes: Array<UserInspectionType>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  userType: UserType;
};


export type UserInspectionTypesArgs = {
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserActions = {
  __typename?: 'UserActions';
  /** @deprecated Action not used anymore */
  canArchiveInspection: Scalars['Boolean']['output'];
  canCreatePdfInspection: Scalars['Boolean']['output'];
  canSeeGuaranteedPriceFilters: Scalars['Boolean']['output'];
};

export type UserInspectionType = {
  __typename?: 'UserInspectionType';
  enabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserInspectionTypeName>;
};

export type UserInspectionTypeName =
  | 'FAST_PRICE'
  | 'FULL'
  | 'PRICE_INDICATOR'
  | 'WALKIN';

export type UserSettings = {
  __typename?: 'UserSettings';
  locale?: Maybe<Scalars['String']['output']>;
  notifications: NotificationsUserSettings;
};

export type UserSettingsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  notifications: NotificationsUserSettingsInput;
};

export type UserType =
  | 'ADMIN'
  | 'MERCHANT';

export type VatType =
  | 'DEDUCTIBLE'
  | 'NOT_DEDUCTIBLE';

export type Vehicle = {
  __typename?: 'Vehicle';
  accidents?: Maybe<Array<VehicleAccident>>;
  class?: Maybe<VehicleClassEnum>;
  condition?: Maybe<VehicleCondition>;
  damages?: Maybe<Array<VehicleDamage>>;
  dimensions?: Maybe<VehicleDimensions>;
  engine?: Maybe<VehicleEngine>;
  exterior?: Maybe<VehicleExterior>;
  featureDetails?: Maybe<Array<VehicleFeatureDetail>>;
  features?: Maybe<VehicleFeatures>;
  files?: Maybe<Array<VehicleFile>>;
  identifiers?: Maybe<VehicleIdentifiers>;
  images?: Maybe<Array<VehicleImage>>;
  interior?: Maybe<VehicleInterior>;
  model?: Maybe<VehicleModel>;
};


export type VehicleImagesArgs = {
  imagePart?: InputMaybe<VehicleImagePart>;
};

export type VehicleAccident = {
  __typename?: 'VehicleAccident';
  areas?: Maybe<Array<VehicleAccidentArea>>;
  files?: Maybe<Array<VehicleFile>>;
  isDeclaredAsTotalLoss?: Maybe<Scalars['Boolean']['output']>;
  isRepairCostAvailable?: Maybe<Scalars['Boolean']['output']>;
  repairCost?: Maybe<VehicleConditionMoney>;
  repairStatus?: Maybe<AccidentAreaRepairStatus>;
  repairedBy?: Maybe<AccidentAreaRepairedBy>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type VehicleAccidentArea = {
  __typename?: 'VehicleAccidentArea';
  area: AccidentArea;
  reasons?: Maybe<Array<VehicleAccidentReason>>;
};

export type VehicleAccidentAreaInput = {
  area: AccidentArea;
  reasons?: InputMaybe<Array<VehicleAccidentReasonInput>>;
};

export type VehicleAccidentInput = {
  area?: InputMaybe<AccidentArea>;
  hash?: InputMaybe<Scalars['String']['input']>;
  invoiceImages: Array<VehicleImageInput>;
  isBadlyRepaired?: InputMaybe<Scalars['Boolean']['input']>;
  isRepairCostsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalLoss?: InputMaybe<Scalars['Boolean']['input']>;
  repairCost?: InputMaybe<Scalars['Decimal']['input']>;
  repairStatus: AccidentAreaRepairStatus;
  repairedBy?: InputMaybe<AccidentAreaRepairedBy>;
};

export type VehicleAccidentReason = {
  __typename?: 'VehicleAccidentReason';
  images?: Maybe<Array<VehicleImage>>;
  reason?: Maybe<AccidentReason>;
};

export type VehicleAccidentReasonInput = {
  images?: InputMaybe<Array<VehicleImageInput>>;
  reason?: InputMaybe<AccidentReason>;
};

export type VehicleBasicDimension = {
  __typename?: 'VehicleBasicDimension';
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<VehicleDimensionsSize>;
  volume?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VehicleBatteryHealth =
  | 'HEALTH_0_25'
  | 'HEALTH_25_50'
  | 'HEALTH_50_75'
  | 'HEALTH_75_100';

export type VehicleClassEnum =
  | 'bus'
  | 'car'
  | 'caravan'
  | 'motorcycle'
  | 'truck';

export type VehicleCondition = {
  __typename?: 'VehicleCondition';
  brakes?: Maybe<Array<Maybe<VehicleConditionBrake>>>;
  cannotBeRolled?: Maybe<Scalars['Boolean']['output']>;
  commercialTypes?: Maybe<Array<VehicleConditionCommercialType>>;
  countryOfCurrentRegistration?: Maybe<Country>;
  countryOfOrigin?: Maybe<Country>;
  damageValue?: Maybe<VehicleConditionMoney>;
  deregistrationDate?: Maybe<Scalars['Date']['output']>;
  exteriorCondition?: Maybe<VehicleConditionCondition>;
  firstRegistrationDate?: Maybe<Scalars['Date']['output']>;
  hasBeenCommercial?: Maybe<Scalars['Boolean']['output']>;
  hasHadAccident?: Maybe<Scalars['Boolean']['output']>;
  hasServiceBook?: Maybe<Scalars['Boolean']['output']>;
  hasTechnicalInspectionCertificate?: Maybe<Scalars['Boolean']['output']>;
  interiorCondition?: Maybe<VehicleConditionCondition>;
  isDamagedAndUnrepaired?: Maybe<Scalars['Boolean']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isNewVehicle?: Maybe<Scalars['Boolean']['output']>;
  isNonSmokerVehicle?: Maybe<Scalars['Boolean']['output']>;
  isPreviousOwnerForeign?: Maybe<Scalars['Boolean']['output']>;
  isPreviousOwnerFromDocument?: Maybe<Scalars['Boolean']['output']>;
  isSalvaged?: Maybe<Scalars['Boolean']['output']>;
  isUnroadworthy?: Maybe<Scalars['Boolean']['output']>;
  keyCount?: Maybe<Scalars['Int']['output']>;
  lastDriveBeltChangeDate?: Maybe<Scalars['Date']['output']>;
  lastDriveBeltChangeMileage?: Maybe<Scalars['Int']['output']>;
  lastRegistrationDate?: Maybe<Scalars['Date']['output']>;
  lastServiceAtDate?: Maybe<Scalars['Date']['output']>;
  lastServiceAtMileage?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  paintThicknesses?: Maybe<Array<Maybe<VehicleConditionPaintThickness>>>;
  /** @deprecated Replaced by totalOwnerCount */
  previousOwnerCount?: Maybe<Scalars['Int']['output']>;
  salvageType?: Maybe<VehicleConditionSalvageType>;
  serviceBookCompletionStatus?: Maybe<VehicleConditionServiceBookCompletionStatus>;
  serviceBookDetails?: Maybe<Array<VehicleConditionEvent>>;
  serviceBookType?: Maybe<VehicleServiceBookType>;
  technicalCondition?: Maybe<VehicleConditionCondition>;
  technicalInspectionCertificateExpiryAtDate?: Maybe<Scalars['Date']['output']>;
  technicalInspectionCertificateIssueDate?: Maybe<Scalars['Date']['output']>;
  technicalInspectionCertificateIssueMileage?: Maybe<Scalars['Int']['output']>;
  totalOwnerCount?: Maybe<Scalars['Int']['output']>;
  usedCarSeal?: Maybe<VehicleConditionUsedCarSeal>;
};

export type VehicleConditionBrake = {
  __typename?: 'VehicleConditionBrake';
  area?: Maybe<VehicleConditionBrakeLocation>;
  condition?: Maybe<VehicleConditionBrakeCondition>;
  type?: Maybe<VehicleConditionBrakeType>;
};

export type VehicleConditionBrakeCondition =
  | 'AS_GOOD_AS_NEW'
  | 'BAD_SUPPORTING_BRAKE'
  | 'BURR'
  | 'CARBON_CERAMIC_BRAKES'
  | 'DRUM_BRAKE'
  | 'LESS_THAN_50'
  | 'MORE_THAN_50'
  | 'WEAR_LIMIT';

export type VehicleConditionBrakeInput = {
  area: VehicleConditionBrakeLocation;
  condition?: InputMaybe<VehicleConditionBrakeCondition>;
};

export type VehicleConditionBrakeLocation =
  | 'FRONT_LEFT'
  | 'FRONT_RIGHT'
  | 'MIDDLE_LEFT'
  | 'MIDDLE_RIGHT'
  | 'REAR_LEFT'
  | 'REAR_RIGHT';

export type VehicleConditionBrakeType =
  | 'CARBON_CERAMIC_BRAKE'
  | 'DISC_BRAKE'
  | 'DRUM_BRAKE';

export type VehicleConditionCommercialType =
  | 'AUTHORITIES'
  | 'CAR_SHARING'
  | 'COMPANY_CAR'
  | 'DEMONSTRATION'
  | 'DRIVING_SCHOOL'
  | 'RENTAL'
  | 'TAXI';

export type VehicleConditionCondition =
  | 'AVERAGE'
  | 'BAD'
  | 'GOOD';

export type VehicleConditionDamageExternal =
  | 'BUMP'
  | 'DENT'
  | 'FADED_PAINT'
  | 'HAIL_DAMAGE'
  | 'RUST'
  | 'SCRATCH'
  | 'STONE_CHIPS';

export type VehicleConditionDamageInternal =
  | 'WEAR_AND_TEAR_OF_SEATS_AND_INTERIOR';

export type VehicleConditionEvent = {
  __typename?: 'VehicleConditionEvent';
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueAtDate?: Maybe<Scalars['Date']['output']>;
  dueAtMileage?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<VehicleConditionEventBookGroup>;
  occurredAtDate?: Maybe<Scalars['Date']['output']>;
  occurredAtMileage?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  subGroup?: Maybe<VehicleConditionEventSubGroup>;
};

export type VehicleConditionEventBookGroup =
  | 'ACCIDENT'
  | 'INSPECTION'
  | 'SERVICE';

export type VehicleConditionEventSubGroup =
  | 'DRIVE_BELT_CHANGE'
  | 'ENGINE_REPLACEMENT';

export type VehicleConditionMoney = {
  __typename?: 'VehicleConditionMoney';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<VehicleConditionMoneyCurrency>;
  decimalAmount?: Maybe<Scalars['Decimal']['output']>;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  minors?: Maybe<Scalars['Int']['output']>;
};

export type VehicleConditionMoneyCurrency =
  | 'CHF'
  | 'DKK'
  | 'EUR'
  | 'SEK';

export type VehicleConditionPaintThickness = {
  __typename?: 'VehicleConditionPaintThickness';
  area?: Maybe<VehicleConditionPaintThicknessArea>;
  isNotMeasurable?: Maybe<Scalars['Boolean']['output']>;
  /** paint thickness in micrometers */
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type VehicleConditionPaintThicknessArea =
  | 'DRIVER_DOOR'
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_DOOR'
  | 'FRONT_LEFT_FENDER'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_DOOR'
  | 'FRONT_RIGHT_FENDER'
  | 'HOOD'
  | 'LEFT'
  | 'LEFT_SKIRT'
  | 'PASSENGER_DOOR'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_DOOR'
  | 'REAR_LEFT_FENDER'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_DOOR'
  | 'REAR_RIGHT_FENDER'
  | 'RIGHT'
  | 'RIGHT_SKIRT'
  | 'ROOF'
  | 'TAILGATE'
  | 'TRUNK';

export type VehicleConditionSalvageType =
  | 'FIRE'
  | 'FLOOD'
  | 'HAIL'
  | 'JUNK'
  | 'LEMON'
  | 'REBUILT'
  | 'VANDALISM';

export type VehicleConditionServiceBookCompletionStatus =
  | 'FILLED'
  | 'NOT_FILLED'
  | 'PARTIALLY_FILLED'
  | 'UNKNOWN';

export type VehicleConditionUsedCarSeal =
  | 'ASTON_MARTIN'
  | 'AUDI'
  | 'BENTLEY'
  | 'BMW'
  | 'CITROEN'
  | 'DS_CERTIFIED'
  | 'DS_ZERTIFIZIERTE_GEBRAUCHTWAGEN'
  | 'FCA'
  | 'FERRARI'
  | 'JAGUAR'
  | 'LANDROVER'
  | 'MASERATI'
  | 'MERCEDES_TRANSPORTER'
  | 'MINI'
  | 'NISSAN'
  | 'OPEL'
  | 'PEUGEOT'
  | 'PORSCHE'
  | 'RENAULT'
  | 'SEAT'
  | 'SKODA'
  | 'VOLVO'
  | 'VW'
  | 'VW_TRADEPORT';

export type VehicleDamage = {
  __typename?: 'VehicleDamage';
  area?: Maybe<VehicleDamageArea>;
  /** Translation Key for area value */
  areaTranslationKey?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<VehicleImage>>;
  isAccidentReason?: Maybe<Scalars['Boolean']['output']>;
  part?: Maybe<VehicleDamagePart>;
  partTranslationKey?: Maybe<Scalars['String']['output']>;
  repairMethod?: Maybe<VehicleDamageRepairMethod>;
  severity?: Maybe<VehicleDamageSeverity>;
  severityDetail?: Maybe<VehicleDamageSeverityDetail>;
  type?: Maybe<VehicleDamageType>;
  typeTranslationKey?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type VehicleDamageArea =
  | 'BRAKES'
  | 'CONTROLS'
  | 'ENGINE'
  | 'FRONT'
  | 'GENERAL'
  | 'INTERIOR'
  | 'LEFT'
  | 'REAR'
  | 'RIGHT'
  | 'ROOF'
  | 'TRUNK'
  | 'UNDERBODY'
  | 'WHEELS';

export type VehicleDamageDepthType =
  | 'SOME_DAMAGE_DEPTH_TYPE';

export type VehicleDamagePart =
  | 'ABS_WARNING_LIGHT'
  | 'AIRBAG_WARNING_LIGHT'
  | 'AIR_CONDITIONING'
  | 'ALARM_SYSTEM'
  | 'ALTERNATOR'
  | 'ANTENNA'
  | 'AUXILIARY_HEATING'
  | 'BALL_OF_THE_TOW_HOOK'
  | 'BATTERY'
  | 'BATTERY_WARNING_LIGHT'
  | 'BRAKE_FLUID_LEVEL'
  | 'BRAKE_PAD_WARNING_LIGHT'
  | 'BRAKE_WARNING_LIGHT'
  | 'CATALYTIC_CONVERTER'
  | 'CENTER_CONSOLE'
  | 'CENTRAL_LOCKING_SYSTEM'
  | 'CLUTCH_COUPLING'
  | 'CLUTCH_PEDAL'
  | 'CONVERTIBLE_TOP'
  | 'CONVERTIBLE_TOP_WINDOW'
  | 'COOLANT_LEVEL'
  | 'COOLANT_TEMPERATURE_WARNING_LIGHT'
  | 'COOLING_FAN'
  | 'COOLING_SYSTEM'
  | 'CRUISE_CONTROL'
  | 'DASHBOARD'
  | 'DIFFUSER'
  | 'DRIVER_SAFETY_BELT'
  | 'DRIVER_SEAT'
  | 'ELECTRICAL_MIRRORS'
  | 'ENGINE'
  | 'ENGINE_OIL_LEVEL'
  | 'ENGINE_WARNING_LIGHT'
  | 'ESP_WARNING_LIGHT'
  | 'EXHAUST_MANIFOLD'
  | 'EXHAUST_PIPE'
  | 'FLOOR_COVERING'
  | 'FRONT_BRAKE_LINES'
  | 'FRONT_BUMPER'
  | 'FRONT_CENTER_SAFETY_BELT'
  | 'FRONT_EXHAUST_SILENCER'
  | 'FRONT_LEFT_BLINKER'
  | 'FRONT_LEFT_BRAKE'
  | 'FRONT_LEFT_DOOR'
  | 'FRONT_LEFT_DOOR_DISC'
  | 'FRONT_LEFT_DOOR_HANDLE'
  | 'FRONT_LEFT_DOOR_TRIM'
  | 'FRONT_LEFT_DRIVE_SHAFT'
  | 'FRONT_LEFT_FENDER'
  | 'FRONT_LEFT_FOG_LIGHT'
  | 'FRONT_LEFT_RIM'
  | 'FRONT_LEFT_TIRE'
  | 'FRONT_LEFT_WHEEL_BEARING'
  | 'FRONT_PARK_DISTANCE_CONTROL_SENSOR'
  | 'FRONT_RIGHT_BLINKER'
  | 'FRONT_RIGHT_BRAKE'
  | 'FRONT_RIGHT_DOOR'
  | 'FRONT_RIGHT_DOOR_DISC'
  | 'FRONT_RIGHT_DOOR_HANDLE'
  | 'FRONT_RIGHT_DOOR_TRIM'
  | 'FRONT_RIGHT_DRIVE_SHAFT'
  | 'FRONT_RIGHT_FENDER'
  | 'FRONT_RIGHT_FOG_LIGHT'
  | 'FRONT_RIGHT_RIM'
  | 'FRONT_RIGHT_TIRE'
  | 'FRONT_RIGHT_WHEEL_BEARING'
  | 'FRONT_SHOCK_ABSORBER'
  | 'FRONT_SPOILER'
  | 'FRONT_WINDOW_FRAME'
  | 'FUEL_TANK'
  | 'GENERAL'
  | 'HAND_BRAKE'
  | 'HARDTOP'
  | 'HATRACK'
  | 'HAZARD_WARNING_LIGHTS_CONTROL'
  | 'HEADLINING'
  | 'HEATED_SEATS'
  | 'HOOD'
  | 'HORN'
  | 'INSTRUMENT_CLUSTER'
  | 'INTERIOR_LIGHTING'
  | 'KEY'
  | 'LAMBDA_PROBE'
  | 'LEFT_A_PILLAR'
  | 'LEFT_B_PILLAR'
  | 'LEFT_C_PILLAR'
  | 'LEFT_D_PILLAR'
  | 'LEFT_FILLER_CAP'
  | 'LEFT_HEADLIGHT'
  | 'LEFT_MIRROR_GLASS'
  | 'LEFT_MIRROR_HOUSING'
  | 'LEFT_SIDE_BLINKER'
  | 'LEFT_SIDE_COVER_TRUNK'
  | 'LEFT_SIDE_SKIRTS'
  | 'LEFT_UNDERBODY'
  | 'LEFT_WIPER'
  | 'LOW_TIRE_PRESSURE_WARNING_LIGHT'
  | 'NAVIGATION_SYSTEM'
  | 'OIL_PRESSURE_WARNING_LIGHT'
  | 'OTHER_SEATS'
  | 'PANORAMIC_ROOF'
  | 'PARK_DISTANCE_CONTROL'
  | 'PARTICLE_FILTER_WARNING_LIGHT'
  | 'PASSENGER_SAFETY_BELT'
  | 'PASSENGER_SEAT'
  | 'POWER_STEERING_PUMP'
  | 'PREHEATER_WARNING_LIGHT'
  | 'PROPELLER_SHAFT'
  | 'RADIATOR'
  | 'RADIO'
  | 'REAR_BRAKE_LINES'
  | 'REAR_BUMPER'
  | 'REAR_CENTER_SAFETY_BELT'
  | 'REAR_EXHAUST_SILENCER'
  | 'REAR_LEFT_BRAKE'
  | 'REAR_LEFT_DOOR'
  | 'REAR_LEFT_DOOR_DISC'
  | 'REAR_LEFT_DOOR_HANDLE'
  | 'REAR_LEFT_DOOR_INNER_PANEL'
  | 'REAR_LEFT_DRIVE_SHAFT'
  | 'REAR_LEFT_FENDER'
  | 'REAR_LEFT_FOG_LIGHT'
  | 'REAR_LEFT_LIGHT'
  | 'REAR_LEFT_RIM'
  | 'REAR_LEFT_SAFETY_BELT'
  | 'REAR_LEFT_SEAT'
  | 'REAR_LEFT_SIDE_WINDOW'
  | 'REAR_LEFT_TIRE'
  | 'REAR_LEFT_WHEEL_BEARING'
  | 'REAR_PANEL'
  | 'REAR_PARK_DISTANCE_CONTROL_SENSOR'
  | 'REAR_RIGHT_BRAKE'
  | 'REAR_RIGHT_DOOR'
  | 'REAR_RIGHT_DOOR_DISC'
  | 'REAR_RIGHT_DOOR_HANDLE'
  | 'REAR_RIGHT_DOOR_INNER_PANEL'
  | 'REAR_RIGHT_DRIVE_SHAFT'
  | 'REAR_RIGHT_FENDER'
  | 'REAR_RIGHT_FOG_LIGHT'
  | 'REAR_RIGHT_LIGHT'
  | 'REAR_RIGHT_RIM'
  | 'REAR_RIGHT_SAFETY_BELT'
  | 'REAR_RIGHT_SEAT'
  | 'REAR_RIGHT_SIDE_WINDOW'
  | 'REAR_RIGHT_TIRE'
  | 'REAR_RIGHT_WHEEL_BEARING'
  | 'REAR_SHOCK_ABSORBER'
  | 'REAR_SPOILER'
  | 'REAR_WINDOW'
  | 'REAR_WINDOW_DEFROSTER'
  | 'REAR_WINDOW_FRAME'
  | 'RIGHT_A_PILLAR'
  | 'RIGHT_B_PILLAR'
  | 'RIGHT_C_PILLAR'
  | 'RIGHT_D_PILLAR'
  | 'RIGHT_FILLER_CAP'
  | 'RIGHT_HEADLIGHT'
  | 'RIGHT_MIRROR_GLASS'
  | 'RIGHT_MIRROR_HOUSING'
  | 'RIGHT_SIDE_BLINKER'
  | 'RIGHT_SIDE_COVER'
  | 'RIGHT_SIDE_SKIRTS'
  | 'RIGHT_UNDERBODY'
  | 'RIGHT_WIPER'
  | 'ROOF'
  | 'ROOF_CROSS_BARS'
  | 'ROOF_RAILS'
  | 'SPARE_KEY'
  | 'SPARE_WHEEL'
  | 'STEERING_AND_TRACK_RODS'
  | 'STEERING_PUMP_OIL_LEVEL'
  | 'STEERING_WHEEL'
  | 'STEERING_WHEEL_LOCK'
  | 'SUNROOF'
  | 'TAILGATE'
  | 'TIRE_EMERGENCY_KIT'
  | 'TRACTION_CONTROL_SYSTEM_WARNING_LIGHT'
  | 'TRANSMISSION'
  | 'TRUNK_COMPARTMENT_COVER'
  | 'TRUNK_FLOOR_COVERING'
  | 'TURBO_CHARGER'
  | 'WATER_PUMP'
  | 'WINDOWS'
  | 'WINDSCREEN'
  | 'WINDSCREEN_HEATER'
  | 'WIPER_AND_WASHER_CONTROL';

export type VehicleDamageRepairMethod =
  | 'CANNOT_BE_REPARIED'
  | 'CAN_BE_REPAIRED'
  | 'PAINT_NEEDED'
  | 'POLISHABLE'
  | 'SMART_REPAIR';

export type VehicleDamageSeverity =
  | 'SEVERITY_0MM_20MM'
  | 'SEVERITY_5CM_10CM'
  | 'SEVERITY_5MM_16MM'
  | 'SEVERITY_20MM_50MM'
  | 'SEVERITY_125MICRON_250MICRON'
  | 'SEVERITY_250MICRON_350MICRON'
  | 'SEVERITY_DEEP'
  | 'SEVERITY_FLASH_RUST'
  | 'SEVERITY_FULLY_MISSING'
  | 'SEVERITY_GRINDING_PARTS'
  | 'SEVERITY_INSIGNIFICANTLY_FADED_AREAS'
  | 'SEVERITY_IN_DRIVERS_EYELINE'
  | 'SEVERITY_LEGAL'
  | 'SEVERITY_LESS_THAN_1CM'
  | 'SEVERITY_LESS_THAN_3MM'
  | 'SEVERITY_LESS_THAN_5'
  | 'SEVERITY_LESS_THAN_5CM'
  | 'SEVERITY_LESS_THAN_5MM'
  | 'SEVERITY_LESS_THAN_10'
  | 'SEVERITY_LESS_THAN_16MM'
  | 'SEVERITY_LESS_THAN_20MM'
  | 'SEVERITY_LESS_THAN_22MM'
  | 'SEVERITY_LESS_THAN_25MM'
  | 'SEVERITY_LIGHT'
  | 'SEVERITY_MINIMAL_NOT_FITTING_PARTS'
  | 'SEVERITY_MINOR'
  | 'SEVERITY_MISSING_SPECIFIC_ITEM'
  | 'SEVERITY_MORE_THAN_1CM'
  | 'SEVERITY_MORE_THAN_3MM'
  | 'SEVERITY_MORE_THAN_5'
  | 'SEVERITY_MORE_THAN_10CM'
  | 'SEVERITY_MORE_THAN_16MM'
  | 'SEVERITY_MORE_THAN_20MM'
  | 'SEVERITY_MORE_THAN_25MM'
  | 'SEVERITY_MORE_THAN_50MM'
  | 'SEVERITY_MORE_THAN_250MICRON'
  | 'SEVERITY_MORE_THAN_350MICRON'
  | 'SEVERITY_MORE_THAN_THAN_10'
  | 'SEVERITY_NON_PROFESSIONAL_REPAINT'
  | 'SEVERITY_NOT_IN_DRIVERS_EYELINE'
  | 'SEVERITY_NOT_LEGAL_OR_NOT_LICENSED'
  | 'SEVERITY_PROFESSIONAL_REPAINT'
  | 'SEVERITY_REPAIRED_SPOTTED'
  | 'SEVERITY_RUSTED'
  | 'SEVERITY_SEVERE'
  | 'SEVERITY_STONE_CHIPS_WITH_FISSURE'
  | 'SEVERITY_STRONGLY_FADED_AREAS'
  | 'SEVERITY_SURFACE';

export type VehicleDamageSeverityDetail = {
  __typename?: 'VehicleDamageSeverityDetail';
  depth?: Maybe<VehicleDamageDepthType>;
  length?: Maybe<Scalars['Int']['output']>;
  paintThickness?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDamageType =
  | 'ACCESSORIES_DAMAGED'
  | 'ACCESSORIES_MISSING_PARTS'
  | 'AIR_CONDITIONING_COMPRESSOR_NOT_STARTING'
  | 'AIR_CONDITIONING_COOLING_CAPACITY_TOO_LOW'
  | 'AIR_CONDITIONING_NOT_COOLING'
  | 'ALARM_SYSTEM_NOT_FUNCTIONING'
  | 'ATTACHMENTS_DENT'
  | 'ATTACHMENTS_FRACTURE'
  | 'ATTACHMENTS_MISSING_PART'
  | 'ATTACHMENTS_NON_ORIGINAL_EQUIPMENT'
  | 'ATTACHMENTS_REPAINT'
  | 'ATTACHMENTS_RUST'
  | 'ATTACHMENTS_SCRATCH'
  | 'ATTACHMENTS_STONE_CHIP'
  | 'AUXILLIARY_EQUIPMENT_DAMAGED'
  | 'AUXILLIARY_EQUIPMENT_LEAKY'
  | 'AUXILLIARY_EQUIPMENT_NO_POWER'
  | 'BODY_CAR_WRAPPING'
  | 'BODY_DENT'
  | 'BODY_FADED'
  | 'BODY_GAP'
  | 'BODY_HAIL_DAMAGE_MORE_THAN_10_DENTS'
  | 'BODY_HAIL_DAMAGE_UP_TO_10_DENTS'
  | 'BODY_LARGE_GAP'
  | 'BODY_REPAINT'
  | 'BODY_RUST'
  | 'BODY_SCRATCH'
  | 'BODY_STONE_CHIP'
  | 'BRAKE_PIPE_CORRODED'
  | 'BRAKE_PIPE_LEAKY'
  | 'BROKEN'
  | 'CAR_WRAPPING'
  | 'CENTRAL_LOCKING_NOT_FUNCTIONING'
  | 'CENTRAL_LOCKING_PARTLY_NOT_FUNCTIONING'
  | 'CLOSING_MECHANISM_DAMAGED'
  | 'CLUTCH_MALFUNCTION'
  | 'CLUTCH_PEDAL_TOO_LONG'
  | 'CLUTCH_PEDAL_TOO_SHORT'
  | 'CLUTCH_PEDAL_TOO_STRONG'
  | 'CLUTCH_SLIPS'
  | 'CONTROL_ELEMENTS_DAMAGED'
  | 'CONTROL_ELEMENTS_MISSING_PARTS'
  | 'CONTROL_ELEMENTS_WORN'
  | 'DENT'
  | 'DING'
  | 'DRIVE_SHAFT_DUST_BOOT_OPEN'
  | 'DRIVE_SHAFT_GRINDING_SOUND'
  | 'EDGE_DAMAGED'
  | 'ELECTRIC_MIRRORS_NOT_FUNCTIONING'
  | 'ELECTRIC_MIRRORS_PARTLY_NOT_FUNCTIONING'
  | 'ELECTRONIC_COMFORT_DAMAGED'
  | 'ELECTRONIC_COMFORT_LACKING_STORAGE_MEDIUM'
  | 'ELECTRONIC_COMFORT_MISSING_PARTS'
  | 'ELECTRONIC_COMFORT_PIXEL_ERRORS'
  | 'ELECTRONIC_COMFORT_SCRATCH'
  | 'EMERGENCY_FLASHER_NOT_FUNCTIONING'
  | 'EMERGENCY_FLASHER_PARTLY_NOT_FUNCTIONING'
  | 'ENGINE_ATYPICAL_SOUND'
  | 'ENGINE_DOES_NOT_ROTATE'
  | 'ENGINE_OIL_LOSS'
  | 'ENGINE_OIL_TOO_LOW'
  | 'ENGINE_POWER_TOO_LOW'
  | 'ENGINE_TOO_LOUD'
  | 'ENGINE_UNUSUAL_NOISE'
  | 'ENGINE_VIBRATION'
  | 'EXHAUST_LEAKY'
  | 'EXHAUST_MISSING_PARTS'
  | 'EXHAUST_RUST'
  | 'EXHAUST_UNUSUAL_SMOKE'
  | 'EXPENDABLE_PART_MISSING_PARTS'
  | 'EXPENDABLE_PART_RUST'
  | 'EXPENDABLE_PART_WEAR_LIMIT'
  | 'FADED'
  | 'FADED_PAINT'
  | 'FRACTURE'
  | 'GENERAL'
  | 'GLASS_CRACK'
  | 'GLASS_FADED'
  | 'GLASS_LEAKY'
  | 'GLASS_SCRATCH'
  | 'GLASS_STONE_CHIP'
  | 'HAIL_DAMAGE'
  | 'HAND_BRAKE_LEVER_PATH_TOO_LONG'
  | 'HEATING_NOT_FUNCTIONING'
  | 'HEATING_PARTLY_NOT_FUNCTIONING'
  | 'LAMPS_FADED'
  | 'LAMPS_FRACTURE'
  | 'LAMPS_LEAKY'
  | 'LAMPS_MISSING_PARTS'
  | 'LAMPS_NON_ORIGINAL_EQUIPMENT'
  | 'LAMPS_NOT_FUNCTIONING'
  | 'LAMPS_SCRATCH'
  | 'LAMPS_STONE_CHIP'
  | 'LEAKAGE'
  | 'LIQUID_EXCHANGE_CHANGE_DUE'
  | 'LIQUID_LEVEL_TOO_HIGH'
  | 'LIQUID_LEVEL_TOO_LOW'
  | 'MISSING_PARTS'
  | 'MOVABLE_BODY_CAR_WRAPPING'
  | 'MOVABLE_BODY_CLOSING_MECHANISM_DAMAGED'
  | 'MOVABLE_BODY_DENT'
  | 'MOVABLE_BODY_FADED'
  | 'MOVABLE_BODY_FRACTURE'
  | 'MOVABLE_BODY_HAIL_DAMAGE_MORE_THAN_10_DENTS'
  | 'MOVABLE_BODY_HAIL_DAMAGE_UP_TO_10_DENTS'
  | 'MOVABLE_BODY_LARGE_GAP'
  | 'MOVABLE_BODY_REPAINT'
  | 'MOVABLE_BODY_RUST'
  | 'MOVABLE_BODY_SCRATCH'
  | 'MOVABLE_BODY_STONE_CHIP'
  | 'NON_ORIGINAL_EQUIPMENT'
  | 'NOT_ALLOWED_DIMENSION'
  | 'PROPELLER_SHAFT_RUST'
  | 'PROPELLER_SHAFT_WARPED'
  | 'REPAINT'
  | 'ROOF_CLOSING_MECHANISM_DAMAGED'
  | 'ROOF_FADED'
  | 'ROOF_FISSURE'
  | 'ROOF_HOLES'
  | 'ROOF_LEAKY'
  | 'ROOF_SCRATCH'
  | 'RUST'
  | 'SCRATCH'
  | 'SEAT_HEATING_BROKEN'
  | 'SHOCK_ABSORBER_LEAKY'
  | 'SHOCK_ABSORBER_WEAR_LIMIT'
  | 'SIGNAL_HORN_NOT_FUNCTIONING'
  | 'SOOTED'
  | 'SPARE_WHEEL_DAMAGED'
  | 'SPARE_WHEEL_MISSING_PARTS'
  | 'SPARE_WHEEL_OLDER_THAN_10_YEARS'
  | 'STARTER_MALFUNCTION'
  | 'STEERING_INCREASED_CLEARANCE'
  | 'STEERING_ON_THE_BEAT'
  | 'STEERING_SCRATCH'
  | 'STEERING_WHEEL_LOCK_DAMAGED'
  | 'STEERING_WORN'
  | 'STONE_CHIP'
  | 'TIRE_AGE_CRACKS'
  | 'TIRE_DIMENSION_INADMISSABLE'
  | 'TIRE_EDGE_DAMAGED'
  | 'TIRE_EMERGENCY_KIT_CHANGE_DUE'
  | 'TIRE_EMERGENCY_KIT_MISSING_PARTS'
  | 'TIRE_WORN_ON_ONE_SIDE'
  | 'TRANSMISSION_ATYPICAL_SOUND'
  | 'TRANSMISSION_DOES_NOT_ROTATE'
  | 'TRANSMISSION_POWER_TOO_LOW'
  | 'TRANSMISSION_TOO_LOUD'
  | 'TRANSMISSION_UNUSUAL_NOISE'
  | 'TRANSMISSION_VIBRATION'
  | 'UNUSUAL_SMOKE'
  | 'UPHOLSTERY_BURN'
  | 'UPHOLSTERY_CRACK'
  | 'UPHOLSTERY_DAMAGED'
  | 'UPHOLSTERY_DIRTY'
  | 'UPHOLSTERY_HOLES'
  | 'UPHOLSTERY_MISSING_PART'
  | 'UPHOLSTERY_RECONDITIONING_NECESSARY'
  | 'UPHOLSTERY_RUPTURED'
  | 'UPHOLSTERY_SCRATCH'
  | 'UPHOLSTERY_WORN'
  | 'WARNING_LIGHTS_ERROR_INDICATOR_ON'
  | 'WEAR_OF_SEATS_AND_FITTINGS'
  | 'WHEEL_BEARINGS_GRINDING_SOUND'
  | 'WINDOW_WRAPPING'
  | 'WIPER_AND_WASHER_NOT_FUNCTIONING'
  | 'WIPER_AND_WASHER_PARTLY_NOT_FUNCTIONING'
  | 'WORN_ON_ONE_SIDE';

export type VehicleDimensions = {
  __typename?: 'VehicleDimensions';
  emptyWeight?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  loadAreaHeight?: Maybe<Scalars['Int']['output']>;
  loadAreaLength?: Maybe<Scalars['Int']['output']>;
  loadAreaVolume?: Maybe<Scalars['Int']['output']>;
  loadAreaWidth?: Maybe<Scalars['Int']['output']>;
  maxWeight?: Maybe<Scalars['Int']['output']>;
  maxWeightPerAxle?: Maybe<Scalars['Int']['output']>;
  payload?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<VehicleDimensionsSize>;
  tankCapacity?: Maybe<Scalars['Int']['output']>;
  totalHeight?: Maybe<Scalars['Int']['output']>;
  totalLength?: Maybe<Scalars['Int']['output']>;
  totalWidth?: Maybe<Scalars['Int']['output']>;
  towingCapacity?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  wheelBase?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDimensionsSize =
  | 'L'
  | 'M'
  | 'S'
  | 'XL'
  | 'XS'
  | 'XXL';

export type VehicleEngine = {
  __typename?: 'VehicleEngine';
  batteryCapacity?: Maybe<Scalars['Int']['output']>;
  batteryHealth?: Maybe<VehicleBatteryHealth>;
  batteryOwnership?: Maybe<VehicleEngineBatteryOwnership>;
  co2Emission?: Maybe<Scalars['Decimal']['output']>;
  combinedConsumption?: Maybe<Scalars['Decimal']['output']>;
  cubicCapacity?: Maybe<Scalars['Decimal']['output']>;
  cylinder?: Maybe<Scalars['Int']['output']>;
  efficiencyClass?: Maybe<VehicleEngineEfficiencyClass>;
  emissionNorm?: Maybe<VehicleEngineEmissionNorm>;
  emissionSticker?: Maybe<VehicleEngineEmissionSticker>;
  engineList?: Maybe<Array<Maybe<VehicleEngineDetails>>>;
  fuelType?: Maybe<VehicleEngineFuelType>;
  /** Translation Key for fuelType value */
  fuelTypeTranslationKey?: Maybe<Scalars['String']['output']>;
  hp?: Maybe<Scalars['Int']['output']>;
  innerConsumption?: Maybe<Scalars['Decimal']['output']>;
  kw?: Maybe<Scalars['Int']['output']>;
  outerConsumption?: Maybe<Scalars['Decimal']['output']>;
  powerConsumption?: Maybe<Scalars['Decimal']['output']>;
  rangeOnFullLoad?: Maybe<Scalars['Int']['output']>;
};

export type VehicleEngineBatteryOwnership =
  | 'LEASED'
  | 'MISSING'
  | 'OWNED';

export type VehicleEngineDetailFuelType =
  | 'COMPRESSED_NATURAL_GAS'
  | 'DIESEL'
  | 'DIESEL_ELECTRIC_HYBRID'
  | 'ELECTRIC'
  | 'ETHANOL_E85'
  | 'HYBRID'
  | 'HYDROGEN'
  | 'LIQUIFIED_PETROLEUM_GAS'
  | 'OTHER'
  | 'PETROL'
  | 'PETROL_ELECTRIC_HYBRID'
  | 'PLUG_IN_HYBRID';

export type VehicleEngineDetails = {
  __typename?: 'VehicleEngineDetails';
  batteryCapacity?: Maybe<Scalars['Int']['output']>;
  batteryHealth?: Maybe<VehicleBatteryHealth>;
  batteryOwnership?: Maybe<VehicleEngineBatteryOwnership>;
  co2Emission?: Maybe<Scalars['Decimal']['output']>;
  combinedConsumption?: Maybe<Scalars['Decimal']['output']>;
  cubicCapacity?: Maybe<Scalars['Decimal']['output']>;
  cylinder?: Maybe<Scalars['Int']['output']>;
  engineFuelType?: Maybe<VehicleEngineDetailFuelType>;
  /** Translation Key for engineFuelType value */
  engineFuelTypeTranslationKey?: Maybe<Scalars['String']['output']>;
  hp?: Maybe<Scalars['Int']['output']>;
  innerConsumption?: Maybe<Scalars['Decimal']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  kw?: Maybe<Scalars['Int']['output']>;
  outerConsumption?: Maybe<Scalars['Decimal']['output']>;
  powerConsumption?: Maybe<Scalars['Decimal']['output']>;
  rangeOnFullLoad?: Maybe<Scalars['Int']['output']>;
};

export type VehicleEngineEfficiencyClass =
  | 'A'
  | 'A_PLUS'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G';

export type VehicleEngineEmissionNorm =
  | 'AT_PZEV'
  | 'EURO0'
  | 'EURO1'
  | 'EURO2'
  | 'EURO3'
  | 'EURO4'
  | 'EURO5'
  | 'EURO5A'
  | 'EURO5B'
  | 'EURO6'
  | 'EURO6A'
  | 'EURO6B'
  | 'EURO6C'
  | 'EURO6D'
  | 'EURO6D_TEMP'
  | 'EURO7'
  | 'ILEV'
  | 'NLEV'
  | 'NO_NORM_APPLICABLE'
  | 'PZEV'
  | 'ZEV';

export type VehicleEngineEmissionSticker =
  | 'BLUE'
  | 'GREEN'
  | 'NONE'
  | 'RED'
  | 'YELLOW';

export type VehicleEngineFuelType =
  | 'COMPRESSED_NATURAL_GAS'
  | 'DIESEL'
  | 'DIESEL_ELECTRIC_HYBRID'
  | 'ELECTRIC'
  | 'ETHANOL_E85'
  | 'HYBRID'
  | 'HYDROGEN'
  | 'LIQUIFIED_PETROLEUM_GAS'
  | 'OTHER'
  | 'PETROL'
  | 'PETROL_ELECTRIC_HYBRID'
  | 'PLUG_IN_HYBRID';

export type VehicleExterior = {
  __typename?: 'VehicleExterior';
  colorDetails?: Maybe<Array<Maybe<VehicleExteriorColorDetails>>>;
  mainColor?: Maybe<VehicleExteriorColor>;
  mainColorEffects?: Maybe<Array<Maybe<VehicleExteriorColorEffect>>>;
  wheelSets?: Maybe<Array<Maybe<VehicleExteriorWheelSet>>>;
};

export type VehicleExteriorColor =
  | 'BEIGE'
  | 'BLACK'
  | 'BLUE'
  | 'BRONZE'
  | 'BROWN'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'OTHER'
  | 'PURPLE'
  | 'RED'
  | 'SILVER'
  | 'VIOLET'
  | 'WHITE'
  | 'YELLOW';

export type VehicleExteriorColorDetails = {
  __typename?: 'VehicleExteriorColorDetails';
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<VehicleExteriorColor>;
  effects?: Maybe<Array<Maybe<VehicleExteriorColorEffect>>>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
};

export type VehicleExteriorColorEffect =
  | 'CANDY'
  | 'FLIP_FLOP'
  | 'FOILED'
  | 'GLOSSY'
  | 'LOTUS'
  | 'MATTE'
  | 'METALLIC'
  | 'NACRE'
  | 'PEARL'
  | 'UNI'
  | '_2K_METALLIC';

export type VehicleExteriorWheelDetail = {
  __typename?: 'VehicleExteriorWheelDetail';
  area?: Maybe<VehicleExteriorWheelDetailArea>;
  dotNumber?: Maybe<Scalars['String']['output']>;
  manufactureDate?: Maybe<Scalars['Date']['output']>;
  profileDepth?: Maybe<Scalars['Decimal']['output']>;
  rimType?: Maybe<VehicleExteriorWheelRimType>;
  tireType?: Maybe<VehicleExteriorWheelType>;
};

export type VehicleExteriorWheelDetailArea =
  | 'FRONT_LEFT'
  | 'FRONT_MIDDLE'
  | 'FRONT_RIGHT'
  | 'MIDDLE_LEFT'
  | 'MIDDLE_RIGHT'
  | 'REAR_LEFT'
  | 'REAR_RIGHT';

export type VehicleExteriorWheelDetailInput = {
  area: VehicleExteriorWheelDetailArea;
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  manufactureDate?: InputMaybe<Scalars['Date']['input']>;
  profileDepth?: InputMaybe<Scalars['Decimal']['input']>;
  rimType?: InputMaybe<VehicleExteriorWheelRimType>;
  tireType?: InputMaybe<VehicleExteriorWheelType>;
};

export type VehicleExteriorWheelRim = {
  __typename?: 'VehicleExteriorWheelRim';
  color?: Maybe<VehicleExteriorColor>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  manufacturingDate?: Maybe<Scalars['Date']['output']>;
  origin?: Maybe<VehicleExteriorWheelRimOrigin>;
  size?: Maybe<Scalars['Decimal']['output']>;
  type?: Maybe<VehicleExteriorWheelRimType>;
};

export type VehicleExteriorWheelRimOrigin =
  | 'ORIGINAL'
  | 'SUPPLIER'
  | 'UNKNOWN';

export type VehicleExteriorWheelRimType =
  | 'ALLOY'
  | 'ALUMINIUM'
  | 'ALUMINIUM_ORIGINAL'
  | 'ALUMINIUM_SUPPLIER'
  | 'CARBON'
  | 'MAGNESIUM'
  | 'STEEL'
  | 'STEEL_WITH_COVER'
  | 'UNKNOWN'
  | 'WITHOUT_RIMS';

export type VehicleExteriorWheelSet = {
  __typename?: 'VehicleExteriorWheelSet';
  features?: Maybe<Array<Maybe<VehicleExteriorWheelTireFeature>>>;
  isPrimarySet?: Maybe<Scalars['Boolean']['output']>;
  rim?: Maybe<VehicleExteriorWheelRim>;
  type?: Maybe<VehicleExteriorWheelType>;
  wheelCount?: Maybe<Scalars['Int']['output']>;
  wheelDetails?: Maybe<Array<Maybe<VehicleExteriorWheelDetail>>>;
};

export type VehicleExteriorWheelTireFeature =
  | 'ANTI_FLAT'
  | 'PRESSURE_SENSOR'
  | 'RUN_FLAT';

export type VehicleExteriorWheelType =
  | 'ALL_SEASON'
  | 'EMERGENCY'
  | 'OFFROAD'
  | 'PERFORMANCE'
  | 'SLICK'
  | 'SUMMER'
  | 'WINTER'
  | 'WITHOUT_TIRES';

export type VehicleFeatureDetail = {
  __typename?: 'VehicleFeatureDetail';
  areas?: Maybe<VehicleFeatureDeteailArea>;
  cardinality?: Maybe<Scalars['Int']['output']>;
  colorDetail?: Maybe<VehicleFeatureDetailColor>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<VehicleBasicDimension>;
  featureRef?: Maybe<VehicleFeatureRef>;
  group?: Maybe<VehicleFeatureDetailGroup>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isRemovable?: Maybe<Scalars['Boolean']['output']>;
  mainColor?: Maybe<VehicleFeatureDetailColorValue>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<VehicleFeatureDetailMaterial>;
  subGroup?: Maybe<VehicleFeatureDetailSubGroup>;
  translationKey?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type VehicleFeatureDetailColor = {
  __typename?: 'VehicleFeatureDetailColor';
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<VehicleFeatureDetailColorValue>;
  effects?: Maybe<Array<Maybe<VehicleFeatureDetailColorEffect>>>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
};

export type VehicleFeatureDetailColorEffect =
  | 'CANDY'
  | 'FLIP_FLOP'
  | 'FOILED'
  | 'GLOSSY'
  | 'LOTUS'
  | 'MATTE'
  | 'METALLIC'
  | 'NACRE'
  | 'PEARL'
  | 'UNI'
  | '_2K_METALLIC';

export type VehicleFeatureDetailColorValue =
  | 'BEIGE'
  | 'BLACK'
  | 'BLUE'
  | 'BRONZE'
  | 'BROWN'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'OTHER'
  | 'PURPLE'
  | 'RED'
  | 'SILVER'
  | 'VIOLET'
  | 'WHITE'
  | 'YELLOW';

export type VehicleFeatureDetailGroup =
  | 'ABS'
  | 'ACCELERATION_SKID_CONTROL'
  | 'ADAPTIVE_CRUISE_CONTROL'
  | 'ADAPTIVE_HEADLIGHTS'
  | 'AIRBAG'
  | 'AIR_CONDITIONING'
  | 'AIR_SUSPENSION'
  | 'ALARM_SYSTEM'
  | 'ALLOY_RIM'
  | 'ALL_WHEEL_DRIVE'
  | 'AMBIENT_LIGHTING'
  | 'ANDROID_AUTO'
  | 'APPLE_CAR_PLAY'
  | 'AUTOMATIC_HEADLIGHT_CONTROL'
  | 'AUXILIARY_HEATER'
  | 'AXLE_LOAD_INCREASE'
  | 'BACKLIGHT_LED'
  | 'BELT_TENSIONER'
  | 'BLIND_SPOT_ASSIST'
  | 'BLOCK_HEATER'
  | 'BRAKE_ASSIST'
  | 'CARGO_SPACE_PARTITION'
  | 'CAR_CHARGE_EQUIPMENT'
  | 'CAR_COMMUNICATION'
  | 'CATALYTIC_CONVERTER'
  | 'CENTER_ARM_REST'
  | 'CERAMIC_BRAKES'
  | 'CHASSIS_CONTROL_SYSTEMS'
  | 'CHILD_SEATS_ISOFIX_MOUNTING_POINTS'
  | 'COMING_HOME_LEAVING_HOME'
  | 'CONVERTIBLE'
  | 'CORNERING_LIGHTS'
  | 'COSMETIC'
  | 'CROSSWIND_ASSIST'
  | 'CROSS_TRAFFIC_ASSIST'
  | 'CRUISE_CONTROL'
  | 'DAYTIME_RUNNING_LIGHTS'
  | 'DIESEL_PARTICULATE_FILTER'
  | 'DIGITAL_COCKPIT'
  | 'DISTANCE_WARNER'
  | 'DRIVER_DROWSINESS_DETECTION'
  | 'DRIVING_MODE_SWITCH'
  | 'DRIVING_STYLE_ANALYSIS'
  | 'DYNAMIC_PERFORMANCE_CONTROL'
  | 'ECO_DRIVE_CONTROL'
  | 'ELECTRICALLY_ADJUSTABLE_SEATS'
  | 'ELECTRIC_SLIDING_DOORS'
  | 'ELECTRIC_STARTER'
  | 'ELECTRONIC_PARKING_BRAKE'
  | 'ELECTRONIC_STABILITY_CONTROL'
  | 'ELECTRONIC_STABILITY_PROGRAM'
  | 'ELECTRO_HYDRAULIC_CONVERTIBLE'
  | 'EMERGENCY_BRAKE_ASSIST'
  | 'EMERGENCY_BRAKE_SIGNAL'
  | 'EMERGENCY_BREAK_ASSIST'
  | 'ENTERTAINMENT_SYSTEM'
  | 'ENVIRONMENT_ASSIST_SYSTEM'
  | 'EXIT_WARNING'
  | 'EXTERIOR_MIRROR'
  | 'FATIGUE_WARNING_SYSTEM'
  | 'FOG_LIGHT'
  | 'FOLDABLE_REAR_SEATS'
  | 'FRONT_CAMERA'
  | 'FRONT_WHEEL_DRIVE'
  | 'FULL_PANELING'
  | 'GARAGE_DOOR_OPENER'
  | 'GEARBOX'
  | 'GLARE_FREE_HIGH_BEAM'
  | 'GLAZING_THERMAL_INSULATION'
  | 'HANDICAPPED_ENABLED'
  | 'HANDS_FREE_SYSTEM'
  | 'HEADLIGHT_CLEANING_SYSTEM'
  | 'HEADLIGHT_LED'
  | 'HEADROOM_HEATING'
  | 'HEAD_UP_DISPLAY'
  | 'HEATED_FRONT_WINDOW'
  | 'HEATED_SEATS'
  | 'HIGH_BEAM_ASSIST'
  | 'HIGH_PERFORMANCE_BRAKES'
  | 'HILL_DESCENT_CONTROL'
  | 'HILL_START_ASSIST'
  | 'IMMOBILIZER'
  | 'INSULATED_GLAZING'
  | 'INTEGRAL_SAFETY_CONCEPT'
  | 'INTERIOR_MIRROR'
  | 'INTERIOR_UPHOLSTERY'
  | 'KEYLESS_ENTRY'
  | 'LANE_ASSIST'
  | 'LANE_CHANGE_ASSIST'
  | 'LASER_HEADLIGHT'
  | 'LASHING_EYES'
  | 'LEVEL_CONTROL'
  | 'LIFTABLE_LEADING_AXLE'
  | 'LIFTABLE_TRAILER_AXLE'
  | 'LIGHT_SENSOR'
  | 'LIMITED_SLIP_DIFFERENTIAL'
  | 'LPG'
  | 'LUMBAR_SUPPORT'
  | 'MASSAGE_SEATS'
  | 'METALLIC_PAINT'
  | 'MULTIFUNCTION_STEERING_WHEEL'
  | 'NAVIGATION_SYSTEM'
  | 'NIGHT_VIEW_ASSIST'
  | 'ON_BOARD_COMPUTER'
  | 'PACKAGE'
  | 'PAINTED_BRAKE_CALIBER'
  | 'PANORAMIC_WINDSCREEN'
  | 'PARKING_ASSIST'
  | 'PARK_DISTANCE_CONTROL'
  | 'PARK_HEATER'
  | 'PASS_THROUGH_REAR_SEAT'
  | 'PETROL_PARTICULATE_FILTER'
  | 'PIVOTING_SEATS'
  | 'POWER_DOOR_LOCKS'
  | 'POWER_OUTLET'
  | 'POWER_STEERING'
  | 'POWER_TAKE_OFF'
  | 'POWER_WINDOWS'
  | 'RAIN_SENSOR_WIPERS'
  | 'REAR_LIGHTS'
  | 'REAR_SEAT_PASS_THROUGH'
  | 'REAR_SEAT_SPLIT'
  | 'REAR_VIEW_CAMERA'
  | 'REAR_VIEW_MIRROR'
  | 'REAR_WHEEL_DRIVE'
  | 'REAR_WIND_BLOCKER'
  | 'REAR_WIPER'
  | 'REINFORCED_TIRE'
  | 'RETARDER_INTARDER'
  | 'RETRACTING_REAR_SEATS'
  | 'ROOF_CASE'
  | 'ROOF_RACK'
  | 'SEAT_SETTINGS'
  | 'SECURITY_PACKAGE'
  | 'SIDE_VIEW_MIRRORS'
  | 'SKI_BAG'
  | 'SOUND_SYSTEM'
  | 'SPARE_WHEEL'
  | 'SPECIAL_ENGINE'
  | 'SPECIAL_PAINTWORK'
  | 'SPEED_CONTROL'
  | 'SPOILER'
  | 'SPORT_EXHAUST_SYSTEM'
  | 'SPORT_SEATS'
  | 'SPORT_UNDERCARRIAGE'
  | 'STABILIZER'
  | 'START_STOP_SYSTEM_ENGINE'
  | 'STEERING_STABILIZER_ASSIST'
  | 'STEERING_WHEEL'
  | 'STEERING_WHEEL_PADDLE_SHIFT'
  | 'SUNROOF'
  | 'SUN_BLIND_SYSTEM'
  | 'SUN_SHADE'
  | 'SUSPENSION_AIR_SPRING_AIR_SPRING'
  | 'SUSPENSION_LEAF_SPRING_AIR_SPRING'
  | 'SUSPENSION_LEAF_SPRING_LEAF_SPRING'
  | 'TACHOGRAPH'
  | 'TAILGATE_ELECTRIC'
  | 'TIRE_PRESSURE_MONITORING_SYSTEM'
  | 'TOW_BAR'
  | 'TRACTION_CONTROL'
  | 'TRAFFIC_JAM_ASSIST'
  | 'TRAFFIC_LIGHT_ASSIST'
  | 'TRAFFIC_SIGN_RECOGNITION'
  | 'TUNING_COMMENT'
  | 'UNCLASSIFIED'
  | 'UNDERCARRIAGE'
  | 'VENTILATED_SEATS'
  | 'WINDSCREEN_HEATED'
  | 'WIRELESS_CHARGING'
  | 'WOOD_FLOORING_CARGO_AREA'
  | 'WOOD_PANELING_CARGO_AREA'
  | 'XENON_LIGHTS'
  | '_360_CAM';

export type VehicleFeatureDetailMaterial =
  | 'ALCANTARA'
  | 'CLOTH'
  | 'LEATHER'
  | 'OTHER'
  | 'PART_LEATHER'
  | 'PLASTIC'
  | 'SYNTHETIC_LEATHER'
  | 'VELOUR';

export type VehicleFeatureDetailSubGroup =
  | 'ABS'
  | 'ADAPTIVE'
  | 'ALCANTARA'
  | 'ALL_WHEEL_DRIVE'
  | 'AUTOMATIC'
  | 'AUTOMATIC_2_ZONE'
  | 'AUTOMATIC_3_ZONE'
  | 'AUTOMATIC_4_ZONE'
  | 'AUTOMATIC_7_SPEED'
  | 'AUTOMATIC_9_SPEED'
  | 'AUTO_DIMMING'
  | 'AUX_IN_CONNECTION'
  | 'BIG'
  | 'BI_XENON'
  | 'BLUETOOTH'
  | 'BOTH_SIDES'
  | 'CAR_PHONE'
  | 'CENTRAL'
  | 'DAB'
  | 'DETACHABLE_TOW_HOOK'
  | 'DRIVER_AIRBAG'
  | 'DRIVER_PASSENGER_AIRBAG'
  | 'ELECTRIC'
  | 'ELECTRIC_HEATED'
  | 'ELECTRIC_TOP'
  | 'EMBEDDED_IN_NAVI'
  | 'EMERGENCY_CALL'
  | 'ENTERTAINMENT_MONITOR'
  | 'FRONT'
  | 'FRONT_AIRBAG'
  | 'FRONT_AND_REAR_ZONES'
  | 'FRONT_MEMORY'
  | 'FRONT_REAR'
  | 'FRONT_REAR_MEMORY'
  | 'FRONT_ZONES'
  | 'GLASS'
  | 'HANDS_FREE_EQUIPPED'
  | 'HARD_TOP'
  | 'HEAD_AIRBAG'
  | 'HEATED'
  | 'KNEE_AIRBAG'
  | 'LEATHER'
  | 'LEATHER_IMITATION'
  | 'LEFT'
  | 'MANUAL'
  | 'MANUAL_5_GEARS'
  | 'MANUAL_6_GEARS'
  | 'MANUAL_DIMMING'
  | 'MATERIAL_LEATHER'
  | 'MATERIAL_WOOD'
  | 'MEMORY'
  | 'MIRROR_LINK'
  | 'MOBILE'
  | 'MP3_USB_IPOD_INTERFACE'
  | 'MULTIFUNCTION_MONITOR'
  | 'NON_DETACHABLE_TOW_HOOK'
  | 'NORMAL'
  | 'PANORAMIC_GLASS'
  | 'PART_LEATHER'
  | 'POWER_STEERING'
  | 'RADIO'
  | 'RADIO_CASSETTE'
  | 'RADIO_CD'
  | 'RADIO_CD_CHANGER'
  | 'RADIO_CD_USB'
  | 'REAR'
  | 'REAR_AIRBAG'
  | 'REAR_SEAT_ENTERTAINMENT'
  | 'REGULAR'
  | 'RIGHT'
  | 'SECURITY_PACKAGE'
  | 'SERIES'
  | 'SIDE_AIRBAG'
  | 'SMALL'
  | 'SMOKERS_PACKAGE'
  | 'SOFT_TOP'
  | 'SOUND_SYSTEM'
  | 'SPORT'
  | 'SPORT_PACKAGE'
  | 'TOUCHSCREEN'
  | 'TUNER'
  | 'USB'
  | 'USB_C'
  | 'VENTILATED_MASSAGE_SEATS'
  | 'VOICE_CONTROL'
  | 'WIND_BLOCKER'
  | 'WINTER_PACKAGE'
  | 'WITHOUT_PANO'
  | 'XENON'
  | '_2'
  | '_4'
  | '_4_PLUS'
  | '_12V';

export type VehicleFeatureDeteailArea =
  | 'CONSOLE'
  | 'CONTROLS'
  | 'EXTERIOR'
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_RIGHT'
  | 'HOOD'
  | 'INTERIOR'
  | 'LEFT'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_RIGHT'
  | 'RIGHT'
  | 'ROOF'
  | 'TRUNK'
  | 'UNDERBODY'
  | 'WHEELS_AND_BRAKES';

export type VehicleFeatureRef =
  | 'HAS_ABS'
  | 'HAS_ACCELERATION_SKID_CONTROL'
  | 'HAS_ADAPTIVE_CRUISE_CONTROLLER'
  | 'HAS_ADAPTIVE_HEADLIGHTS'
  | 'HAS_AIRBAG'
  | 'HAS_AIR_CONDITIONING'
  | 'HAS_AIR_SUSPENSION'
  | 'HAS_ALARM_SYSTEM'
  | 'HAS_ALLOY_RIMS'
  | 'HAS_ALL_WHEEL_DRIVE'
  | 'HAS_AMBIENT_LIGHTING'
  | 'HAS_ANDROID_PHONE_CONNECTION'
  | 'HAS_APPLE_CARPLAY'
  | 'HAS_AUTOMATIC_AIR_CONDITION'
  | 'HAS_AUTOMATIC_HEADLIGHT_CONTROL'
  | 'HAS_AUXILIARY_HEATER'
  | 'HAS_AXLE_LOAD_INCREASE'
  | 'HAS_BACKLIGHT_LED'
  | 'HAS_BI_XENON_LIGHTS'
  | 'HAS_BLIND_SPOT_ASSIST'
  | 'HAS_BLOCK_HEATER'
  | 'HAS_BLUETOOTH'
  | 'HAS_BRAKE_ASSIST'
  | 'HAS_CARGO_SPACE_PARTITION'
  | 'HAS_CAR_COMMUNICATION'
  | 'HAS_CD_MULTICHANGER'
  | 'HAS_CENTER_ARM_REST'
  | 'HAS_CENTRAL_LOCKING'
  | 'HAS_CHARGING_CABLES'
  | 'HAS_CHASSIS_CONTROL_SYSTEM'
  | 'HAS_CLIMATISATION'
  | 'HAS_COC_DOCUMENT'
  | 'HAS_COMING_HOME_LEAVING_HOME'
  | 'HAS_CORNERING_LIGHTS'
  | 'HAS_CO_2'
  | 'HAS_CROSSWIND_ASSIST'
  | 'HAS_CROSS_TRAFFIC_ASSIST'
  | 'HAS_CRUISE_CONTROL'
  | 'HAS_DAYTIME_RUNNING_LIGHTS'
  | 'HAS_DETACHABLE_TOW_HOOK'
  | 'HAS_DIESEL_PARTICULATE_FILTER'
  | 'HAS_DIGITAL_RADIO'
  | 'HAS_DIMMING_INTERIOR_MIRROR'
  | 'HAS_DISTANCE_WARNER'
  | 'HAS_DRAUGHT_STOP'
  | 'HAS_DRIVER_DROWSINESS_DETECTION'
  | 'HAS_DRIVING_MODE_SWITCH'
  | 'HAS_DYNAMIC_PERFORMANCE_CONTROL'
  | 'HAS_ECO_DRIVE_CONTROL'
  | 'HAS_ELECTRIC_SEATS'
  | 'HAS_ELECTRIC_SEATS_FRONT_AND_REAR'
  | 'HAS_ELECTRIC_SIDE_VIEW_MIRRORS'
  | 'HAS_ELECTRIC_SLIDING_DOORS'
  | 'HAS_ELECTRIC_TAIL_GATE'
  | 'HAS_EMERGENCY_BREAK_ASSIST'
  | 'HAS_EMERGENCY_CALL_SYSTEM'
  | 'HAS_ENTERTAINMENT_SYSTEM'
  | 'HAS_ENVIRONMENT_ASSIST_SYSTEM'
  | 'HAS_ESP'
  | 'HAS_EXTERIOR_MIRROR'
  | 'HAS_FOG_LIGHTS'
  | 'HAS_FOLD_FLAT_PASSENGER_SEAT'
  | 'HAS_FRONT_CAMERA'
  | 'HAS_GLARE_FREE_HIGH_BEAM'
  | 'HAS_GPS'
  | 'HAS_HANDICAPPED_FEATURES'
  | 'HAS_HANDS_FREE_SYSTEM'
  | 'HAS_HARDTOP'
  | 'HAS_HEADLIGHT_CLEANING_SYSTEM'
  | 'HAS_HEAD_UP_DISPLAY'
  | 'HAS_HEATED_FRONT_WINDOW'
  | 'HAS_HEATED_SEATS'
  | 'HAS_HEATED_SEATS_FRONT'
  | 'HAS_HEATED_SEATS_FRONT_AND_REAR'
  | 'HAS_HEATED_SIDE_VIEW_MIRRORS'
  | 'HAS_HEATED_STEERING_WHEEL'
  | 'HAS_HEATED_WIND_SHIELD'
  | 'HAS_HIGH_BEAM_ASSIST'
  | 'HAS_HIGH_PERFORMANCE_BRAKES'
  | 'HAS_HILL_DESCENT_CONTROL'
  | 'HAS_HILL_START_ASSIST'
  | 'HAS_IMMOBILIZER'
  | 'HAS_INTEGRAL_SAFETY_CONCEPT'
  | 'HAS_INTEGRATED_MUSIC_STREAMING'
  | 'HAS_ISOFIX_MOUNTING_POINTS'
  | 'HAS_KEYLESS_ENTRY'
  | 'HAS_LANE_ASSIST'
  | 'HAS_LANE_CHANGE_ASSIST'
  | 'HAS_LASER_HEADLIGHTS'
  | 'HAS_LEATHER_STEERING_WHEEL'
  | 'HAS_LED_HEADLIGHTS'
  | 'HAS_LEVEL_CONTROL'
  | 'HAS_LIMITED_SLIP_DIFFERENTIAL'
  | 'HAS_LPG'
  | 'HAS_MAINTENANCE_GUIDE'
  | 'HAS_MASSAGE_SEATS'
  | 'HAS_NAVIGATION_SYSTEM'
  | 'HAS_NEW_HU_AU'
  | 'HAS_NIGHT_VIEW_ASSIST'
  | 'HAS_ON_BOARD_COMPUTER'
  | 'HAS_PADDLE_SHIFTERS'
  | 'HAS_PANORAMIC_ROOF'
  | 'HAS_PARKING_ASSIST'
  | 'HAS_PARK_DISTANCE_CONTROL'
  | 'HAS_PARK_DISTANCE_CONTROL_FRONT_AND_REAR'
  | 'HAS_PARK_DISTANCE_CONTROL_REAR'
  | 'HAS_PARK_DISTANCE_CONTROL_WITH_CAMERA'
  | 'HAS_PARK_HEATER'
  | 'HAS_POWER_TAKE_OFF'
  | 'HAS_POWER_WINDOWS'
  | 'HAS_POWER_WINDOWS_FRONT'
  | 'HAS_POWER_WINDOWS_FRONT_AND_REAR'
  | 'HAS_RADIO'
  | 'HAS_RADIO_CASSETTE'
  | 'HAS_RADIO_CD'
  | 'HAS_RADIO_D_A_B'
  | 'HAS_RADIO_MP_3'
  | 'HAS_RADIO_USB'
  | 'HAS_RAIN_SENSOR_WIPERS'
  | 'HAS_RANGE_EXTENDER'
  | 'HAS_REAR_SEAT_PASS_THROUGH'
  | 'HAS_REAR_SEAT_SPLIT'
  | 'HAS_REAR_WIND_BLOCKER'
  | 'HAS_REMOTE_CENTRAL_LOCKING'
  | 'HAS_ROOF_RACK'
  | 'HAS_SEAT_SETTINGS'
  | 'HAS_SEAT_VENTILATION'
  | 'HAS_SECURITY_PACKAGE'
  | 'HAS_SELF_PARKING_SYSTEM'
  | 'HAS_SELF_STEERING_SYSTEM'
  | 'HAS_SERVO_STEERING'
  | 'HAS_SKI_BAG'
  | 'HAS_SMARTPHONE_INDUCTION_CHARGER'
  | 'HAS_SMOKERS_PACKAGE'
  | 'HAS_SOUND_SYSTEM'
  | 'HAS_SPEED_CONTROL'
  | 'HAS_SPEED_LIMITER'
  | 'HAS_SPORT_PACKAGE'
  | 'HAS_SPORT_SEATS'
  | 'HAS_SPORT_SUSPENSION'
  | 'HAS_SPORT_UNDERCARRIAGE'
  | 'HAS_START_STOP_AUTOMATIC'
  | 'HAS_START_STOP_SYSTEM_ENGINE'
  | 'HAS_STEERING_STABILIZER_ASSIST'
  | 'HAS_STEERING_WHEEL_WITH_MULTIFUNCTION'
  | 'HAS_SUNROOF'
  | 'HAS_SUN_BLIND_SYSTEM'
  | 'HAS_THERMAL_GLAZING_INSULATION'
  | 'HAS_TIRE_PRESSURE_MONITORING_SYSTEM'
  | 'HAS_TOUCH_SCREEN'
  | 'HAS_TOW_BAR'
  | 'HAS_TRACTION_CONTROL'
  | 'HAS_TRAFFIC_SIGN_RECOGNITION'
  | 'HAS_TRAILER_COUPLING'
  | 'HAS_TUNING'
  | 'HAS_TV'
  | 'HAS_UNCLASSIFIED_FEATURE_DETAIL'
  | 'HAS_UNDERCARRIAGE'
  | 'HAS_U_S_B'
  | 'HAS_VIRTUAL_COCKPIT'
  | 'HAS_VOICE_CONTROL'
  | 'HAS_WARRANTY'
  | 'HAS_WIFI_HOT_SPOT'
  | 'HAS_WINTER_PACKAGE'
  | 'HAS_WOOD_FLOORING_CARGO_AREA'
  | 'HAS_WOOD_PANELING_CARGO_AREA'
  | 'HAS_XENON_LIGHTS'
  | 'IS_BIO_DIESEL_SUITABLE'
  | 'IS_CONVERTIBLE'
  | 'IS_ELECTRO_HYDRAULIC_CONVERTIBLE'
  | 'IS_E_10_ENABLED'
  | 'IS_FINANCED';

export type VehicleFeatures = {
  __typename?: 'VehicleFeatures';
  hasAbs?: Maybe<Scalars['Boolean']['output']>;
  hasAccelerationSkidControl?: Maybe<Scalars['Boolean']['output']>;
  hasAdaptiveCruiseController?: Maybe<Scalars['Boolean']['output']>;
  hasAdaptiveHeadlights?: Maybe<Scalars['Boolean']['output']>;
  hasAirConditioning?: Maybe<Scalars['Boolean']['output']>;
  hasAirSuspension?: Maybe<Scalars['Boolean']['output']>;
  hasAirbag?: Maybe<Scalars['Boolean']['output']>;
  hasAlarmSystem?: Maybe<Scalars['Boolean']['output']>;
  hasAllWheelDrive?: Maybe<Scalars['Boolean']['output']>;
  hasAlloyRims?: Maybe<Scalars['Boolean']['output']>;
  hasAmbientLighting?: Maybe<Scalars['Boolean']['output']>;
  hasAndroidPhoneConnection?: Maybe<Scalars['Boolean']['output']>;
  hasAppleCarplay?: Maybe<Scalars['Boolean']['output']>;
  hasAutomaticAirCondition?: Maybe<Scalars['Boolean']['output']>;
  hasAutomaticHeadlightControl?: Maybe<Scalars['Boolean']['output']>;
  hasAuxiliaryHeater?: Maybe<Scalars['Boolean']['output']>;
  hasAxleLoadIncrease?: Maybe<Scalars['Boolean']['output']>;
  hasBacklightLed?: Maybe<Scalars['Boolean']['output']>;
  hasBiXenonLights?: Maybe<Scalars['Boolean']['output']>;
  hasBlindSpotAssist?: Maybe<Scalars['Boolean']['output']>;
  hasBlockHeater?: Maybe<Scalars['Boolean']['output']>;
  hasBluetooth?: Maybe<Scalars['Boolean']['output']>;
  hasBrakeAssist?: Maybe<Scalars['Boolean']['output']>;
  hasCarCommunication?: Maybe<Scalars['Boolean']['output']>;
  hasCargoSpacePartition?: Maybe<Scalars['Boolean']['output']>;
  hasCdMultichanger?: Maybe<Scalars['Boolean']['output']>;
  hasCenterArmRest?: Maybe<Scalars['Boolean']['output']>;
  hasCentralLocking?: Maybe<Scalars['Boolean']['output']>;
  hasChargingCables?: Maybe<Scalars['Boolean']['output']>;
  hasChassisControlSystem?: Maybe<Scalars['Boolean']['output']>;
  hasClimatisation?: Maybe<Scalars['Boolean']['output']>;
  hasCo2?: Maybe<Scalars['Boolean']['output']>;
  hasCocDocument?: Maybe<Scalars['Boolean']['output']>;
  hasComingHomeLeavingHome?: Maybe<Scalars['Boolean']['output']>;
  hasCorneringLights?: Maybe<Scalars['Boolean']['output']>;
  hasCrossTrafficAssist?: Maybe<Scalars['Boolean']['output']>;
  hasCrosswindAssist?: Maybe<Scalars['Boolean']['output']>;
  hasCruiseControl?: Maybe<Scalars['Boolean']['output']>;
  hasDaytimeRunningLights?: Maybe<Scalars['Boolean']['output']>;
  hasDetachableTowHook?: Maybe<Scalars['Boolean']['output']>;
  hasDieselParticulateFilter?: Maybe<Scalars['Boolean']['output']>;
  hasDigitalRadio?: Maybe<Scalars['Boolean']['output']>;
  hasDimmingInteriorMirror?: Maybe<Scalars['Boolean']['output']>;
  hasDistanceWarner?: Maybe<Scalars['Boolean']['output']>;
  hasDraughtStop?: Maybe<Scalars['Boolean']['output']>;
  hasDriverDrowsinessDetection?: Maybe<Scalars['Boolean']['output']>;
  hasDrivingModeSwitch?: Maybe<Scalars['Boolean']['output']>;
  hasDynamicPerformanceControl?: Maybe<Scalars['Boolean']['output']>;
  hasEcoDriveControl?: Maybe<Scalars['Boolean']['output']>;
  hasElectricSeats?: Maybe<Scalars['Boolean']['output']>;
  hasElectricSeatsFrontAndRear?: Maybe<Scalars['Boolean']['output']>;
  hasElectricSideViewMirrors?: Maybe<Scalars['Boolean']['output']>;
  hasElectricSlidingDoors?: Maybe<Scalars['Boolean']['output']>;
  hasElectricTailGate?: Maybe<Scalars['Boolean']['output']>;
  hasEmergencyBreakAssist?: Maybe<Scalars['Boolean']['output']>;
  hasEmergencyCallSystem?: Maybe<Scalars['Boolean']['output']>;
  hasEntertainmentSystem?: Maybe<Scalars['Boolean']['output']>;
  hasEnvironmentAssistSystem?: Maybe<Scalars['Boolean']['output']>;
  hasEsp?: Maybe<Scalars['Boolean']['output']>;
  hasExteriorMirror?: Maybe<Scalars['Boolean']['output']>;
  hasFogLights?: Maybe<Scalars['Boolean']['output']>;
  hasFoldFlatPassengerSeat?: Maybe<Scalars['Boolean']['output']>;
  hasFrontCamera?: Maybe<Scalars['Boolean']['output']>;
  hasGlareFreeHighBeam?: Maybe<Scalars['Boolean']['output']>;
  hasGps?: Maybe<Scalars['Boolean']['output']>;
  hasHandicappedFeatures?: Maybe<Scalars['Boolean']['output']>;
  hasHandsFreeSystem?: Maybe<Scalars['Boolean']['output']>;
  hasHardtop?: Maybe<Scalars['Boolean']['output']>;
  hasHeadUpDisplay?: Maybe<Scalars['Boolean']['output']>;
  hasHeadlightCleaningSystem?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedFrontWindow?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedSeats?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedSeatsFront?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedSeatsFrontAndRear?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedSideViewMirrors?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedSteeringWheel?: Maybe<Scalars['Boolean']['output']>;
  hasHeatedWindShield?: Maybe<Scalars['Boolean']['output']>;
  hasHighBeamAssist?: Maybe<Scalars['Boolean']['output']>;
  hasHighPerformanceBrakes?: Maybe<Scalars['Boolean']['output']>;
  hasHillDescentControl?: Maybe<Scalars['Boolean']['output']>;
  hasHillStartAssist?: Maybe<Scalars['Boolean']['output']>;
  hasImmobilizer?: Maybe<Scalars['Boolean']['output']>;
  hasIntegralSafetyConcept?: Maybe<Scalars['Boolean']['output']>;
  hasIntegratedMusicStreaming?: Maybe<Scalars['Boolean']['output']>;
  hasIsofixMountingPoints?: Maybe<Scalars['Boolean']['output']>;
  hasKeylessEntry?: Maybe<Scalars['Boolean']['output']>;
  hasLaneAssist?: Maybe<Scalars['Boolean']['output']>;
  hasLaneChangeAssist?: Maybe<Scalars['Boolean']['output']>;
  hasLaserHeadlights?: Maybe<Scalars['Boolean']['output']>;
  hasLeatherSteeringWheel?: Maybe<Scalars['Boolean']['output']>;
  hasLedHeadlights?: Maybe<Scalars['Boolean']['output']>;
  hasLevelControl?: Maybe<Scalars['Boolean']['output']>;
  hasLimitedSlipDifferential?: Maybe<Scalars['Boolean']['output']>;
  hasLpg?: Maybe<Scalars['Boolean']['output']>;
  hasMaintenanceGuide?: Maybe<Scalars['Boolean']['output']>;
  hasMassageSeats?: Maybe<Scalars['Boolean']['output']>;
  hasNavigationSystem?: Maybe<Scalars['Boolean']['output']>;
  hasNewHuAu?: Maybe<Scalars['Boolean']['output']>;
  hasNightViewAssist?: Maybe<Scalars['Boolean']['output']>;
  hasOnBoardComputer?: Maybe<Scalars['Boolean']['output']>;
  hasPaddleShifters?: Maybe<Scalars['Boolean']['output']>;
  hasPanoramicRoof?: Maybe<Scalars['Boolean']['output']>;
  hasParkDistanceControl?: Maybe<Scalars['Boolean']['output']>;
  hasParkDistanceControlFrontAndRear?: Maybe<Scalars['Boolean']['output']>;
  hasParkDistanceControlRear?: Maybe<Scalars['Boolean']['output']>;
  hasParkDistanceControlWithCamera?: Maybe<Scalars['Boolean']['output']>;
  hasParkHeater?: Maybe<Scalars['Boolean']['output']>;
  hasParkingAssist?: Maybe<Scalars['Boolean']['output']>;
  hasPowerTakeOff?: Maybe<Scalars['Boolean']['output']>;
  hasPowerWindows?: Maybe<Scalars['Boolean']['output']>;
  hasPowerWindowsFront?: Maybe<Scalars['Boolean']['output']>;
  hasPowerWindowsFrontAndRear?: Maybe<Scalars['Boolean']['output']>;
  hasRadio?: Maybe<Scalars['Boolean']['output']>;
  hasRadioCassette?: Maybe<Scalars['Boolean']['output']>;
  hasRadioCd?: Maybe<Scalars['Boolean']['output']>;
  hasRadioDAB?: Maybe<Scalars['Boolean']['output']>;
  hasRadioMp3?: Maybe<Scalars['Boolean']['output']>;
  hasRadioUsb?: Maybe<Scalars['Boolean']['output']>;
  hasRainSensorWipers?: Maybe<Scalars['Boolean']['output']>;
  hasRangeExtender?: Maybe<Scalars['Boolean']['output']>;
  hasRearSeatPassThrough?: Maybe<Scalars['Boolean']['output']>;
  hasRearSeatSplit?: Maybe<Scalars['Boolean']['output']>;
  hasRearWindBlocker?: Maybe<Scalars['Boolean']['output']>;
  hasRemoteCentralLocking?: Maybe<Scalars['Boolean']['output']>;
  hasRoofRack?: Maybe<Scalars['Boolean']['output']>;
  hasSeatSettings?: Maybe<Scalars['Boolean']['output']>;
  hasSeatVentilation?: Maybe<Scalars['Boolean']['output']>;
  hasSecurityPackage?: Maybe<Scalars['Boolean']['output']>;
  hasSelfParkingSystem?: Maybe<Scalars['Boolean']['output']>;
  hasSelfSteeringSystem?: Maybe<Scalars['Boolean']['output']>;
  hasServoSteering?: Maybe<Scalars['Boolean']['output']>;
  hasSkiBag?: Maybe<Scalars['Boolean']['output']>;
  hasSmartphoneInductionCharger?: Maybe<Scalars['Boolean']['output']>;
  hasSmokersPackage?: Maybe<Scalars['Boolean']['output']>;
  hasSoundSystem?: Maybe<Scalars['Boolean']['output']>;
  hasSpeedControl?: Maybe<Scalars['Boolean']['output']>;
  hasSpeedLimiter?: Maybe<Scalars['Boolean']['output']>;
  hasSportPackage?: Maybe<Scalars['Boolean']['output']>;
  hasSportSeats?: Maybe<Scalars['Boolean']['output']>;
  hasSportSuspension?: Maybe<Scalars['Boolean']['output']>;
  hasSportUndercarriage?: Maybe<Scalars['Boolean']['output']>;
  hasStartStopAutomatic?: Maybe<Scalars['Boolean']['output']>;
  hasStartStopSystemEngine?: Maybe<Scalars['Boolean']['output']>;
  hasSteeringStabilizerAssist?: Maybe<Scalars['Boolean']['output']>;
  hasSteeringWheelWithMultifunction?: Maybe<Scalars['Boolean']['output']>;
  hasSunBlindSystem?: Maybe<Scalars['Boolean']['output']>;
  hasSunroof?: Maybe<Scalars['Boolean']['output']>;
  hasThermalGlazingInsulation?: Maybe<Scalars['Boolean']['output']>;
  hasTirePressureMonitoringSystem?: Maybe<Scalars['Boolean']['output']>;
  hasTouchScreen?: Maybe<Scalars['Boolean']['output']>;
  hasTowBar?: Maybe<Scalars['Boolean']['output']>;
  hasTractionControl?: Maybe<Scalars['Boolean']['output']>;
  hasTrafficSignRecognition?: Maybe<Scalars['Boolean']['output']>;
  hasTrailerCoupling?: Maybe<Scalars['Boolean']['output']>;
  hasTuning?: Maybe<Scalars['Boolean']['output']>;
  hasTv?: Maybe<Scalars['Boolean']['output']>;
  hasUSB?: Maybe<Scalars['Boolean']['output']>;
  hasUnclassifiedFeatureDetail?: Maybe<Scalars['Boolean']['output']>;
  hasUndercarriage?: Maybe<Scalars['Boolean']['output']>;
  hasVirtualCockpit?: Maybe<Scalars['Boolean']['output']>;
  hasVoiceControl?: Maybe<Scalars['Boolean']['output']>;
  hasWarranty?: Maybe<Scalars['Boolean']['output']>;
  hasWifiHotSpot?: Maybe<Scalars['Boolean']['output']>;
  hasWinterPackage?: Maybe<Scalars['Boolean']['output']>;
  hasWoodFlooringCargoArea?: Maybe<Scalars['Boolean']['output']>;
  hasWoodPanelingCargoArea?: Maybe<Scalars['Boolean']['output']>;
  hasXenonLights?: Maybe<Scalars['Boolean']['output']>;
  isBioDieselSuitable?: Maybe<Scalars['Boolean']['output']>;
  isConvertible?: Maybe<Scalars['Boolean']['output']>;
  isE10Enabled?: Maybe<Scalars['Boolean']['output']>;
  isElectroHydraulicConvertible?: Maybe<Scalars['Boolean']['output']>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
};

export type VehicleFields = {
  __typename?: 'VehicleFields';
  accidents: VehicleFieldsAccidents;
  paintThickness?: Maybe<Array<Maybe<PainThicknessOption>>>;
};

export type VehicleFieldsAccidents = {
  __typename?: 'VehicleFieldsAccidents';
  areas?: Maybe<Array<AccidentAreaOption>>;
  modelVersion: Scalars['Int']['output'];
};

export type VehicleFile = {
  __typename?: 'VehicleFile';
  absoluteUrl: Scalars['String']['output'];
  mimeType: VehicleFileMimeType;
  source?: Maybe<VehicleFileSource>;
  type?: Maybe<VehicleFileType>;
};

export type VehicleFileInput = {
  absoluteUrl: Scalars['URL']['input'];
  mimeType: VehicleFileMimeType;
  source?: InputMaybe<VehicleFileSource>;
  type?: InputMaybe<VehicleFileType>;
};

export type VehicleFileMimeType =
  | 'APPLICATION_PDF'
  | 'IMAGE_JPEG'
  | 'IMAGE_PNG'
  | 'VIDEO_MP4'
  | 'VIDEO_MPEG';

export type VehicleFileSource =
  | 'AUTO1'
  | 'MSI'
  | 'PA'
  | 'PA_ZRT'
  | 'PUBLIC_API';

export type VehicleFileType =
  | 'INVOICE'
  | 'OTHER'
  | 'REPORT';

export type VehicleIdentifiers = {
  __typename?: 'VehicleIdentifiers';
  datECode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hsn?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  regNumber?: Maybe<Scalars['String']['output']>;
  schwackeCode?: Maybe<Scalars['Int']['output']>;
  tsn?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type VehicleImage = {
  __typename?: 'VehicleImage';
  absoluteUrl: Scalars['String']['output'];
  area?: Maybe<VehicleImageArea>;
  height?: Maybe<Scalars['Int']['output']>;
  mimeType: VehicleMimeType;
  orientation?: Maybe<VehicleImageOrientation>;
  panoramaIndex?: Maybe<Scalars['Int']['output']>;
  part?: Maybe<VehicleImagePart>;
  pointsOfInterest?: Maybe<Array<PointOfInterest>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VehicleImageArea =
  | 'CONSOLE'
  | 'CONTROLS'
  | 'DOCUMENTS'
  | 'ENGINE'
  | 'EXTERIOR'
  | 'FRONT'
  | 'FRONT_INTERIOR'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_SIDE'
  | 'FRONT_LEFT_TIRE'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_SIDE'
  | 'FRONT_RIGHT_TIRE'
  | 'GENERAL'
  | 'HIGHLIGHTS'
  | 'HOOD'
  | 'INTERIOR'
  | 'LEFT'
  | 'NAVIGATION_SYSTEM'
  | 'PANORAMA'
  | 'REAR'
  | 'REAR_INTERIOR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_SIDE'
  | 'REAR_LEFT_TIRE'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_SIDE'
  | 'REAR_RIGHT_TIRE'
  | 'RIGHT'
  | 'ROOF'
  | 'SECONDARY_WHEELS_SET'
  | 'SPEEDOMETER'
  | 'TRUNK'
  | 'UNDERBODY'
  | 'WHEELS_AND_BRAKES';

export type VehicleImageInput = {
  absoluteUrl: Scalars['URL']['input'];
  area?: InputMaybe<VehicleImageArea>;
  mimeType: VehicleMimeType;
  part?: InputMaybe<VehicleImagePart>;
  pointsOfInterest?: InputMaybe<Array<PointOfInterestInput>>;
};

export type VehicleImageOrientation =
  | 'LANDSCAPE'
  | 'PORTRAIT';

export type VehicleImagePart =
  | 'ALTERNATOR'
  | 'ANTENNA'
  | 'A_PILLAR'
  | 'BLINKER_LEFT'
  | 'BLINKER_RIGHT'
  | 'BRAKE_FLUID_LEVEL'
  | 'BRAKE_LINES_BACK'
  | 'BRAKE_LINES_FRONT'
  | 'BUMPER'
  | 'B_PILLAR'
  | 'CATALYTIC_CONVERTER'
  | 'COC'
  | 'CONVERTIBLE_TOP'
  | 'COOLANT_LEVEL'
  | 'COOLING_SYSTEM'
  | 'COUPLING'
  | 'C_PILLAR'
  | 'DISC_DEAR_DOOR'
  | 'DISC_FRONT_DOOR'
  | 'DOOR_HANDLE_FRONT'
  | 'DOOR_HANDLE_REAR'
  | 'DRIVE_HAFT_FRONT_RIGHT'
  | 'DRIVE_SHAFT_FRONT_LEFT'
  | 'DRIVE_SHAFT_REAR_LEFT'
  | 'DRIVE_SHAFT_REAR_RIGHT'
  | 'D_PILLAR'
  | 'ELECTRIC_BATTERY'
  | 'ELECTRIC_BATTERY_DOCUMENT'
  | 'ELECTRIC_VEHICLE'
  | 'ENGINE'
  | 'ENGINE_OIL_LEVEL'
  | 'ENGINE_VIDEO'
  | 'EXHAUST_MANIFOLD'
  | 'EXTERIOR_PANORAMA_CLOSED_DOORS_PART'
  | 'EXTERIOR_PANORAMA_OPEN_DOORS_PART'
  | 'FILLER_CAP'
  | 'FOG_LIGHT_LEFT'
  | 'FOG_LIGHT_RIGHT'
  | 'FRONT_DOOR'
  | 'FRONT_FENDER'
  | 'FRONT_LEFT_BRAKE'
  | 'FRONT_RIGHT_BRAKE'
  | 'FRONT_SHOCK_ABSORBER'
  | 'FRONT_SILENCER'
  | 'GENERAL'
  | 'GENERAL_DAMAGE'
  | 'GRILL'
  | 'HARDTOP'
  | 'HEADLIGHT_LEFT'
  | 'HEADLIGHT_RIGHT'
  | 'HOOD'
  | 'INTERIOR_FRONT'
  | 'INTERIOR_PANORAMA_FULL'
  | 'INTERIOR_REAR'
  | 'LAMBDA_PROBE'
  | 'LICENSE_PLATE'
  | 'MIRRORS_GLASS'
  | 'MIRRORS_HOUSING'
  | 'OUTSIDE_MIRROR'
  | 'PANORAMIC_ROOF'
  | 'PASSENGER_DOOR'
  | 'POWER_STEERING_PUMP'
  | 'PROPERLLER_SHAFT'
  | 'RADIATOR'
  | 'RADIO'
  | 'REAR_DOOR'
  | 'REAR_FENDER'
  | 'REAR_SHOCK'
  | 'REAR_SIDE_WINDOW'
  | 'REAR_SILENCER'
  | 'REGISTRATION'
  | 'RIM_FRONT_LEFT'
  | 'RIM_FRONT_RIGHT'
  | 'RIM_REAR_LEFT'
  | 'RIM_REAR_RIGHT'
  | 'ROOF_RAILS'
  | 'SERVICE_BOOK'
  | 'SIDE_INDICATOR'
  | 'SIDE_SKIRTS'
  | 'SMALL_WINDOW'
  | 'SPOILER'
  | 'STARTER'
  | 'STEERING_AND_TRACK_RODS'
  | 'STEERING_PUMP_OIL_LEVEL'
  | 'SUNROOF'
  | 'TAILLIGHT'
  | 'TANK'
  | 'TECHNICAL_INSPECTION'
  | 'TECHNICAL_INSPECTION_CERTIFICATE'
  | 'TRANSMISSION'
  | 'TRUNK_LID'
  | 'TURBOCHARGER'
  | 'TYRES_FRONT_LEFT'
  | 'TYRES_FRONT_RIGHT'
  | 'TYRES_REAR_LEFT'
  | 'TYRES_REAR_RIGHT'
  | 'VALANCE'
  | 'WATER_PUMP'
  | 'WHEEL_BEARING_FRONT_LEFT'
  | 'WHEEL_BEARING_FRONT_RIGHT'
  | 'WHEEL_BEARING_REAR_LEFT'
  | 'WHEEL_BEARING_REAR_RIGHT'
  | 'WINDOW'
  | 'WINDOW_FRAME'
  | 'WINDSHIELD'
  | 'WINDSHIELD_WIPERS'
  | 'WING'
  | 'WIPER_LEFT'
  | 'WIPER_RIGHT';

export type VehicleInterior = {
  __typename?: 'VehicleInterior';
  colorDetails?: Maybe<VehicleInteriorColorDetails>;
  isUpholsteryOriginal?: Maybe<Scalars['Boolean']['output']>;
  mainColor?: Maybe<VehicleInteriorColor>;
  seatCount?: Maybe<Scalars['Int']['output']>;
  seats?: Maybe<Array<Maybe<VehicleInteriorSeat>>>;
  upholstery?: Maybe<VehicleInteriorUpholstery>;
};

export type VehicleInteriorColor =
  | 'BEIGE'
  | 'BLACK'
  | 'BLUE'
  | 'BRONZE'
  | 'BROWN'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'OTHER'
  | 'PURPLE'
  | 'RED'
  | 'SILVER'
  | 'VIOLET'
  | 'WHITE'
  | 'YELLOW';

export type VehicleInteriorColorDetails = {
  __typename?: 'VehicleInteriorColorDetails';
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<VehicleInteriorColor>;
  effects?: Maybe<Array<Maybe<VehicleInteriorColorEffect>>>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
};

export type VehicleInteriorColorEffect =
  | 'CANDY'
  | 'FLIP_FLOP'
  | 'FOILED'
  | 'GLOSSY'
  | 'LOTUS'
  | 'MATTE'
  | 'METALLIC'
  | 'NACRE'
  | 'PEARL'
  | 'UNI'
  | '_2K_METALLIC';

export type VehicleInteriorSeat = {
  __typename?: 'VehicleInteriorSeat';
  adjustability?: Maybe<VehicleInteriorSeatAdjustability>;
  area?: Maybe<VehicleInteriorSeatArea>;
  beltType?: Maybe<VehicleInteriorSeatBeltType>;
  color?: Maybe<VehicleInteriorColor>;
  features?: Maybe<Array<Maybe<VehicleInteriorSeatFeature>>>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<VehicleInteriorSeatMaterial>;
};

export type VehicleInteriorSeatAdjustability =
  | 'EIGHT_WAY'
  | 'FOUR_WAY'
  | 'SIX_WAY';

export type VehicleInteriorSeatArea =
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_MIDDLE'
  | 'FRONT_RIGHT'
  | 'MIDDLE'
  | 'MIDDLE_LEFT'
  | 'MIDDLE_MIDDLE'
  | 'MIDDLE_RIGHT'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_MIDDLE'
  | 'REAR_RIGHT';

export type VehicleInteriorSeatBeltType =
  | '_2_POINT'
  | '_2_POINT_LAP'
  | '_2_POINT_SASH'
  | '_3_POINT'
  | '_4_POINT'
  | '_5_POINT'
  | '_6_POINT'
  | '_7_POINT';

export type VehicleInteriorSeatFeature =
  | 'HAS_BELT_TENSIONER'
  | 'HAS_HEATING'
  | 'HAS_INTEGRATED_CHILD_SEAT'
  | 'HAS_ISOFIX_MOUNTING_POINTS'
  | 'HAS_LUMBAR_SUPPORT'
  | 'HAS_MEMORY'
  | 'IS_MANUAL'
  | 'IS_POWER_ADJUSTABLE'
  | 'IS_SPORT';

export type VehicleInteriorSeatMaterial =
  | 'ALCANTARA'
  | 'CLOTH'
  | 'LEATHER'
  | 'OTHER'
  | 'PART_LEATHER'
  | 'PLASTIC'
  | 'SYNTHETIC_LEATHER'
  | 'VELOUR';

export type VehicleInteriorUpholstery =
  | 'ALCANTARA'
  | 'CLOTH'
  | 'LEATHER'
  | 'OTHER'
  | 'PART_LEATHER'
  | 'PLASTIC'
  | 'SYNTHETIC_LEATHER'
  | 'VELOUR';

export type VehicleMimeType =
  | 'IMAGE_JPEG'
  | 'IMAGE_PNG'
  | 'JPEG'
  | 'MP4'
  | 'MPEG'
  | 'PNG'
  | 'VIDEO_MP4'
  | 'VIDEO_MPEG';

export type VehicleModel = {
  __typename?: 'VehicleModel';
  axles?: Maybe<Scalars['Int']['output']>;
  bodyType?: Maybe<VehicleModelBodyType>;
  /** Translation Key for bodyType value */
  bodyTypeTranslationKey?: Maybe<Scalars['String']['output']>;
  buildDate?: Maybe<Scalars['Date']['output']>;
  doorCount?: Maybe<Scalars['Int']['output']>;
  driveType?: Maybe<VehicleModelDriveType>;
  /** Translation Key for driveType value */
  driveTypeTranslationKey?: Maybe<Scalars['String']['output']>;
  factoryCode?: Maybe<Scalars['String']['output']>;
  gearBox?: Maybe<VehicleModelGearBox>;
  /** Translation Key for gearBox value */
  gearBoxTranslationKey?: Maybe<Scalars['String']['output']>;
  gearCount?: Maybe<Scalars['Int']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  mobileDeMake?: Maybe<Scalars['String']['output']>;
  mobileDeModel?: Maybe<Scalars['String']['output']>;
  mobileDeModelDescription?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  steeringWheelPosition?: Maybe<SteeringWheelPosition>;
  subModel?: Maybe<Scalars['String']['output']>;
  targetCountry?: Maybe<Country>;
  wheelDrive?: Maybe<VehicleModelWheelDrive>;
};

export type VehicleModelBodyType =
  | 'BUS'
  | 'CHASSIS_CAB'
  | 'CONVERTIBLE'
  | 'CONVERTIBLE_COUPE'
  | 'COUPE'
  | 'CURTAIN_SIDED_PLATFORM_CAB'
  | 'OTHER'
  | 'OTHER_COMMERCIAL'
  | 'PANEL_VAN'
  | 'PANEL_VAN_HIGH'
  | 'PANEL_VAN_HIGH_LONG'
  | 'PANEL_VAN_LONG'
  | 'PICKUP'
  | 'PLATFORM_CAB'
  | 'ROADSTER'
  | 'SEDAN'
  | 'SMALL_CAR'
  | 'STATION_WAGON'
  | 'SUV'
  | 'TIPPER'
  | 'TRUCK_WITH_BOX_BODY'
  | 'VAN';

export type VehicleModelDriveType =
  | 'ALL_WHEEL_DRIVE'
  | 'ALL_WHEEL_DRIVE_PERMANENT'
  | 'AZIMUTH_DRIVE'
  | 'BACK_WHEEL'
  | 'FRONT_WHEEL';

export type VehicleModelGearBox =
  | 'AUTOMATIC'
  | 'DUPLEX'
  | 'MANUAL'
  | 'SEMI_AUTOMATIC';

export type VehicleModelWheelDrive =
  | '_4X2'
  | '_4X4'
  | '_6X2'
  | '_6X4'
  | '_6X6'
  | '_8X4'
  | '_8X6'
  | '_8X8';

export type VehicleObject = {
  __typename?: 'VehicleObject';
  meta?: Maybe<MetaChannels>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type VehiclePaintThicknessInput = {
  area: VehicleConditionPaintThicknessArea;
  isNotMeasurable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value is in micrometers */
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type VehicleQualityOption = {
  __typename?: 'VehicleQualityOption';
  translationKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VehicleServiceBookType =
  | 'DIGITAL'
  | 'PAPER';

export type VideoType =
  | 'OVERVIEW_ENGINE_VIDEO';

export type Viewer = {
  __typename?: 'Viewer';
  refreshToken: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userImage: Scalars['String']['output'];
  userLocale: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type VinStatus =
  | 'AUCTION_ENDED'
  | 'DUPLICATED_VIN_UNFINISHED'
  /** Used for checkBeforeSubmitLicensePlate and checkBeforeSubmitVin only */
  | 'NO_VEHICLE_INFO'
  /** Used for checkBeforeSubmitLicensePlate only */
  | 'NO_VIN'
  | 'OK'
  | 'RERUN_LIMIT_EXHAUSTED'
  | 'RUNNING_AUCTION'
  /** Used for checkBeforeSubmitLicensePlate and checkBeforeSubmitVin only */
  | 'VEHICLE_INFO_TIMEOUT';

export type WalkinCustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type GuestRouteViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GuestRouteViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', userEmail: string, userLocale: string } | null };

export type ProtectedRouteViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ProtectedRouteViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', userEmail: string, userLocale: string } | null };

export type UserActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserActionsQuery = { __typename?: 'Query', user: { __typename?: 'User', email?: string | null, actions: { __typename?: 'UserActions', canCreatePdfInspection: boolean } } };

export type BranchCountryQueryVariables = Exact<{
  branchId: Scalars['Int']['input'];
}>;


export type BranchCountryQuery = { __typename?: 'Query', branch: { __typename?: 'Branch', country: Country } };

export type CarDetailsCarInfoQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CarDetailsCarInfoQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, name: string, country: Country }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyType?: string | null, gearBox?: string | null, driveType?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null, fuelTypeTranslationKey?: string | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null } | null, images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', engineName?: string | null, currentOwnerType?: OwnerType | null } | null } | null } | null };

export type CarDetailsInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CarDetailsInitialDataQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, country: Country, licensePlateCallEnabled: boolean }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, condition?: { __typename?: 'VehicleCondition', countryOfOrigin?: Country | null, firstRegistrationDate?: string | null, totalOwnerCount?: number | null, commercialUseType?: Array<VehicleConditionCommercialType> | null } | null, engine?: { __typename?: 'VehicleEngine', co2Emission?: number | null, fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, envClass?: VehicleEngineEmissionNorm | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', licensePlate?: string | null, externalId?: string | null, vin?: string | null } | null, model?: { __typename?: 'VehicleModel', buildDate?: string | null, model?: string | null } | null } | null, flags?: { __typename?: 'InspectionFlags', carRegistrationAvailable?: boolean | null, co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', countryOfRegistration?: string | null, vatType?: VatType | null, inventoryType?: InventoryType | null, otherNote?: string | null, currentOwnerType?: OwnerType | null, hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null, isBatteryChargeLevelGuaranteed?: boolean | null } | null } | null } | null };

export type CarDetailsUpdaterMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  carRegistrationImages?: InputMaybe<Array<VehicleImageInput> | VehicleImageInput>;
  certificateImages?: InputMaybe<Array<VehicleImageInput> | VehicleImageInput>;
  co2Emission?: InputMaybe<Scalars['Decimal']['input']>;
  co2EmissionAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  commercialUseType?: InputMaybe<VehicleConditionCommercialType>;
  countryOfOrigin?: InputMaybe<Country>;
  countryOfRegistration?: InputMaybe<Country>;
  envClass?: InputMaybe<VehicleEngineEmissionNorm>;
  firstRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  inventoryType?: InputMaybe<InventoryType>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  vatType?: InputMaybe<VatType>;
  currentOwnerType?: InputMaybe<OwnerType>;
  wasInCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  totalOwnersNumberAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  totalOwnerCount?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  otherNote: Scalars['String']['input'];
  skipOtherNote: Scalars['Boolean']['input'];
  batteryLeased?: InputMaybe<Scalars['Boolean']['input']>;
  batteryLeasingCostPerMonthInMinorUnits?: InputMaybe<Scalars['Int']['input']>;
  isBatteryLeasingCostAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isBatteryConditionReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isBatteryChargeLevelGuaranteed: Scalars['Boolean']['input'];
  batteryHealth?: InputMaybe<VehicleBatteryHealth>;
  hasChargingCables?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<VehicleImageInput> | VehicleImageInput>;
  skipElectricCar: Scalars['Boolean']['input'];
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CarDetailsUpdaterMutation = { __typename?: 'Mutation', msiSubmitAdditionalData?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, condition?: { __typename?: 'VehicleCondition', firstRegistrationDate?: string | null, commercialTypes?: Array<VehicleConditionCommercialType> | null, countryOfOrigin?: Country | null, totalOwnerCount?: number | null } | null, engine?: { __typename?: 'VehicleEngine', emissionNorm?: VehicleEngineEmissionNorm | null, co2Emission?: number | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', licensePlate?: string | null, externalId?: string | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', vatType?: VatType | null, inventoryType?: InventoryType | null, countryOfRegistration?: string | null, currentOwnerType?: OwnerType | null } | null } | null, flags?: { __typename?: 'InspectionFlags', co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null } | null, evaSubmitElectricCarDetails?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null, isBatteryChargeLevelGuaranteed?: boolean | null } | null } | null }, submitOtherNote?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', otherNote?: string | null } | null } | null } };

export type CheckBeforeSubmitLicensePlateV2QueryVariables = Exact<{
  licensePlate: Scalars['LicensePlateInput']['input'];
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
}>;


export type CheckBeforeSubmitLicensePlateV2Query = { __typename?: 'Query', checkBeforeSubmitLicensePlateV2: { __typename?: 'BeforeSubmitLicensePlateCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitToAuctionCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitVinCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } };

export type CheckBeforeSubmitVinV2QueryVariables = Exact<{
  vin: Scalars['VinInput']['input'];
  branchId: Scalars['Int']['input'];
  evaluationType: EvaluationType;
}>;


export type CheckBeforeSubmitVinV2Query = { __typename?: 'Query', checkBeforeSubmitVinV2: { __typename?: 'BeforeSubmitLicensePlateCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitToAuctionCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitVinCheckResult', retryAfter?: number | null, vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } };

export type ResolveLicensePlateQueryVariables = Exact<{
  branch: Scalars['Int']['input'];
  licensePlate: Scalars['LicensePlateInput']['input'];
}>;


export type ResolveLicensePlateQuery = { __typename?: 'Query', resolveLicensePlate?: string | null };

export type UserInspectionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInspectionTypesQuery = { __typename?: 'Query', user: { __typename?: 'User', email?: string | null, inspectionTypes: Array<{ __typename?: 'UserInspectionType', type?: UserInspectionTypeName | null, enabled: boolean }> } };

export type CarPicturesVehicleQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CarPicturesVehicleQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null } | null };

export type CreateVideoMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  type: VideoType;
}>;


export type CreateVideoMutation = { __typename?: 'Mutation', createVideo: { __typename?: 'CreatedVideo', getUrl: string, preSignedUrl: string } };

export type DeleteVehicleImageMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
}>;


export type DeleteVehicleImageMutation = { __typename?: 'Mutation', deleteVehicleImage: { __typename?: 'Inspection', inspectionId: number } };

export type ReplaceAdditionalCarImagesMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  images: Array<VehicleImageInput> | VehicleImageInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReplaceAdditionalCarImagesMutation = { __typename?: 'Mutation', replaceAdditionalCarImages: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null } };

export type ReplaceMainCarImagesMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  images: Array<VehicleImageInput> | VehicleImageInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReplaceMainCarImagesMutation = { __typename?: 'Mutation', replaceMainCarImages: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null } };

export type CarQualityInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CarQualityInitialDataQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', damages?: Array<{ __typename?: 'VehicleDamage', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, type?: VehicleDamageType | null, isAccidentReason?: boolean | null, files?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null }> | null, condition?: { __typename?: 'VehicleCondition', paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', paintThickness?: { __typename?: 'MetaPaintThickness', left?: boolean | null, right?: boolean | null, hood?: boolean | null, roof?: boolean | null, back?: boolean | null } | null } | null, highlights?: Array<{ __typename?: 'Highlight', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, files: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null, fields?: { __typename?: 'InspectionFields', vehicle?: { __typename?: 'VehicleFields', paintThickness?: Array<{ __typename?: 'PainThicknessOption', area: VehicleConditionPaintThicknessArea, canBePlastic: boolean, canBeFabric: boolean } | null> | null } | null } | null, flags?: { __typename?: 'InspectionFlags', isPaintThicknessChecked?: boolean | null } | null } | null, damageOptions: Array<{ __typename?: 'DamageArea', area: VehicleDamageArea, areaTranslationKey?: string | null, carParts: Array<{ __typename?: 'DamageCarPart', value: VehicleDamagePart, translationKey: string, damageTypes: Array<{ __typename?: 'DamageType', translationKey: string, value: VehicleDamageType, severities?: Array<{ __typename?: 'VehicleQualityOption', translationKey: string, value: string }> | null }> }> }> };

export type DamageOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DamageOptionsQuery = { __typename?: 'Query', damageOptions: Array<{ __typename?: 'DamageArea', area: VehicleDamageArea, areaTranslationKey?: string | null, carParts: Array<{ __typename?: 'DamageCarPart', value: VehicleDamagePart, translationKey: string, damageTypes: Array<{ __typename?: 'DamageType', translationKey: string, value: VehicleDamageType, severities?: Array<{ __typename?: 'VehicleQualityOption', translationKey: string, value: string }> | null }> }> }> };

export type UpdateCarQualityMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  damages: Array<DamageInput> | DamageInput;
  highlights: Array<HighlightInput> | HighlightInput;
  paintThickness: MetaPaintThicknessInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCarQualityMutation = { __typename?: 'Mutation', msiReplaceHighlights: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', highlights?: Array<{ __typename?: 'Highlight', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, files: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null }, msiSubmitPaintThickness: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', paintThickness?: { __typename?: 'MetaPaintThickness', left?: boolean | null, right?: boolean | null, hood?: boolean | null, roof?: boolean | null, back?: boolean | null } | null } | null } | null }, msiReplaceDamages: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', damages?: Array<{ __typename?: 'VehicleDamage', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, type?: VehicleDamageType | null, isAccidentReason?: boolean | null, files?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null }> | null } | null } };

export type UpdateCarQualityV2MutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  damages: Array<DamageInput> | DamageInput;
  highlights: Array<HighlightInput> | HighlightInput;
  isPaintThicknessChecked: Scalars['Boolean']['input'];
  paintThickness?: InputMaybe<Array<VehiclePaintThicknessInput> | VehiclePaintThicknessInput>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  skipPaintThickness: Scalars['Boolean']['input'];
}>;


export type UpdateCarQualityV2Mutation = { __typename?: 'Mutation', msiReplaceHighlights: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', highlights?: Array<{ __typename?: 'Highlight', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, files: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null }, submitPaintThickness?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, flags?: { __typename?: 'InspectionFlags', isPaintThicknessChecked?: boolean | null } | null }, msiReplaceDamages: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', damages?: Array<{ __typename?: 'VehicleDamage', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, type?: VehicleDamageType | null, isAccidentReason?: boolean | null, files?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null }> | null } | null } };

export type CarStatusDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CarStatusDataQuery = { __typename?: 'Query', getMandatoryEquipment?: Array<{ __typename?: 'EquipmentGroup', translationKey: string, exists?: boolean | null, name: string, items?: Array<{ __typename?: 'EquipmentItem', id: number, description?: string | null, source: string, exists?: boolean | null }> | null }> | null, inspection?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', interior?: { __typename?: 'VehicleInterior', seatCount?: number | null, upholstery?: VehicleInteriorUpholstery | null, isUpholsteryOriginal?: boolean | null } | null, condition?: { __typename?: 'VehicleCondition', keyCount?: number | null } | null, exterior?: { __typename?: 'VehicleExterior', mainColor?: VehicleExteriorColor | null, colorDetails?: Array<{ __typename?: 'VehicleExteriorColorDetails', isOriginal?: boolean | null, effects?: Array<VehicleExteriorColorEffect | null> | null } | null> | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', hasTuning?: boolean | null, tuningNote?: string | null, lpgNote?: string | null, hasLpg?: boolean | null, otherNote?: string | null } | null } | null } | null };

export type OtherEquipmentQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type OtherEquipmentQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', equipment?: Array<{ __typename?: 'EquipmentMeta', featureRef?: string | null, description?: string | null, isOriginal?: boolean | null, source?: string | null }> | null } | null } | null };

export type SubmitEquipmentPageMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  otherInformation: MsiOtherInfoInput;
  equipment: Array<EquipmentGroupItemInput> | EquipmentGroupItemInput;
  otherNote?: InputMaybe<Scalars['String']['input']>;
  skipOtherNote: Scalars['Boolean']['input'];
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubmitEquipmentPageMutation = { __typename?: 'Mutation', msiSubmitOtherInfo?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', interior?: { __typename?: 'VehicleInterior', seatCount?: number | null, upholstery?: VehicleInteriorUpholstery | null, isUpholsteryOriginal?: boolean | null } | null, condition?: { __typename?: 'VehicleCondition', keyCount?: number | null } | null, exterior?: { __typename?: 'VehicleExterior', mainColor?: VehicleExteriorColor | null, colorDetails?: Array<{ __typename?: 'VehicleExteriorColorDetails', isOriginal?: boolean | null, effects?: Array<VehicleExteriorColorEffect | null> | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', hasTuning?: boolean | null, tuningNote?: string | null, lpgNote?: string | null, hasLpg?: boolean | null, hasChargingCables?: boolean | null } | null } | null } | null, msiSubmitEquipment: { __typename?: 'Inspection', inspectionId: number }, submitOtherNote?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', otherNote?: string | null } | null } | null } };

export type SubmitOtherInformationMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  otherInformation: MsiOtherInfoInput;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubmitOtherInformationMutation = { __typename?: 'Mutation', msiSubmitOtherInfo?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', interior?: { __typename?: 'VehicleInterior', seatCount?: number | null, upholstery?: VehicleInteriorUpholstery | null, isUpholsteryOriginal?: boolean | null } | null, condition?: { __typename?: 'VehicleCondition', keyCount?: number | null } | null, exterior?: { __typename?: 'VehicleExterior', mainColor?: VehicleExteriorColor | null, colorDetails?: Array<{ __typename?: 'VehicleExteriorColorDetails', isOriginal?: boolean | null, effects?: Array<VehicleExteriorColorEffect | null> | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', hasTuning?: boolean | null, tuningNote?: string | null, lpgNote?: string | null, hasLpg?: boolean | null, hasChargingCables?: boolean | null } | null } | null } | null };

export type PiConvertInspectionToFullEvaMutationVariables = Exact<{
  stockNumber: Scalars['String']['input'];
}>;


export type PiConvertInspectionToFullEvaMutation = { __typename?: 'Mutation', piConvertInspectionToFullEva: { __typename?: 'Inspection', inspectionId: number } };

export type InspectionsV2QueryVariables = Exact<{
  branchesIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  statusesIds?: InputMaybe<Array<InspectionStatus> | InspectionStatus>;
}>;


export type InspectionsV2Query = { __typename?: 'Query', inspectionsV2: { __typename?: 'InspectionCollection', inspections: Array<{ __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, status: InspectionStatus, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null } | null, model?: { __typename?: 'VehicleModel', subModel?: string | null, make?: string | null, model?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null } | null, images?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, area?: VehicleImageArea | null, part?: VehicleImagePart | null }> | null } | null, branch: { __typename?: 'Branch', id: number, name: string } }> } };

export type GetLocationsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsListQuery = { __typename?: 'Query', userBranches: Array<{ __typename?: 'Branch', id: number, name: string, street: string, zipcode: string, city: string }>, userMerchant?: { __typename?: 'Merchant', defaultBranchId?: number | null } | null };

export type LoginWithGoogleCodeMutationVariables = Exact<{
  authCode: Scalars['String']['input'];
}>;


export type LoginWithGoogleCodeMutation = { __typename?: 'Mutation', loginWithGoogleCode: { __typename?: 'LoginWithGoogleCodeReturn', success: boolean, errorMessage?: string | null, data?: { __typename?: 'LoginWithGoogleCodeReturnData', accessToken: string, adminGroupIds: Array<number>, expiresIn: number, googleAccessToken: string, googleRefreshToken: string, jti: string, refreshToken: string, scope: string, tokenType: string, userChksum: string, userId: string, userLocale: string, userUuid: string } | null } };

export type ManufacturersQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ManufacturersQuery = { __typename?: 'Query', getManufacturers: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type GetMainTypesQueryVariables = Exact<{
  manufacturerId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMainTypesQuery = { __typename?: 'Query', getMainTypes: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type GetBuiltDatesQueryVariables = Exact<{
  manufacturerId: Scalars['String']['input'];
  mainTypeId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBuiltDatesQuery = { __typename?: 'Query', getBuiltDates: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type GetBodyTypesQueryVariables = Exact<{
  manufacturerId: Scalars['String']['input'];
  mainTypeId: Scalars['String']['input'];
  builtDate: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBodyTypesQuery = { __typename?: 'Query', getBodyTypes: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type GetMainTypeDetailsQueryVariables = Exact<{
  manufacturerId: Scalars['String']['input'];
  mainTypeId: Scalars['String']['input'];
  builtDate: Scalars['String']['input'];
  bodyType: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMainTypeDetailsQuery = { __typename?: 'Query', getMainTypeDetails: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type GetMainTypeSubsQueryVariables = Exact<{
  manufacturerId: Scalars['String']['input'];
  mainTypeId: Scalars['String']['input'];
  builtDate: Scalars['String']['input'];
  bodyType: Scalars['String']['input'];
  mainTypeDetailId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMainTypeSubsQuery = { __typename?: 'Query', getMainTypeSubs: Array<{ __typename?: 'CarDataItem', id: string, value: string } | null> };

export type ManualFlowInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type ManualFlowInitialDataQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, country: Country, licensePlateCallEnabled: boolean }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', licensePlate?: string | null, externalId?: string | null, vin?: string | null } | null } | null } | null };

export type PdfUpdateEcodeMutationVariables = Exact<{
  vin: Scalars['String']['input'];
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  ecode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  branch: Scalars['Int']['input'];
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfUpdateEcodeMutation = { __typename?: 'Mutation', msiPdfSubmitEcode?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, country: Country }, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyTypeTranslationKey?: string | null, gearBoxTranslationKey?: string | null, driveTypeTranslationKey?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelTypeTranslationKey?: string | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null, co2Emission?: number | null, emissionNorm?: VehicleEngineEmissionNorm | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', engineName?: string | null } | null, equipment?: Array<{ __typename?: 'EquipmentMeta', featureRef?: string | null, description?: string | null, isOriginal?: boolean | null, source?: string | null }> | null } | null } | null };

export type UpdateEcodeMutationVariables = Exact<{
  vin: Scalars['String']['input'];
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  ecode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  branch: Scalars['Int']['input'];
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEcodeMutation = { __typename?: 'Mutation', msiSubmitEcode?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, country: Country }, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyTypeTranslationKey?: string | null, gearBoxTranslationKey?: string | null, driveTypeTranslationKey?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelTypeTranslationKey?: string | null, fuelType?: VehicleEngineFuelType | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null, co2Emission?: number | null, emissionNorm?: VehicleEngineEmissionNorm | null } | null, condition?: { __typename?: 'VehicleCondition', paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', engineName?: string | null } | null, equipment?: Array<{ __typename?: 'EquipmentMeta', featureRef?: string | null, description?: string | null, isOriginal?: boolean | null, source?: string | null }> | null } | null, fields?: { __typename?: 'InspectionFields', vehicle?: { __typename?: 'VehicleFields', paintThickness?: Array<{ __typename?: 'PainThicknessOption', area: VehicleConditionPaintThicknessArea, canBePlastic: boolean, canBeFabric: boolean } | null> | null } | null } | null } | null };

export type TechnicalInspectionCompaniesQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type TechnicalInspectionCompaniesQuery = { __typename?: 'Query', technicalInspectionCompanies: Array<{ __typename?: 'Company', id: number, name: string }> };

export type PdfServiceDocumentsUpdaterMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  service: MsiServiceInput;
  accidents: Array<MsiAccidentInput> | MsiAccidentInput;
  hasHadAccident?: InputMaybe<Scalars['Boolean']['input']>;
  otherNote: Scalars['String']['input'];
  inspectionReport?: InputMaybe<VehicleFileInput>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PdfServiceDocumentsUpdaterMutation = { __typename?: 'Mutation', msiPdfSubmitService?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', hasServiceBook?: boolean | null, serviceBookType?: VehicleServiceBookType | null, lastServiceAtDate?: string | null, lastServiceAtMileage?: number | null, lastDriveBeltChangeDate?: string | null, lastDriveBeltChangeMileage?: number | null, isUnroadworthy?: boolean | null, cannotBeRolled?: boolean | null, technicalInspectionCertificateExpiryAtDate?: string | null } | null, engine?: { __typename?: 'VehicleEngine', engineList?: Array<{ __typename?: 'VehicleEngineDetails', isOriginal?: boolean | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', serviceBookAppointments?: ServiceBookAppointmentsEnum | null, serviceBookAppointmentsAvailable?: boolean | null, kmEngineExchange?: number | null, driveBeltChanged?: boolean | null, isMileageManipulated?: boolean | null, mileageManipulatedReason?: string | null, serviceBookImages?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null } | null } | null, evaReplaceAccidents: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', hasHadAccident?: boolean | null } | null, damages?: Array<{ __typename?: 'VehicleDamage', isAccidentReason?: boolean | null }> | null } | null, meta?: { __typename?: 'MetaPurchasing', accidents?: Array<{ __typename?: 'Accident', repairStatus?: AccidentAreaRepairStatus | null, repairedBy?: AccidentAreaRepairedBy | null, repairCost?: number | null, isRepairCostsAvailable?: boolean | null, invoiceImages: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null }, msiPdfSubmitTechnicalInspection?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', technicalInspectionCompanyId?: number | null, technicalInspectionReport?: { __typename?: 'VehicleFile', absoluteUrl: string, mimeType: VehicleFileMimeType, type?: VehicleFileType | null } | null } | null } | null } | null, submitOtherNote: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', otherNote?: string | null } | null } | null } };

export type ServiceDocumentsInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type ServiceDocumentsInitialDataQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', hasHadAccident?: boolean | null, hasServiceBook?: boolean | null, serviceBookType?: VehicleServiceBookType | null, lastServiceAtDate?: string | null, lastServiceAtMileage?: number | null, lastDriveBeltChangeDate?: string | null, lastDriveBeltChangeMileage?: number | null, isUnroadworthy?: boolean | null, cannotBeRolled?: boolean | null, inspectionExpiryDate?: string | null } | null, engine?: { __typename?: 'VehicleEngine', engineList?: Array<{ __typename?: 'VehicleEngineDetails', isOriginal?: boolean | null } | null> | null } | null, damages?: Array<{ __typename?: 'VehicleDamage', isAccidentReason?: boolean | null }> | null } | null, meta?: { __typename?: 'MetaPurchasing', accidents?: Array<{ __typename?: 'Accident', repairStatus?: AccidentAreaRepairStatus | null, repairedBy?: AccidentAreaRepairedBy | null, repairCost?: number | null, isRepairCostsAvailable?: boolean | null, invoiceImages: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null, evaluation?: { __typename?: 'MetaEvaluation', serviceBookAppointments?: ServiceBookAppointmentsEnum | null, serviceBookAppointmentsAvailable?: boolean | null, kmEngineExchange?: number | null, driveBeltChanged?: boolean | null, otherNote?: string | null, technicalInspectionCompanyId?: number | null, serviceBookImages?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null, technicalInspectionReport?: { __typename?: 'VehicleFile', absoluteUrl: string, mimeType: VehicleFileMimeType, type?: VehicleFileType | null } | null } | null } | null } | null };

export type ServiceDocumentsUpdaterMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  service: MsiServiceInput;
  accidents: Array<MsiAccidentInput> | MsiAccidentInput;
  hasHadAccident?: InputMaybe<Scalars['Boolean']['input']>;
  otherNote: Scalars['String']['input'];
  inspectionReport?: InputMaybe<VehicleFileInput>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceDocumentsUpdaterMutation = { __typename?: 'Mutation', msiSubmitService?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', hasServiceBook?: boolean | null, serviceBookType?: VehicleServiceBookType | null, lastServiceAtDate?: string | null, lastServiceAtMileage?: number | null, lastDriveBeltChangeDate?: string | null, lastDriveBeltChangeMileage?: number | null, isUnroadworthy?: boolean | null, cannotBeRolled?: boolean | null, technicalInspectionCertificateExpiryAtDate?: string | null } | null, engine?: { __typename?: 'VehicleEngine', engineList?: Array<{ __typename?: 'VehicleEngineDetails', isOriginal?: boolean | null } | null> | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', serviceBookAppointments?: ServiceBookAppointmentsEnum | null, serviceBookAppointmentsAvailable?: boolean | null, kmEngineExchange?: number | null, driveBeltChanged?: boolean | null, serviceBookImages?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null } | null } | null } | null, evaReplaceAccidents: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', hasHadAccident?: boolean | null } | null, damages?: Array<{ __typename?: 'VehicleDamage', isAccidentReason?: boolean | null }> | null } | null, meta?: { __typename?: 'MetaPurchasing', accidents?: Array<{ __typename?: 'Accident', repairStatus?: AccidentAreaRepairStatus | null, repairedBy?: AccidentAreaRepairedBy | null, repairCost?: number | null, isRepairCostsAvailable?: boolean | null, invoiceImages: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null }, msiSubmitTechnicalInspection?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', technicalInspectionCompanyId?: number | null, technicalInspectionReport?: { __typename?: 'VehicleFile', absoluteUrl: string, mimeType: VehicleFileMimeType, type?: VehicleFileType | null } | null } | null } | null } | null, submitOtherNote: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', otherNote?: string | null } | null } | null } };

export type GetInspectionByStockNumberQueryVariables = Exact<{
  stockNumberOrVin: Scalars['String']['input'];
}>;


export type GetInspectionByStockNumberQuery = { __typename?: 'Query', search?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null } | null, model?: { __typename?: 'VehicleModel', subModel?: string | null, make?: string | null, model?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null } | null, images?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, area?: VehicleImageArea | null, part?: VehicleImagePart | null }> | null } | null } | null };

export type EvaSubmitToAuctionMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  termsAccepted: Scalars['Boolean']['input'];
  expectedPrice: Scalars['Int']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  startPrice?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EvaSubmitToAuctionMutation = { __typename?: 'Mutation', evaSubmitToAuction: { __typename?: 'Inspection', inspectionId: number } };

export type EvaSubmitToDirectAuctionMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  expectedPrice: Scalars['Int']['input'];
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type EvaSubmitToDirectAuctionMutation = { __typename?: 'Mutation', evaSubmitToDirectAuction: { __typename?: 'Inspection', inspectionId: number } };

export type SellerQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type SellerQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, seller?: { __typename?: 'SellerInfo', companyName?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, street?: string | null, zipCode?: string | null } | null } | null } | null };

export type AutoPriceQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type AutoPriceQuery = { __typename?: 'Query', getAutoPrice: { __typename?: 'AutoPrice', priceInMinorUnits?: number | null, status: AutoPriceStatus } };

export type CheckBeforeSubmitToAuctionQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type CheckBeforeSubmitToAuctionQuery = { __typename?: 'Query', checkBeforeSubmitToAuction: { __typename?: 'BeforeSubmitLicensePlateCheckResult', vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitToAuctionCheckResult', vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } | { __typename?: 'BeforeSubmitVinCheckResult', vinStatus: VinStatus, relatedInspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null } | null } | null } };

export type EvaSubmitToBatchAuctionMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  auctionTypeId?: InputMaybe<Scalars['Int']['input']>;
  expectedPrice: Scalars['Int']['input'];
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  failedReasons?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  termsAccepted: Scalars['Boolean']['input'];
}>;


export type EvaSubmitToBatchAuctionMutation = { __typename?: 'Mutation', evaSubmitToBatchAuction: { __typename?: 'Inspection', inspectionId: number } };

export type GetStartPriceQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  expectedPrice: Scalars['Int']['input'];
  currency?: InputMaybe<Currency>;
}>;


export type GetStartPriceQuery = { __typename?: 'Query', getStartPrice?: { __typename?: 'Price', amount?: number | null } | null };

export type SubmitToInstantPriceMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  termsAccepted: Scalars['Boolean']['input'];
}>;


export type SubmitToInstantPriceMutation = { __typename?: 'Mutation', submitToInstantPrice: { __typename?: 'Inspection', inspectionId: number } };

export type SummaryInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type SummaryInitialDataQuery = { __typename?: 'Query', getMandatoryEquipment?: Array<{ __typename?: 'EquipmentGroup', name: string, exists?: boolean | null, items?: Array<{ __typename?: 'EquipmentItem', description?: string | null, exists?: boolean | null }> | null }> | null, getAuctionOptions?: Array<{ __typename?: 'AuctionOption', id: number, duration: number }> | null, msiGetCheckoutTypes: Array<{ __typename?: 'CheckoutType', enabled: boolean, type: CheckoutTypeTypes, reason?: CheckoutTypeReason | null } | null>, inspection?: { __typename?: 'Inspection', inspectionId: number, lastChangedTime?: string | null, status: InspectionStatus, car: { __typename?: 'Car', stockNumber?: string | null }, meta?: { __typename?: 'MetaPurchasing', accidents?: Array<{ __typename?: 'Accident', repairStatus?: AccidentAreaRepairStatus | null }> | null, verification?: { __typename?: 'MetaVerification', failedReasons?: Array<{ __typename?: 'FailedReason', id: number, reasonName: string, comment?: string | null }> | null } | null, evaluation?: { __typename?: 'MetaEvaluation', serviceBookAppointmentsAvailable?: boolean | null, serviceBookAppointments?: ServiceBookAppointmentsEnum | null, countryOfRegistration?: string | null, isBatteryConditionReportAvailable?: boolean | null, expectedPrice?: number | null, priceIndicatorPrice?: { __typename?: 'PriceIndicatorPrice', originalPrice?: number | null, minPrice?: number | null, maxPrice?: number | null, fixedPrice?: number | null } | null } | null, highlights?: Array<{ __typename?: 'Highlight', files: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null } | null, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType, area?: VehicleImageArea | null }> | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null } | null, interior?: { __typename?: 'VehicleInterior', upholstery?: VehicleInteriorUpholstery | null } | null, features?: { __typename?: 'VehicleFeatures', hasAirConditioning?: boolean | null, hasAutomaticAirCondition?: boolean | null } | null, condition?: { __typename?: 'VehicleCondition', firstRegistrationDate?: string | null, keyCount?: number | null, mileage?: number | null, commercialTypes?: Array<VehicleConditionCommercialType> | null, totalOwnerCount?: number | null, hasHadAccident?: boolean | null, hasServiceBook?: boolean | null, lastServiceAtMileage?: number | null, lastServiceAtDate?: string | null, technicalInspectionCertificateExpiryAtDate?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, gearBox?: string | null } | null, engine?: { __typename?: 'VehicleEngine', batteryCapacity?: number | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, fuelType?: VehicleEngineFuelType | null, kw?: number | null, hp?: number | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', isOriginal?: boolean | null, batteryCapacity?: number | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, damages?: Array<{ __typename?: 'VehicleDamage', files?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null }> | null } | null, branch: { __typename?: 'Branch', id: number, country: Country }, flags?: { __typename?: 'InspectionFlags', totalOwnersNumberAvailable?: boolean | null, wasInCommercialUse?: boolean | null } | null } | null, userMerchant?: { __typename?: 'Merchant', country?: Country | null } | null };

export type QuestionOptionFragmentFragment = { __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number };

export type SubmitTestDriveMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  mileage?: InputMaybe<Scalars['Int']['input']>;
  skipSubmitMileageManipulationSuspicions: Scalars['Boolean']['input'];
  mileageSuspicions?: InputMaybe<MileageManipulationSuspicionsInput>;
  answers: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubmitTestDriveMutation = { __typename?: 'Mutation', submitMileage: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', mileage?: number | null } | null } | null }, submitMileageManipulationSuspicions?: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', isMileageManipulated?: boolean | null, mileageManipulationSuspicions?: { __typename?: 'MileageManipulationSuspicions', isMileageConflictingCarCondition?: boolean | null, isOdometerBroken?: boolean | null, isMileageConflictingServiceHistory?: boolean | null, isMileageConflictingDatabase?: boolean | null, isTachometerReplaced?: boolean | null, tachometerReplacementMileage?: number | null, isTachometerReplacementMileageAvailable?: boolean | null } | null } | null } | null }, submitTestDriveAnswers: { __typename?: 'Inspection', inspectionId: number, meta?: { __typename?: 'MetaPurchasing', testDrive?: { __typename?: 'TestDrive', answers?: Array<number> | null } | null } | null } };

export type TestDriveInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type TestDriveInitialDataQuery = { __typename?: 'Query', testDriveQuestions?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null, inspection?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', mileage?: number | null } | null } | null, meta?: { __typename?: 'MetaPurchasing', testDrive?: { __typename?: 'TestDrive', answers?: Array<number> | null } | null, evaluation?: { __typename?: 'MetaEvaluation', isMileageManipulated?: boolean | null, mileageManipulationSuspicions?: { __typename?: 'MileageManipulationSuspicions', isMileageConflictingCarCondition?: boolean | null, isOdometerBroken?: boolean | null, isMileageConflictingServiceHistory?: boolean | null, isMileageConflictingDatabase?: boolean | null, isTachometerReplaced?: boolean | null, tachometerReplacementMileage?: number | null, isTachometerReplacementMileageAvailable?: boolean | null } | null } | null } | null } | null };

export type TiresBrakesInitialDataQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type TiresBrakesInitialDataQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', brakes?: Array<{ __typename?: 'VehicleConditionBrake', area?: VehicleConditionBrakeLocation | null, condition?: VehicleConditionBrakeCondition | null } | null> | null } | null, exterior?: { __typename?: 'VehicleExterior', wheelSets?: Array<{ __typename?: 'VehicleExteriorWheelSet', isPrimarySet?: boolean | null, wheelDetails?: Array<{ __typename?: 'VehicleExteriorWheelDetail', profileDepth?: number | null, area?: VehicleExteriorWheelDetailArea | null, rimType?: VehicleExteriorWheelRimType | null, tireType?: VehicleExteriorWheelType | null, dotNumber?: string | null } | null> | null } | null> | null } | null } | null } | null };

export type UpdateTiresBreaksMutationVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
  wheels: Array<VehicleExteriorWheelDetailInput> | VehicleExteriorWheelDetailInput;
  extraWheels: Array<VehicleExteriorWheelDetailInput> | VehicleExteriorWheelDetailInput;
  brakesCondition: Array<VehicleConditionBrakeInput> | VehicleConditionBrakeInput;
  isPrimarySet: Scalars['Boolean']['input'];
  isExtraSet: Scalars['Boolean']['input'];
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTiresBreaksMutation = { __typename?: 'Mutation', submitMainWheels: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', exterior?: { __typename?: 'VehicleExterior', wheelSets?: Array<{ __typename?: 'VehicleExteriorWheelSet', isPrimarySet?: boolean | null, wheelDetails?: Array<{ __typename?: 'VehicleExteriorWheelDetail', profileDepth?: number | null, area?: VehicleExteriorWheelDetailArea | null, rimType?: VehicleExteriorWheelRimType | null, tireType?: VehicleExteriorWheelType | null, dotNumber?: string | null } | null> | null } | null> | null } | null } | null }, msiReplaceBrakeConditions?: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', brakes?: Array<{ __typename?: 'VehicleConditionBrake', area?: VehicleConditionBrakeLocation | null, condition?: VehicleConditionBrakeCondition | null } | null> | null } | null } | null } | null, submitExtraWheels: { __typename?: 'Inspection', inspectionId: number, vehicle?: { __typename?: 'Vehicle', exterior?: { __typename?: 'VehicleExterior', wheelSets?: Array<{ __typename?: 'VehicleExteriorWheelSet', isPrimarySet?: boolean | null, wheelDetails?: Array<{ __typename?: 'VehicleExteriorWheelDetail', profileDepth?: number | null, area?: VehicleExteriorWheelDetailArea | null, rimType?: VehicleExteriorWheelRimType | null, tireType?: VehicleExteriorWheelType | null, dotNumber?: string | null } | null> | null } | null> | null } | null } | null } };

export type BranchQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BranchQuery = { __typename?: 'Query', branch: { __typename?: 'Branch', id: number, name: string, street: string, zipcode: string, city: string, country: Country, phone?: string | null, email?: string | null } };

export type CreateBranchMutationVariables = Exact<{
  branch: BranchInput;
}>;


export type CreateBranchMutation = { __typename?: 'Mutation', createBranch: { __typename?: 'Branch', id: number, name: string, street: string, zipcode: string, city: string } };

export type UpdateBranchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  branch: BranchInput;
}>;


export type UpdateBranchMutation = { __typename?: 'Mutation', updateBranch: { __typename?: 'Branch', id: number, name: string, street: string, zipcode: string, city: string } };

export type UserBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBranchesQuery = { __typename?: 'Query', userBranches: Array<{ __typename?: 'Branch', country: Country, licensePlateCallEnabled: boolean, street: string, zipcode: string, city: string, value: number, label: string }>, userMerchant?: { __typename?: 'Merchant', defaultBranchId?: number | null } | null };

export type UserBranchesPaginatedQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserBranchesPaginatedQuery = { __typename?: 'Query', userBranchesPaginated: { __typename?: 'BranchList', name?: string | null, page: number, pageSize: number, totalPageCount: number, entities: Array<{ __typename?: 'Branch', country: Country, licensePlateCallEnabled: boolean, street: string, zipcode: string, city: string, value: number, label: string }> }, userMerchant?: { __typename?: 'Merchant', defaultBranchId?: number | null } | null };

export type TopBannerQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type TopBannerQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, name: string }, car: { __typename?: 'Car', stockNumber?: string | null }, vehicle?: { __typename?: 'Vehicle', images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string }> | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null } | null } | null } | null };

export type InspectionQueryVariables = Exact<{
  inspectionId: Scalars['Int']['input'];
}>;


export type InspectionQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', inspectionId: number, editable: boolean, sourceType: InspectionSourceType, actions: Array<{ __typename?: 'InspectionAction', name?: InspectionActionName | null }>, branch: { __typename?: 'Branch', id: number, country: Country, name: string }, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, vehicle?: { __typename?: 'Vehicle', condition?: { __typename?: 'VehicleCondition', countryOfOrigin?: Country | null, firstRegistrationDate?: string | null, keyCount?: number | null, mileage?: number | null, totalOwnerCount?: number | null, hasHadAccident?: boolean | null, hasServiceBook?: boolean | null, serviceBookType?: VehicleServiceBookType | null, lastServiceAtDate?: string | null, lastServiceAtMileage?: number | null, lastDriveBeltChangeDate?: string | null, lastDriveBeltChangeMileage?: number | null, isUnroadworthy?: boolean | null, technicalInspectionCertificateExpiryAtDate?: string | null, commercialUseType?: Array<VehicleConditionCommercialType> | null, brakes?: Array<{ __typename?: 'VehicleConditionBrake', area?: VehicleConditionBrakeLocation | null, condition?: VehicleConditionBrakeCondition | null } | null> | null } | null, damages?: Array<{ __typename?: 'VehicleDamage', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, type?: VehicleDamageType | null, isAccidentReason?: boolean | null, files?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null }> | null, engine?: { __typename?: 'VehicleEngine', cubicCapacity?: number | null, cylinder?: number | null, co2Emission?: number | null, fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, hp?: number | null, kw?: number | null, envClass?: VehicleEngineEmissionNorm | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', isOriginal?: boolean | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, exterior?: { __typename?: 'VehicleExterior', mainColor?: VehicleExteriorColor | null, colorDetails?: Array<{ __typename?: 'VehicleExteriorColorDetails', isOriginal?: boolean | null, effects?: Array<VehicleExteriorColorEffect | null> | null } | null> | null, wheelSets?: Array<{ __typename?: 'VehicleExteriorWheelSet', isPrimarySet?: boolean | null, wheelDetails?: Array<{ __typename?: 'VehicleExteriorWheelDetail', profileDepth?: number | null, area?: VehicleExteriorWheelDetailArea | null, rimType?: VehicleExteriorWheelRimType | null, tireType?: VehicleExteriorWheelType | null, dotNumber?: string | null } | null> | null } | null> | null } | null, identifiers?: { __typename?: 'VehicleIdentifiers', licensePlate?: string | null, externalId?: string | null, vin?: string | null } | null, images?: Array<{ __typename?: 'VehicleImage', area?: VehicleImageArea | null, part?: VehicleImagePart | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, interior?: { __typename?: 'VehicleInterior', seatCount?: number | null, upholstery?: VehicleInteriorUpholstery | null, isUpholsteryOriginal?: boolean | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyType?: VehicleModelBodyType | null, driveType?: VehicleModelDriveType | null, gearBox?: VehicleModelGearBox | null } | null } | null, flags?: { __typename?: 'InspectionFlags', carRegistrationAvailable?: boolean | null, co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null, meta?: { __typename?: 'MetaPurchasing', accidents?: Array<{ __typename?: 'Accident', repairStatus?: AccidentAreaRepairStatus | null, repairedBy?: AccidentAreaRepairedBy | null, repairCost?: number | null, isRepairCostsAvailable?: boolean | null, invoiceImages: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> }> | null, evaluation?: { __typename?: 'MetaEvaluation', engineName?: string | null, countryOfRegistration?: string | null, inventoryType?: InventoryType | null, otherNote?: string | null, vatType?: VatType | null, hasTuning?: boolean | null, tuningNote?: string | null, lpgNote?: string | null, hasLpg?: boolean | null, hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null, serviceBookAppointments?: ServiceBookAppointmentsEnum | null, serviceBookAppointmentsAvailable?: boolean | null, kmEngineExchange?: number | null, driveBeltChanged?: boolean | null, isMileageManipulated?: boolean | null, mileageManipulatedReason?: string | null, technicalInspectionCompanyId?: number | null, paintThickness?: { __typename?: 'MetaPaintThickness', left?: boolean | null, right?: boolean | null, hood?: boolean | null, roof?: boolean | null, back?: boolean | null } | null, serviceBookImages?: Array<{ __typename?: 'VehicleImage', absoluteUrl: string, mimeType: VehicleMimeType }> | null, technicalInspectionReport?: { __typename?: 'VehicleFile', absoluteUrl: string, mimeType: VehicleFileMimeType, type?: VehicleFileType | null } | null } | null, highlights?: Array<{ __typename?: 'Highlight', area?: VehicleDamageArea | null, part?: VehicleDamagePart | null, files: Array<{ __typename?: 'VehicleImage', absoluteUrl: string }> }> | null, testDrive?: { __typename?: 'TestDrive', answers?: Array<number> | null } | null } | null } | null, testDriveQuestions?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number, options?: Array<{ __typename?: 'QuestionItem', id: number, translationKey: string, allowedOptions: number }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null, getMandatoryEquipment?: Array<{ __typename?: 'EquipmentGroup', translationKey: string, exists?: boolean | null, name: string, items?: Array<{ __typename?: 'EquipmentItem', id: number, description?: string | null, source: string, exists?: boolean | null }> | null }> | null };

export type LayoutViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type LayoutViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', userName: string, userEmail: string, userImage: string } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutReturn', success: boolean } };

export type CreateInspectionFromPdfMutationVariables = Exact<{
  pdfUrl: Scalars['URL']['input'];
  branch: Scalars['Int']['input'];
  vin?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInspectionFromPdfMutation = { __typename?: 'Mutation', createInspectionFromPdf?: { __typename?: 'InspectionFromPdfStatus', status: PdfJobStatus, inspectionId?: number | null } | null };

export type MsiPdfSubmitVinMutationVariables = Exact<{
  vin: Scalars['String']['input'];
  branch?: InputMaybe<Scalars['Int']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MsiPdfSubmitVinMutation = { __typename?: 'Mutation', msiPdfSubmitVin?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, name: string, country: Country }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyType?: string | null, gearBox?: string | null, driveType?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, fuelTypeTranslationKey?: string | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null, co2Emission?: number | null, emissionNorm?: VehicleEngineEmissionNorm | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, condition?: { __typename?: 'VehicleCondition', countryOfOrigin?: Country | null, firstRegistrationDate?: string | null, totalOwnerCount?: number | null, commercialUseType?: Array<VehicleConditionCommercialType> | null, paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, flags?: { __typename?: 'InspectionFlags', carRegistrationAvailable?: boolean | null, co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', countryOfRegistration?: string | null, vatType?: VatType | null, inventoryType?: InventoryType | null, otherNote?: string | null, hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null } | null, equipment?: Array<{ __typename?: 'EquipmentMeta', featureRef?: string | null, description?: string | null, isOriginal?: boolean | null, source?: string | null }> | null } | null, fields?: { __typename?: 'InspectionFields', vehicle?: { __typename?: 'VehicleFields', paintThickness?: Array<{ __typename?: 'PainThicknessOption', area: VehicleConditionPaintThicknessArea, canBePlastic: boolean, canBeFabric: boolean } | null> | null } | null } | null } | null };

export type MsiSubmitVinMutationVariables = Exact<{
  vin: Scalars['String']['input'];
  branch?: InputMaybe<Scalars['Int']['input']>;
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MsiSubmitVinMutation = { __typename?: 'Mutation', msiSubmitVin?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, name: string, country: Country }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyType?: string | null, gearBox?: string | null, driveType?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, fuelTypeTranslationKey?: string | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null, co2Emission?: number | null, emissionNorm?: VehicleEngineEmissionNorm | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, condition?: { __typename?: 'VehicleCondition', countryOfOrigin?: Country | null, firstRegistrationDate?: string | null, totalOwnerCount?: number | null, commercialUseType?: Array<VehicleConditionCommercialType> | null, paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, flags?: { __typename?: 'InspectionFlags', carRegistrationAvailable?: boolean | null, co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', countryOfRegistration?: string | null, engineName?: string | null, vatType?: VatType | null, currentOwnerType?: OwnerType | null, inventoryType?: InventoryType | null, otherNote?: string | null, hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null } | null, equipment?: Array<{ __typename?: 'EquipmentMeta', featureRef?: string | null, description?: string | null, isOriginal?: boolean | null, source?: string | null }> | null } | null, fields?: { __typename?: 'InspectionFields', vehicle?: { __typename?: 'VehicleFields', paintThickness?: Array<{ __typename?: 'PainThicknessOption', area: VehicleConditionPaintThicknessArea, canBePlastic: boolean, canBeFabric: boolean } | null> | null } | null } | null } | null };

export type SubmitLicensePlateMutationVariables = Exact<{
  branch: Scalars['Int']['input'];
  licensePlate: Scalars['LicensePlateInput']['input'];
  inspectionId?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitLicensePlateMutation = { __typename?: 'Mutation', submitLicensePlate?: { __typename?: 'Inspection', inspectionId: number, branch: { __typename?: 'Branch', id: number, name: string, country: Country }, vehicle?: { __typename?: 'Vehicle', identifiers?: { __typename?: 'VehicleIdentifiers', vin?: string | null, licensePlate?: string | null, externalId?: string | null } | null, model?: { __typename?: 'VehicleModel', make?: string | null, model?: string | null, subModel?: string | null, buildDate?: string | null, bodyType?: string | null, gearBox?: string | null, driveType?: string | null } | null, engine?: { __typename?: 'VehicleEngine', fuelType?: VehicleEngineFuelType | null, batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, fuelTypeTranslationKey?: string | null, hp?: number | null, kw?: number | null, cylinder?: number | null, cubicCapacity?: number | null, co2Emission?: number | null, emissionNorm?: VehicleEngineEmissionNorm | null, engineList?: Array<{ __typename?: 'VehicleEngineDetails', batteryHealth?: VehicleBatteryHealth | null, batteryOwnership?: VehicleEngineBatteryOwnership | null, engineFuelType?: VehicleEngineDetailFuelType | null } | null> | null } | null, images?: Array<{ __typename?: 'VehicleImage', part?: VehicleImagePart | null, area?: VehicleImageArea | null, absoluteUrl: string, mimeType: VehicleMimeType }> | null, condition?: { __typename?: 'VehicleCondition', countryOfOrigin?: Country | null, firstRegistrationDate?: string | null, totalOwnerCount?: number | null, commercialUseType?: Array<VehicleConditionCommercialType> | null, paintThicknesses?: Array<{ __typename?: 'VehicleConditionPaintThickness', area?: VehicleConditionPaintThicknessArea | null, value?: number | null, isNotMeasurable?: boolean | null } | null> | null } | null } | null, flags?: { __typename?: 'InspectionFlags', carRegistrationAvailable?: boolean | null, co2EmissionAvailable?: boolean | null, wasInCommercialUse?: boolean | null, totalOwnersNumberAvailable?: boolean | null } | null, car: { __typename?: 'Car', stockNumber?: string | null, vin?: string | null }, meta?: { __typename?: 'MetaPurchasing', evaluation?: { __typename?: 'MetaEvaluation', countryOfRegistration?: string | null, vatType?: VatType | null, inventoryType?: InventoryType | null, otherNote?: string | null, engineName?: string | null, hasChargingCables?: boolean | null, batteryLeasingCostPerMonthInMinorUnits?: number | null, isBatteryLeasingCostAvailable?: boolean | null, isBatteryConditionReportAvailable?: boolean | null } | null } | null, fields?: { __typename?: 'InspectionFields', vehicle?: { __typename?: 'VehicleFields', paintThickness?: Array<{ __typename?: 'PainThicknessOption', area: VehicleConditionPaintThicknessArea, canBePlastic: boolean, canBeFabric: boolean } | null> | null } | null } | null } | null };

export type GetFileUploadUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileUploadUrlQuery = { __typename?: 'Query', getFileUploadUrl: { __typename?: 'FileUploadUrl', url: string } };

export const QuestionOptionFragmentFragmentDoc = gql`
    fragment questionOptionFragment on QuestionItem {
  id
  translationKey
  allowedOptions
}
    `;
export const GuestRouteViewerDocument = gql`
    query GuestRouteViewer {
  viewer @client {
    userEmail
    userLocale
  }
}
    `;

/**
 * __useGuestRouteViewerQuery__
 *
 * To run a query within a React component, call `useGuestRouteViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestRouteViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestRouteViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestRouteViewerQuery(baseOptions?: Apollo.QueryHookOptions<GuestRouteViewerQuery, GuestRouteViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestRouteViewerQuery, GuestRouteViewerQueryVariables>(GuestRouteViewerDocument, options);
      }
export function useGuestRouteViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestRouteViewerQuery, GuestRouteViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestRouteViewerQuery, GuestRouteViewerQueryVariables>(GuestRouteViewerDocument, options);
        }
export type GuestRouteViewerQueryHookResult = ReturnType<typeof useGuestRouteViewerQuery>;
export type GuestRouteViewerLazyQueryHookResult = ReturnType<typeof useGuestRouteViewerLazyQuery>;
export type GuestRouteViewerQueryResult = Apollo.QueryResult<GuestRouteViewerQuery, GuestRouteViewerQueryVariables>;
export const ProtectedRouteViewerDocument = gql`
    query ProtectedRouteViewer {
  viewer @client {
    userEmail
    userLocale
  }
}
    `;

/**
 * __useProtectedRouteViewerQuery__
 *
 * To run a query within a React component, call `useProtectedRouteViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProtectedRouteViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProtectedRouteViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useProtectedRouteViewerQuery(baseOptions?: Apollo.QueryHookOptions<ProtectedRouteViewerQuery, ProtectedRouteViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProtectedRouteViewerQuery, ProtectedRouteViewerQueryVariables>(ProtectedRouteViewerDocument, options);
      }
export function useProtectedRouteViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProtectedRouteViewerQuery, ProtectedRouteViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProtectedRouteViewerQuery, ProtectedRouteViewerQueryVariables>(ProtectedRouteViewerDocument, options);
        }
export type ProtectedRouteViewerQueryHookResult = ReturnType<typeof useProtectedRouteViewerQuery>;
export type ProtectedRouteViewerLazyQueryHookResult = ReturnType<typeof useProtectedRouteViewerLazyQuery>;
export type ProtectedRouteViewerQueryResult = Apollo.QueryResult<ProtectedRouteViewerQuery, ProtectedRouteViewerQueryVariables>;
export const UserActionsDocument = gql`
    query UserActions {
  user {
    email
    actions {
      canCreatePdfInspection
    }
  }
}
    `;

/**
 * __useUserActionsQuery__
 *
 * To run a query within a React component, call `useUserActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserActionsQuery(baseOptions?: Apollo.QueryHookOptions<UserActionsQuery, UserActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserActionsQuery, UserActionsQueryVariables>(UserActionsDocument, options);
      }
export function useUserActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserActionsQuery, UserActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserActionsQuery, UserActionsQueryVariables>(UserActionsDocument, options);
        }
export type UserActionsQueryHookResult = ReturnType<typeof useUserActionsQuery>;
export type UserActionsLazyQueryHookResult = ReturnType<typeof useUserActionsLazyQuery>;
export type UserActionsQueryResult = Apollo.QueryResult<UserActionsQuery, UserActionsQueryVariables>;
export const BranchCountryDocument = gql`
    query branchCountry($branchId: Int!) {
  branch(id: $branchId) {
    country
  }
}
    `;

/**
 * __useBranchCountryQuery__
 *
 * To run a query within a React component, call `useBranchCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchCountryQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useBranchCountryQuery(baseOptions: Apollo.QueryHookOptions<BranchCountryQuery, BranchCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchCountryQuery, BranchCountryQueryVariables>(BranchCountryDocument, options);
      }
export function useBranchCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchCountryQuery, BranchCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchCountryQuery, BranchCountryQueryVariables>(BranchCountryDocument, options);
        }
export type BranchCountryQueryHookResult = ReturnType<typeof useBranchCountryQuery>;
export type BranchCountryLazyQueryHookResult = ReturnType<typeof useBranchCountryLazyQuery>;
export type BranchCountryQueryResult = Apollo.QueryResult<BranchCountryQuery, BranchCountryQueryVariables>;
export const CarDetailsCarInfoDocument = gql`
    query carDetailsCarInfo($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    branch {
      id
      name
      country
    }
    car {
      stockNumber
    }
    vehicle {
      identifiers {
        vin
      }
      model {
        make
        model
        subModel
        buildDate
        bodyType: bodyTypeTranslationKey
        gearBox: gearBoxTranslationKey
        driveType: driveTypeTranslationKey
      }
      engine {
        fuelType
        fuelTypeTranslationKey
        hp
        kw
        cylinder
        cubicCapacity
      }
      images {
        part
        area
        absoluteUrl
        mimeType
      }
    }
    meta {
      evaluation {
        engineName
        currentOwnerType
      }
    }
  }
}
    `;

/**
 * __useCarDetailsCarInfoQuery__
 *
 * To run a query within a React component, call `useCarDetailsCarInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDetailsCarInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDetailsCarInfoQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCarDetailsCarInfoQuery(baseOptions: Apollo.QueryHookOptions<CarDetailsCarInfoQuery, CarDetailsCarInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarDetailsCarInfoQuery, CarDetailsCarInfoQueryVariables>(CarDetailsCarInfoDocument, options);
      }
export function useCarDetailsCarInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDetailsCarInfoQuery, CarDetailsCarInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarDetailsCarInfoQuery, CarDetailsCarInfoQueryVariables>(CarDetailsCarInfoDocument, options);
        }
export type CarDetailsCarInfoQueryHookResult = ReturnType<typeof useCarDetailsCarInfoQuery>;
export type CarDetailsCarInfoLazyQueryHookResult = ReturnType<typeof useCarDetailsCarInfoLazyQuery>;
export type CarDetailsCarInfoQueryResult = Apollo.QueryResult<CarDetailsCarInfoQuery, CarDetailsCarInfoQueryVariables>;
export const CarDetailsInitialDataDocument = gql`
    query carDetailsInitialData($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    branch {
      id
      country
      licensePlateCallEnabled
    }
    car {
      stockNumber
    }
    vehicle {
      images {
        area
        part
        absoluteUrl
        mimeType
      }
      condition {
        countryOfOrigin
        firstRegistrationDate
        commercialUseType: commercialTypes
        totalOwnerCount
      }
      engine {
        co2Emission
        envClass: emissionNorm
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          batteryHealth
          batteryOwnership
          engineFuelType
        }
      }
      identifiers {
        licensePlate
        externalId
        vin
      }
      model {
        buildDate
        model
      }
    }
    flags {
      carRegistrationAvailable
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
    meta {
      evaluation {
        countryOfRegistration
        vatType
        inventoryType
        otherNote
        currentOwnerType
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
        isBatteryChargeLevelGuaranteed
      }
    }
  }
}
    `;

/**
 * __useCarDetailsInitialDataQuery__
 *
 * To run a query within a React component, call `useCarDetailsInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDetailsInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDetailsInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCarDetailsInitialDataQuery(baseOptions: Apollo.QueryHookOptions<CarDetailsInitialDataQuery, CarDetailsInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarDetailsInitialDataQuery, CarDetailsInitialDataQueryVariables>(CarDetailsInitialDataDocument, options);
      }
export function useCarDetailsInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDetailsInitialDataQuery, CarDetailsInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarDetailsInitialDataQuery, CarDetailsInitialDataQueryVariables>(CarDetailsInitialDataDocument, options);
        }
export type CarDetailsInitialDataQueryHookResult = ReturnType<typeof useCarDetailsInitialDataQuery>;
export type CarDetailsInitialDataLazyQueryHookResult = ReturnType<typeof useCarDetailsInitialDataLazyQuery>;
export type CarDetailsInitialDataQueryResult = Apollo.QueryResult<CarDetailsInitialDataQuery, CarDetailsInitialDataQueryVariables>;
export const CarDetailsUpdaterDocument = gql`
    mutation carDetailsUpdater($inspectionId: Int!, $carRegistrationImages: [VehicleImageInput!], $certificateImages: [VehicleImageInput!], $co2Emission: Decimal, $co2EmissionAvailable: Boolean, $commercialUseType: VehicleConditionCommercialType, $countryOfOrigin: Country, $countryOfRegistration: Country, $envClass: VehicleEngineEmissionNorm, $firstRegistrationDate: Date, $inventoryType: InventoryType, $isFinanced: Boolean, $vatType: VatType, $currentOwnerType: OwnerType, $wasInCommercialUse: Boolean, $totalOwnersNumberAvailable: Boolean, $totalOwnerCount: Int, $licensePlate: String, $externalId: String, $otherNote: String!, $skipOtherNote: Boolean!, $batteryLeased: Boolean, $batteryLeasingCostPerMonthInMinorUnits: Int, $isBatteryLeasingCostAvailable: Boolean, $isBatteryConditionReportAvailable: Boolean, $isBatteryChargeLevelGuaranteed: Boolean!, $batteryHealth: VehicleBatteryHealth, $hasChargingCables: Boolean, $supportingDocuments: [VehicleImageInput!], $skipElectricCar: Boolean!, $incomplete: Boolean) {
  msiSubmitAdditionalData(
    inspectionId: $inspectionId
    incomplete: $incomplete
    data: {carRegistrationImages: $carRegistrationImages, certificateImages: $certificateImages, firstRegistrationDateAvailable: true, firstRegistrationDate: $firstRegistrationDate, commercialUseType: $commercialUseType, envClass: $envClass, vatType: $vatType, currentOwnerType: $currentOwnerType, inventoryType: $inventoryType, countryOfOrigin: $countryOfOrigin, countryOfRegistration: $countryOfRegistration, isFinanced: $isFinanced, co2EmissionAvailable: $co2EmissionAvailable, co2Emission: $co2Emission, wasInCommercialUse: $wasInCommercialUse, totalOwnersNumberAvailable: $totalOwnersNumberAvailable, totalOwnerCount: $totalOwnerCount, licensePlate: $licensePlate, externalId: $externalId}
  ) {
    inspectionId
    vehicle {
      images {
        area
        part
        absoluteUrl
        mimeType
      }
      condition {
        firstRegistrationDate
        commercialTypes
        countryOfOrigin
        totalOwnerCount
      }
      engine {
        emissionNorm
        co2Emission
      }
      identifiers {
        licensePlate
        externalId
      }
    }
    meta {
      evaluation {
        vatType
        inventoryType
        countryOfRegistration
        currentOwnerType
      }
    }
    flags {
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
  }
  evaSubmitElectricCarDetails(
    inspectionId: $inspectionId
    incomplete: $incomplete
    data: {batteryHealth: $batteryHealth, batteryLeased: $batteryLeased, batteryLeasingCostPerMonthInMinorUnits: $batteryLeasingCostPerMonthInMinorUnits, isBatteryLeasingCostAvailable: $isBatteryLeasingCostAvailable, isBatteryConditionReportAvailable: $isBatteryConditionReportAvailable, isBatteryChargeLevelGuaranteed: $isBatteryChargeLevelGuaranteed, hasChargingCables: $hasChargingCables, supportingDocuments: $supportingDocuments}
  ) @skip(if: $skipElectricCar) {
    inspectionId
    vehicle {
      engine {
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          batteryHealth
          batteryOwnership
          engineFuelType
        }
      }
    }
    meta {
      evaluation {
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
        isBatteryChargeLevelGuaranteed
      }
    }
  }
  submitOtherNote(inspectionId: $inspectionId, otherNote: $otherNote) @skip(if: $skipOtherNote) {
    inspectionId
    meta {
      evaluation {
        otherNote
      }
    }
  }
}
    `;
export type CarDetailsUpdaterMutationFn = Apollo.MutationFunction<CarDetailsUpdaterMutation, CarDetailsUpdaterMutationVariables>;

/**
 * __useCarDetailsUpdaterMutation__
 *
 * To run a mutation, you first call `useCarDetailsUpdaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarDetailsUpdaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carDetailsUpdaterMutation, { data, loading, error }] = useCarDetailsUpdaterMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      carRegistrationImages: // value for 'carRegistrationImages'
 *      certificateImages: // value for 'certificateImages'
 *      co2Emission: // value for 'co2Emission'
 *      co2EmissionAvailable: // value for 'co2EmissionAvailable'
 *      commercialUseType: // value for 'commercialUseType'
 *      countryOfOrigin: // value for 'countryOfOrigin'
 *      countryOfRegistration: // value for 'countryOfRegistration'
 *      envClass: // value for 'envClass'
 *      firstRegistrationDate: // value for 'firstRegistrationDate'
 *      inventoryType: // value for 'inventoryType'
 *      isFinanced: // value for 'isFinanced'
 *      vatType: // value for 'vatType'
 *      currentOwnerType: // value for 'currentOwnerType'
 *      wasInCommercialUse: // value for 'wasInCommercialUse'
 *      totalOwnersNumberAvailable: // value for 'totalOwnersNumberAvailable'
 *      totalOwnerCount: // value for 'totalOwnerCount'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *      otherNote: // value for 'otherNote'
 *      skipOtherNote: // value for 'skipOtherNote'
 *      batteryLeased: // value for 'batteryLeased'
 *      batteryLeasingCostPerMonthInMinorUnits: // value for 'batteryLeasingCostPerMonthInMinorUnits'
 *      isBatteryLeasingCostAvailable: // value for 'isBatteryLeasingCostAvailable'
 *      isBatteryConditionReportAvailable: // value for 'isBatteryConditionReportAvailable'
 *      isBatteryChargeLevelGuaranteed: // value for 'isBatteryChargeLevelGuaranteed'
 *      batteryHealth: // value for 'batteryHealth'
 *      hasChargingCables: // value for 'hasChargingCables'
 *      supportingDocuments: // value for 'supportingDocuments'
 *      skipElectricCar: // value for 'skipElectricCar'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useCarDetailsUpdaterMutation(baseOptions?: Apollo.MutationHookOptions<CarDetailsUpdaterMutation, CarDetailsUpdaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarDetailsUpdaterMutation, CarDetailsUpdaterMutationVariables>(CarDetailsUpdaterDocument, options);
      }
export type CarDetailsUpdaterMutationHookResult = ReturnType<typeof useCarDetailsUpdaterMutation>;
export type CarDetailsUpdaterMutationResult = Apollo.MutationResult<CarDetailsUpdaterMutation>;
export type CarDetailsUpdaterMutationOptions = Apollo.BaseMutationOptions<CarDetailsUpdaterMutation, CarDetailsUpdaterMutationVariables>;
export const CheckBeforeSubmitLicensePlateV2Document = gql`
    query checkBeforeSubmitLicensePlateV2($licensePlate: LicensePlateInput!, $branchId: Int!, $evaluationType: EvaluationType!) {
  checkBeforeSubmitLicensePlateV2(
    licensePlate: $licensePlate
    branchId: $branchId
    evaluationType: $evaluationType
  ) {
    retryAfter
    vinStatus
    relatedInspection {
      inspectionId
      lastChangedTime
      sourceType
      actions {
        name
      }
      branch {
        id
        name
      }
      car {
        stockNumber
      }
      vehicle {
        images {
          area
          part
          absoluteUrl
        }
        model {
          make
          model
          subModel
        }
        identifiers {
          vin
          licensePlate
          externalId
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBeforeSubmitLicensePlateV2Query__
 *
 * To run a query within a React component, call `useCheckBeforeSubmitLicensePlateV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckBeforeSubmitLicensePlateV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBeforeSubmitLicensePlateV2Query({
 *   variables: {
 *      licensePlate: // value for 'licensePlate'
 *      branchId: // value for 'branchId'
 *      evaluationType: // value for 'evaluationType'
 *   },
 * });
 */
export function useCheckBeforeSubmitLicensePlateV2Query(baseOptions: Apollo.QueryHookOptions<CheckBeforeSubmitLicensePlateV2Query, CheckBeforeSubmitLicensePlateV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBeforeSubmitLicensePlateV2Query, CheckBeforeSubmitLicensePlateV2QueryVariables>(CheckBeforeSubmitLicensePlateV2Document, options);
      }
export function useCheckBeforeSubmitLicensePlateV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBeforeSubmitLicensePlateV2Query, CheckBeforeSubmitLicensePlateV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBeforeSubmitLicensePlateV2Query, CheckBeforeSubmitLicensePlateV2QueryVariables>(CheckBeforeSubmitLicensePlateV2Document, options);
        }
export type CheckBeforeSubmitLicensePlateV2QueryHookResult = ReturnType<typeof useCheckBeforeSubmitLicensePlateV2Query>;
export type CheckBeforeSubmitLicensePlateV2LazyQueryHookResult = ReturnType<typeof useCheckBeforeSubmitLicensePlateV2LazyQuery>;
export type CheckBeforeSubmitLicensePlateV2QueryResult = Apollo.QueryResult<CheckBeforeSubmitLicensePlateV2Query, CheckBeforeSubmitLicensePlateV2QueryVariables>;
export const CheckBeforeSubmitVinV2Document = gql`
    query checkBeforeSubmitVinV2($vin: VinInput!, $branchId: Int!, $evaluationType: EvaluationType!) {
  checkBeforeSubmitVinV2(
    vin: $vin
    branchId: $branchId
    evaluationType: $evaluationType
  ) {
    retryAfter
    vinStatus
    relatedInspection {
      inspectionId
      lastChangedTime
      sourceType
      actions {
        name
      }
      branch {
        id
        name
      }
      car {
        stockNumber
      }
      vehicle {
        images {
          area
          part
          absoluteUrl
        }
        model {
          make
          model
          subModel
        }
        identifiers {
          vin
          licensePlate
          externalId
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBeforeSubmitVinV2Query__
 *
 * To run a query within a React component, call `useCheckBeforeSubmitVinV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckBeforeSubmitVinV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBeforeSubmitVinV2Query({
 *   variables: {
 *      vin: // value for 'vin'
 *      branchId: // value for 'branchId'
 *      evaluationType: // value for 'evaluationType'
 *   },
 * });
 */
export function useCheckBeforeSubmitVinV2Query(baseOptions: Apollo.QueryHookOptions<CheckBeforeSubmitVinV2Query, CheckBeforeSubmitVinV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBeforeSubmitVinV2Query, CheckBeforeSubmitVinV2QueryVariables>(CheckBeforeSubmitVinV2Document, options);
      }
export function useCheckBeforeSubmitVinV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBeforeSubmitVinV2Query, CheckBeforeSubmitVinV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBeforeSubmitVinV2Query, CheckBeforeSubmitVinV2QueryVariables>(CheckBeforeSubmitVinV2Document, options);
        }
export type CheckBeforeSubmitVinV2QueryHookResult = ReturnType<typeof useCheckBeforeSubmitVinV2Query>;
export type CheckBeforeSubmitVinV2LazyQueryHookResult = ReturnType<typeof useCheckBeforeSubmitVinV2LazyQuery>;
export type CheckBeforeSubmitVinV2QueryResult = Apollo.QueryResult<CheckBeforeSubmitVinV2Query, CheckBeforeSubmitVinV2QueryVariables>;
export const ResolveLicensePlateDocument = gql`
    query resolveLicensePlate($branch: Int!, $licensePlate: LicensePlateInput!) {
  resolveLicensePlate(data: {branch: $branch, licensePlate: $licensePlate})
}
    `;

/**
 * __useResolveLicensePlateQuery__
 *
 * To run a query within a React component, call `useResolveLicensePlateQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveLicensePlateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveLicensePlateQuery({
 *   variables: {
 *      branch: // value for 'branch'
 *      licensePlate: // value for 'licensePlate'
 *   },
 * });
 */
export function useResolveLicensePlateQuery(baseOptions: Apollo.QueryHookOptions<ResolveLicensePlateQuery, ResolveLicensePlateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveLicensePlateQuery, ResolveLicensePlateQueryVariables>(ResolveLicensePlateDocument, options);
      }
export function useResolveLicensePlateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveLicensePlateQuery, ResolveLicensePlateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveLicensePlateQuery, ResolveLicensePlateQueryVariables>(ResolveLicensePlateDocument, options);
        }
export type ResolveLicensePlateQueryHookResult = ReturnType<typeof useResolveLicensePlateQuery>;
export type ResolveLicensePlateLazyQueryHookResult = ReturnType<typeof useResolveLicensePlateLazyQuery>;
export type ResolveLicensePlateQueryResult = Apollo.QueryResult<ResolveLicensePlateQuery, ResolveLicensePlateQueryVariables>;
export const UserInspectionTypesDocument = gql`
    query userInspectionTypes {
  user {
    email
    inspectionTypes {
      type
      enabled
    }
  }
}
    `;

/**
 * __useUserInspectionTypesQuery__
 *
 * To run a query within a React component, call `useUserInspectionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInspectionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInspectionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInspectionTypesQuery(baseOptions?: Apollo.QueryHookOptions<UserInspectionTypesQuery, UserInspectionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInspectionTypesQuery, UserInspectionTypesQueryVariables>(UserInspectionTypesDocument, options);
      }
export function useUserInspectionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInspectionTypesQuery, UserInspectionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInspectionTypesQuery, UserInspectionTypesQueryVariables>(UserInspectionTypesDocument, options);
        }
export type UserInspectionTypesQueryHookResult = ReturnType<typeof useUserInspectionTypesQuery>;
export type UserInspectionTypesLazyQueryHookResult = ReturnType<typeof useUserInspectionTypesLazyQuery>;
export type UserInspectionTypesQueryResult = Apollo.QueryResult<UserInspectionTypesQuery, UserInspectionTypesQueryVariables>;
export const CarPicturesVehicleDocument = gql`
    query carPicturesVehicle($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    vehicle {
      images {
        part
        area
        absoluteUrl
        mimeType
      }
    }
  }
}
    `;

/**
 * __useCarPicturesVehicleQuery__
 *
 * To run a query within a React component, call `useCarPicturesVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarPicturesVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarPicturesVehicleQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCarPicturesVehicleQuery(baseOptions: Apollo.QueryHookOptions<CarPicturesVehicleQuery, CarPicturesVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarPicturesVehicleQuery, CarPicturesVehicleQueryVariables>(CarPicturesVehicleDocument, options);
      }
export function useCarPicturesVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarPicturesVehicleQuery, CarPicturesVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarPicturesVehicleQuery, CarPicturesVehicleQueryVariables>(CarPicturesVehicleDocument, options);
        }
export type CarPicturesVehicleQueryHookResult = ReturnType<typeof useCarPicturesVehicleQuery>;
export type CarPicturesVehicleLazyQueryHookResult = ReturnType<typeof useCarPicturesVehicleLazyQuery>;
export type CarPicturesVehicleQueryResult = Apollo.QueryResult<CarPicturesVehicleQuery, CarPicturesVehicleQueryVariables>;
export const CreateVideoDocument = gql`
    mutation createVideo($inspectionId: Int!, $type: VideoType!) {
  createVideo(inspectionId: $inspectionId, type: $type) {
    getUrl
    preSignedUrl
  }
}
    `;
export type CreateVideoMutationFn = Apollo.MutationFunction<CreateVideoMutation, CreateVideoMutationVariables>;

/**
 * __useCreateVideoMutation__
 *
 * To run a mutation, you first call `useCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMutation, { data, loading, error }] = useCreateVideoMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateVideoMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoMutation, CreateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoMutation, CreateVideoMutationVariables>(CreateVideoDocument, options);
      }
export type CreateVideoMutationHookResult = ReturnType<typeof useCreateVideoMutation>;
export type CreateVideoMutationResult = Apollo.MutationResult<CreateVideoMutation>;
export type CreateVideoMutationOptions = Apollo.BaseMutationOptions<CreateVideoMutation, CreateVideoMutationVariables>;
export const DeleteVehicleImageDocument = gql`
    mutation deleteVehicleImage($inspectionId: Int!, $url: String!) {
  deleteVehicleImage(inspectionId: $inspectionId, url: $url) {
    inspectionId
  }
}
    `;
export type DeleteVehicleImageMutationFn = Apollo.MutationFunction<DeleteVehicleImageMutation, DeleteVehicleImageMutationVariables>;

/**
 * __useDeleteVehicleImageMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleImageMutation, { data, loading, error }] = useDeleteVehicleImageMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDeleteVehicleImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleImageMutation, DeleteVehicleImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleImageMutation, DeleteVehicleImageMutationVariables>(DeleteVehicleImageDocument, options);
      }
export type DeleteVehicleImageMutationHookResult = ReturnType<typeof useDeleteVehicleImageMutation>;
export type DeleteVehicleImageMutationResult = Apollo.MutationResult<DeleteVehicleImageMutation>;
export type DeleteVehicleImageMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleImageMutation, DeleteVehicleImageMutationVariables>;
export const ReplaceAdditionalCarImagesDocument = gql`
    mutation replaceAdditionalCarImages($inspectionId: Int!, $images: [VehicleImageInput!]!, $incomplete: Boolean) {
  replaceAdditionalCarImages(
    inspectionId: $inspectionId
    images: $images
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      images {
        part
        area
        absoluteUrl
        mimeType
      }
    }
  }
}
    `;
export type ReplaceAdditionalCarImagesMutationFn = Apollo.MutationFunction<ReplaceAdditionalCarImagesMutation, ReplaceAdditionalCarImagesMutationVariables>;

/**
 * __useReplaceAdditionalCarImagesMutation__
 *
 * To run a mutation, you first call `useReplaceAdditionalCarImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceAdditionalCarImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceAdditionalCarImagesMutation, { data, loading, error }] = useReplaceAdditionalCarImagesMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      images: // value for 'images'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useReplaceAdditionalCarImagesMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceAdditionalCarImagesMutation, ReplaceAdditionalCarImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceAdditionalCarImagesMutation, ReplaceAdditionalCarImagesMutationVariables>(ReplaceAdditionalCarImagesDocument, options);
      }
export type ReplaceAdditionalCarImagesMutationHookResult = ReturnType<typeof useReplaceAdditionalCarImagesMutation>;
export type ReplaceAdditionalCarImagesMutationResult = Apollo.MutationResult<ReplaceAdditionalCarImagesMutation>;
export type ReplaceAdditionalCarImagesMutationOptions = Apollo.BaseMutationOptions<ReplaceAdditionalCarImagesMutation, ReplaceAdditionalCarImagesMutationVariables>;
export const ReplaceMainCarImagesDocument = gql`
    mutation replaceMainCarImages($inspectionId: Int!, $images: [VehicleImageInput!]!, $incomplete: Boolean) {
  replaceMainCarImages(
    inspectionId: $inspectionId
    images: $images
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      images {
        part
        area
        absoluteUrl
        mimeType
      }
    }
  }
}
    `;
export type ReplaceMainCarImagesMutationFn = Apollo.MutationFunction<ReplaceMainCarImagesMutation, ReplaceMainCarImagesMutationVariables>;

/**
 * __useReplaceMainCarImagesMutation__
 *
 * To run a mutation, you first call `useReplaceMainCarImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceMainCarImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceMainCarImagesMutation, { data, loading, error }] = useReplaceMainCarImagesMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      images: // value for 'images'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useReplaceMainCarImagesMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceMainCarImagesMutation, ReplaceMainCarImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceMainCarImagesMutation, ReplaceMainCarImagesMutationVariables>(ReplaceMainCarImagesDocument, options);
      }
export type ReplaceMainCarImagesMutationHookResult = ReturnType<typeof useReplaceMainCarImagesMutation>;
export type ReplaceMainCarImagesMutationResult = Apollo.MutationResult<ReplaceMainCarImagesMutation>;
export type ReplaceMainCarImagesMutationOptions = Apollo.BaseMutationOptions<ReplaceMainCarImagesMutation, ReplaceMainCarImagesMutationVariables>;
export const CarQualityInitialDataDocument = gql`
    query carQualityInitialData($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    car {
      stockNumber
    }
    vehicle {
      damages {
        area
        part
        type
        files: images {
          absoluteUrl
          mimeType
        }
        isAccidentReason
      }
      condition {
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    meta {
      evaluation {
        paintThickness {
          left
          right
          hood
          roof
          back
        }
      }
      highlights {
        area
        part
        files: images {
          absoluteUrl
          mimeType
        }
      }
    }
    fields {
      vehicle {
        paintThickness {
          area
          canBePlastic
          canBeFabric
        }
      }
    }
    flags {
      isPaintThicknessChecked
    }
  }
  damageOptions {
    area
    areaTranslationKey
    carParts {
      value
      translationKey
      damageTypes {
        translationKey
        value
        severities {
          translationKey
          value
        }
      }
    }
  }
}
    `;

/**
 * __useCarQualityInitialDataQuery__
 *
 * To run a query within a React component, call `useCarQualityInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarQualityInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarQualityInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCarQualityInitialDataQuery(baseOptions: Apollo.QueryHookOptions<CarQualityInitialDataQuery, CarQualityInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarQualityInitialDataQuery, CarQualityInitialDataQueryVariables>(CarQualityInitialDataDocument, options);
      }
export function useCarQualityInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarQualityInitialDataQuery, CarQualityInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarQualityInitialDataQuery, CarQualityInitialDataQueryVariables>(CarQualityInitialDataDocument, options);
        }
export type CarQualityInitialDataQueryHookResult = ReturnType<typeof useCarQualityInitialDataQuery>;
export type CarQualityInitialDataLazyQueryHookResult = ReturnType<typeof useCarQualityInitialDataLazyQuery>;
export type CarQualityInitialDataQueryResult = Apollo.QueryResult<CarQualityInitialDataQuery, CarQualityInitialDataQueryVariables>;
export const DamageOptionsDocument = gql`
    query damageOptions {
  damageOptions {
    area
    areaTranslationKey
    carParts {
      value
      translationKey
      damageTypes {
        translationKey
        value
        severities {
          translationKey
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDamageOptionsQuery__
 *
 * To run a query within a React component, call `useDamageOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDamageOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDamageOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDamageOptionsQuery(baseOptions?: Apollo.QueryHookOptions<DamageOptionsQuery, DamageOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DamageOptionsQuery, DamageOptionsQueryVariables>(DamageOptionsDocument, options);
      }
export function useDamageOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DamageOptionsQuery, DamageOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DamageOptionsQuery, DamageOptionsQueryVariables>(DamageOptionsDocument, options);
        }
export type DamageOptionsQueryHookResult = ReturnType<typeof useDamageOptionsQuery>;
export type DamageOptionsLazyQueryHookResult = ReturnType<typeof useDamageOptionsLazyQuery>;
export type DamageOptionsQueryResult = Apollo.QueryResult<DamageOptionsQuery, DamageOptionsQueryVariables>;
export const UpdateCarQualityDocument = gql`
    mutation updateCarQuality($inspectionId: Int!, $damages: [DamageInput!]!, $highlights: [HighlightInput!]!, $paintThickness: MetaPaintThicknessInput!, $incomplete: Boolean) {
  msiReplaceHighlights(
    inspectionId: $inspectionId
    highlights: $highlights
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      highlights {
        area
        part
        files: images {
          absoluteUrl
          mimeType
        }
      }
    }
  }
  msiSubmitPaintThickness(
    inspectionId: $inspectionId
    paintThickness: $paintThickness
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      evaluation {
        paintThickness {
          left
          right
          hood
          roof
          back
        }
      }
    }
  }
  msiReplaceDamages(
    inspectionId: $inspectionId
    damages: $damages
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      damages {
        area
        part
        type
        files: images {
          absoluteUrl
          mimeType
        }
        isAccidentReason
      }
    }
  }
}
    `;
export type UpdateCarQualityMutationFn = Apollo.MutationFunction<UpdateCarQualityMutation, UpdateCarQualityMutationVariables>;

/**
 * __useUpdateCarQualityMutation__
 *
 * To run a mutation, you first call `useUpdateCarQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarQualityMutation, { data, loading, error }] = useUpdateCarQualityMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      damages: // value for 'damages'
 *      highlights: // value for 'highlights'
 *      paintThickness: // value for 'paintThickness'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useUpdateCarQualityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarQualityMutation, UpdateCarQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarQualityMutation, UpdateCarQualityMutationVariables>(UpdateCarQualityDocument, options);
      }
export type UpdateCarQualityMutationHookResult = ReturnType<typeof useUpdateCarQualityMutation>;
export type UpdateCarQualityMutationResult = Apollo.MutationResult<UpdateCarQualityMutation>;
export type UpdateCarQualityMutationOptions = Apollo.BaseMutationOptions<UpdateCarQualityMutation, UpdateCarQualityMutationVariables>;
export const UpdateCarQualityV2Document = gql`
    mutation updateCarQualityV2($inspectionId: Int!, $damages: [DamageInput!]!, $highlights: [HighlightInput!]!, $isPaintThicknessChecked: Boolean!, $paintThickness: [VehiclePaintThicknessInput!], $incomplete: Boolean, $skipPaintThickness: Boolean!) {
  msiReplaceHighlights(
    inspectionId: $inspectionId
    highlights: $highlights
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      highlights {
        area
        part
        files: images {
          absoluteUrl
          mimeType
        }
      }
    }
  }
  submitPaintThickness(
    inspectionId: $inspectionId
    isPaintThicknessChecked: $isPaintThicknessChecked
    paintThickness: $paintThickness
    incomplete: $incomplete
  ) @skip(if: $skipPaintThickness) {
    inspectionId
    vehicle {
      condition {
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    flags {
      isPaintThicknessChecked
    }
  }
  msiReplaceDamages(
    inspectionId: $inspectionId
    damages: $damages
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      damages {
        area
        part
        type
        files: images {
          absoluteUrl
          mimeType
        }
        isAccidentReason
      }
    }
  }
}
    `;
export type UpdateCarQualityV2MutationFn = Apollo.MutationFunction<UpdateCarQualityV2Mutation, UpdateCarQualityV2MutationVariables>;

/**
 * __useUpdateCarQualityV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCarQualityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarQualityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarQualityV2Mutation, { data, loading, error }] = useUpdateCarQualityV2Mutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      damages: // value for 'damages'
 *      highlights: // value for 'highlights'
 *      isPaintThicknessChecked: // value for 'isPaintThicknessChecked'
 *      paintThickness: // value for 'paintThickness'
 *      incomplete: // value for 'incomplete'
 *      skipPaintThickness: // value for 'skipPaintThickness'
 *   },
 * });
 */
export function useUpdateCarQualityV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarQualityV2Mutation, UpdateCarQualityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarQualityV2Mutation, UpdateCarQualityV2MutationVariables>(UpdateCarQualityV2Document, options);
      }
export type UpdateCarQualityV2MutationHookResult = ReturnType<typeof useUpdateCarQualityV2Mutation>;
export type UpdateCarQualityV2MutationResult = Apollo.MutationResult<UpdateCarQualityV2Mutation>;
export type UpdateCarQualityV2MutationOptions = Apollo.BaseMutationOptions<UpdateCarQualityV2Mutation, UpdateCarQualityV2MutationVariables>;
export const CarStatusDataDocument = gql`
    query CarStatusData($inspectionId: Int!) {
  getMandatoryEquipment(inspectionId: $inspectionId) {
    translationKey
    exists
    name
    items {
      id
      description
      source
      exists
    }
  }
  inspection(inspectionId: $inspectionId) {
    inspectionId
    vehicle {
      interior {
        seatCount
        upholstery
        isUpholsteryOriginal
      }
      condition {
        keyCount
      }
      exterior {
        mainColor
        colorDetails {
          isOriginal
          effects
        }
      }
      engine {
        fuelType
      }
    }
    meta {
      evaluation {
        hasTuning
        tuningNote
        lpgNote
        hasLpg
        otherNote
      }
    }
  }
}
    `;

/**
 * __useCarStatusDataQuery__
 *
 * To run a query within a React component, call `useCarStatusDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarStatusDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarStatusDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCarStatusDataQuery(baseOptions: Apollo.QueryHookOptions<CarStatusDataQuery, CarStatusDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarStatusDataQuery, CarStatusDataQueryVariables>(CarStatusDataDocument, options);
      }
export function useCarStatusDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarStatusDataQuery, CarStatusDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarStatusDataQuery, CarStatusDataQueryVariables>(CarStatusDataDocument, options);
        }
export type CarStatusDataQueryHookResult = ReturnType<typeof useCarStatusDataQuery>;
export type CarStatusDataLazyQueryHookResult = ReturnType<typeof useCarStatusDataLazyQuery>;
export type CarStatusDataQueryResult = Apollo.QueryResult<CarStatusDataQuery, CarStatusDataQueryVariables>;
export const OtherEquipmentDocument = gql`
    query OtherEquipment($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    meta {
      equipment {
        featureRef
        description
        isOriginal
        source
      }
    }
  }
}
    `;

/**
 * __useOtherEquipmentQuery__
 *
 * To run a query within a React component, call `useOtherEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherEquipmentQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useOtherEquipmentQuery(baseOptions: Apollo.QueryHookOptions<OtherEquipmentQuery, OtherEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtherEquipmentQuery, OtherEquipmentQueryVariables>(OtherEquipmentDocument, options);
      }
export function useOtherEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtherEquipmentQuery, OtherEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtherEquipmentQuery, OtherEquipmentQueryVariables>(OtherEquipmentDocument, options);
        }
export type OtherEquipmentQueryHookResult = ReturnType<typeof useOtherEquipmentQuery>;
export type OtherEquipmentLazyQueryHookResult = ReturnType<typeof useOtherEquipmentLazyQuery>;
export type OtherEquipmentQueryResult = Apollo.QueryResult<OtherEquipmentQuery, OtherEquipmentQueryVariables>;
export const SubmitEquipmentPageDocument = gql`
    mutation submitEquipmentPage($inspectionId: Int!, $otherInformation: MsiOtherInfoInput!, $equipment: [EquipmentGroupItemInput!]!, $otherNote: String, $skipOtherNote: Boolean!, $incomplete: Boolean) {
  msiSubmitOtherInfo(
    inspectionId: $inspectionId
    data: $otherInformation
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      interior {
        seatCount
        upholstery
        isUpholsteryOriginal
      }
      condition {
        keyCount
      }
      exterior {
        mainColor
        colorDetails {
          isOriginal
          effects
        }
      }
    }
    meta {
      evaluation {
        hasTuning
        tuningNote
        lpgNote
        hasLpg
        hasChargingCables
      }
    }
  }
  msiSubmitEquipment(
    inspectionId: $inspectionId
    equipment: $equipment
    incomplete: $incomplete
  ) {
    inspectionId
  }
  submitOtherNote(inspectionId: $inspectionId, otherNote: $otherNote) @skip(if: $skipOtherNote) {
    inspectionId
    meta {
      evaluation {
        otherNote
      }
    }
  }
}
    `;
export type SubmitEquipmentPageMutationFn = Apollo.MutationFunction<SubmitEquipmentPageMutation, SubmitEquipmentPageMutationVariables>;

/**
 * __useSubmitEquipmentPageMutation__
 *
 * To run a mutation, you first call `useSubmitEquipmentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEquipmentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEquipmentPageMutation, { data, loading, error }] = useSubmitEquipmentPageMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      otherInformation: // value for 'otherInformation'
 *      equipment: // value for 'equipment'
 *      otherNote: // value for 'otherNote'
 *      skipOtherNote: // value for 'skipOtherNote'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useSubmitEquipmentPageMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEquipmentPageMutation, SubmitEquipmentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEquipmentPageMutation, SubmitEquipmentPageMutationVariables>(SubmitEquipmentPageDocument, options);
      }
export type SubmitEquipmentPageMutationHookResult = ReturnType<typeof useSubmitEquipmentPageMutation>;
export type SubmitEquipmentPageMutationResult = Apollo.MutationResult<SubmitEquipmentPageMutation>;
export type SubmitEquipmentPageMutationOptions = Apollo.BaseMutationOptions<SubmitEquipmentPageMutation, SubmitEquipmentPageMutationVariables>;
export const SubmitOtherInformationDocument = gql`
    mutation submitOtherInformation($inspectionId: Int!, $otherInformation: MsiOtherInfoInput!, $incomplete: Boolean) {
  msiSubmitOtherInfo(
    inspectionId: $inspectionId
    data: $otherInformation
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      interior {
        seatCount
        upholstery
        isUpholsteryOriginal
      }
      condition {
        keyCount
      }
      exterior {
        mainColor
        colorDetails {
          isOriginal
          effects
        }
      }
    }
    meta {
      evaluation {
        hasTuning
        tuningNote
        lpgNote
        hasLpg
        hasChargingCables
      }
    }
  }
}
    `;
export type SubmitOtherInformationMutationFn = Apollo.MutationFunction<SubmitOtherInformationMutation, SubmitOtherInformationMutationVariables>;

/**
 * __useSubmitOtherInformationMutation__
 *
 * To run a mutation, you first call `useSubmitOtherInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOtherInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOtherInformationMutation, { data, loading, error }] = useSubmitOtherInformationMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      otherInformation: // value for 'otherInformation'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useSubmitOtherInformationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOtherInformationMutation, SubmitOtherInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOtherInformationMutation, SubmitOtherInformationMutationVariables>(SubmitOtherInformationDocument, options);
      }
export type SubmitOtherInformationMutationHookResult = ReturnType<typeof useSubmitOtherInformationMutation>;
export type SubmitOtherInformationMutationResult = Apollo.MutationResult<SubmitOtherInformationMutation>;
export type SubmitOtherInformationMutationOptions = Apollo.BaseMutationOptions<SubmitOtherInformationMutation, SubmitOtherInformationMutationVariables>;
export const PiConvertInspectionToFullEvaDocument = gql`
    mutation piConvertInspectionToFullEva($stockNumber: String!) {
  piConvertInspectionToFullEva(stockNumber: $stockNumber) {
    inspectionId
  }
}
    `;
export type PiConvertInspectionToFullEvaMutationFn = Apollo.MutationFunction<PiConvertInspectionToFullEvaMutation, PiConvertInspectionToFullEvaMutationVariables>;

/**
 * __usePiConvertInspectionToFullEvaMutation__
 *
 * To run a mutation, you first call `usePiConvertInspectionToFullEvaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePiConvertInspectionToFullEvaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [piConvertInspectionToFullEvaMutation, { data, loading, error }] = usePiConvertInspectionToFullEvaMutation({
 *   variables: {
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function usePiConvertInspectionToFullEvaMutation(baseOptions?: Apollo.MutationHookOptions<PiConvertInspectionToFullEvaMutation, PiConvertInspectionToFullEvaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PiConvertInspectionToFullEvaMutation, PiConvertInspectionToFullEvaMutationVariables>(PiConvertInspectionToFullEvaDocument, options);
      }
export type PiConvertInspectionToFullEvaMutationHookResult = ReturnType<typeof usePiConvertInspectionToFullEvaMutation>;
export type PiConvertInspectionToFullEvaMutationResult = Apollo.MutationResult<PiConvertInspectionToFullEvaMutation>;
export type PiConvertInspectionToFullEvaMutationOptions = Apollo.BaseMutationOptions<PiConvertInspectionToFullEvaMutation, PiConvertInspectionToFullEvaMutationVariables>;
export const InspectionsV2Document = gql`
    query inspectionsV2($branchesIds: [Int!], $statusesIds: [InspectionStatus!]) {
  inspectionsV2(
    query: {branch: $branchesIds, status: $statusesIds, pageSize: 100}
  ) {
    inspections {
      inspectionId
      lastChangedTime
      status
      sourceType
      actions {
        name
      }
      car {
        stockNumber
      }
      vehicle {
        identifiers {
          vin
        }
        model {
          subModel
          make
          model
        }
        engine {
          fuelType
        }
        images {
          absoluteUrl
          area
          part
        }
      }
      branch {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useInspectionsV2Query__
 *
 * To run a query within a React component, call `useInspectionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInspectionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionsV2Query({
 *   variables: {
 *      branchesIds: // value for 'branchesIds'
 *      statusesIds: // value for 'statusesIds'
 *   },
 * });
 */
export function useInspectionsV2Query(baseOptions?: Apollo.QueryHookOptions<InspectionsV2Query, InspectionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionsV2Query, InspectionsV2QueryVariables>(InspectionsV2Document, options);
      }
export function useInspectionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionsV2Query, InspectionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionsV2Query, InspectionsV2QueryVariables>(InspectionsV2Document, options);
        }
export type InspectionsV2QueryHookResult = ReturnType<typeof useInspectionsV2Query>;
export type InspectionsV2LazyQueryHookResult = ReturnType<typeof useInspectionsV2LazyQuery>;
export type InspectionsV2QueryResult = Apollo.QueryResult<InspectionsV2Query, InspectionsV2QueryVariables>;
export const GetLocationsListDocument = gql`
    query getLocationsList {
  userBranches {
    id
    name
    street
    zipcode
    city
  }
  userMerchant {
    defaultBranchId
  }
}
    `;

/**
 * __useGetLocationsListQuery__
 *
 * To run a query within a React component, call `useGetLocationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsListQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsListQuery, GetLocationsListQueryVariables>(GetLocationsListDocument, options);
      }
export function useGetLocationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsListQuery, GetLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsListQuery, GetLocationsListQueryVariables>(GetLocationsListDocument, options);
        }
export type GetLocationsListQueryHookResult = ReturnType<typeof useGetLocationsListQuery>;
export type GetLocationsListLazyQueryHookResult = ReturnType<typeof useGetLocationsListLazyQuery>;
export type GetLocationsListQueryResult = Apollo.QueryResult<GetLocationsListQuery, GetLocationsListQueryVariables>;
export const LoginWithGoogleCodeDocument = gql`
    mutation loginWithGoogleCode($authCode: String!) {
  loginWithGoogleCode(authCode: $authCode) @client {
    success
    errorMessage
    data {
      accessToken
      adminGroupIds
      expiresIn
      googleAccessToken
      googleRefreshToken
      jti
      refreshToken
      scope
      tokenType
      userChksum
      userId
      userLocale
      userUuid
    }
  }
}
    `;
export type LoginWithGoogleCodeMutationFn = Apollo.MutationFunction<LoginWithGoogleCodeMutation, LoginWithGoogleCodeMutationVariables>;

/**
 * __useLoginWithGoogleCodeMutation__
 *
 * To run a mutation, you first call `useLoginWithGoogleCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithGoogleCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithGoogleCodeMutation, { data, loading, error }] = useLoginWithGoogleCodeMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *   },
 * });
 */
export function useLoginWithGoogleCodeMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithGoogleCodeMutation, LoginWithGoogleCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithGoogleCodeMutation, LoginWithGoogleCodeMutationVariables>(LoginWithGoogleCodeDocument, options);
      }
export type LoginWithGoogleCodeMutationHookResult = ReturnType<typeof useLoginWithGoogleCodeMutation>;
export type LoginWithGoogleCodeMutationResult = Apollo.MutationResult<LoginWithGoogleCodeMutation>;
export type LoginWithGoogleCodeMutationOptions = Apollo.BaseMutationOptions<LoginWithGoogleCodeMutation, LoginWithGoogleCodeMutationVariables>;
export const ManufacturersDocument = gql`
    query manufacturers($locale: String) {
  getManufacturers(locale: $locale) {
    id
    value
  }
}
    `;

/**
 * __useManufacturersQuery__
 *
 * To run a query within a React component, call `useManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManufacturersQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useManufacturersQuery(baseOptions?: Apollo.QueryHookOptions<ManufacturersQuery, ManufacturersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManufacturersQuery, ManufacturersQueryVariables>(ManufacturersDocument, options);
      }
export function useManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManufacturersQuery, ManufacturersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManufacturersQuery, ManufacturersQueryVariables>(ManufacturersDocument, options);
        }
export type ManufacturersQueryHookResult = ReturnType<typeof useManufacturersQuery>;
export type ManufacturersLazyQueryHookResult = ReturnType<typeof useManufacturersLazyQuery>;
export type ManufacturersQueryResult = Apollo.QueryResult<ManufacturersQuery, ManufacturersQueryVariables>;
export const GetMainTypesDocument = gql`
    query getMainTypes($manufacturerId: String!, $country: String, $locale: String) {
  getMainTypes(
    manufacturerId: $manufacturerId
    country: $country
    locale: $locale
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetMainTypesQuery__
 *
 * To run a query within a React component, call `useGetMainTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainTypesQuery({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      country: // value for 'country'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMainTypesQuery(baseOptions: Apollo.QueryHookOptions<GetMainTypesQuery, GetMainTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainTypesQuery, GetMainTypesQueryVariables>(GetMainTypesDocument, options);
      }
export function useGetMainTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainTypesQuery, GetMainTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainTypesQuery, GetMainTypesQueryVariables>(GetMainTypesDocument, options);
        }
export type GetMainTypesQueryHookResult = ReturnType<typeof useGetMainTypesQuery>;
export type GetMainTypesLazyQueryHookResult = ReturnType<typeof useGetMainTypesLazyQuery>;
export type GetMainTypesQueryResult = Apollo.QueryResult<GetMainTypesQuery, GetMainTypesQueryVariables>;
export const GetBuiltDatesDocument = gql`
    query getBuiltDates($manufacturerId: String!, $mainTypeId: String!, $country: String) {
  getBuiltDates(
    manufacturerId: $manufacturerId
    mainTypeId: $mainTypeId
    country: $country
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetBuiltDatesQuery__
 *
 * To run a query within a React component, call `useGetBuiltDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuiltDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuiltDatesQuery({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      mainTypeId: // value for 'mainTypeId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetBuiltDatesQuery(baseOptions: Apollo.QueryHookOptions<GetBuiltDatesQuery, GetBuiltDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuiltDatesQuery, GetBuiltDatesQueryVariables>(GetBuiltDatesDocument, options);
      }
export function useGetBuiltDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuiltDatesQuery, GetBuiltDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuiltDatesQuery, GetBuiltDatesQueryVariables>(GetBuiltDatesDocument, options);
        }
export type GetBuiltDatesQueryHookResult = ReturnType<typeof useGetBuiltDatesQuery>;
export type GetBuiltDatesLazyQueryHookResult = ReturnType<typeof useGetBuiltDatesLazyQuery>;
export type GetBuiltDatesQueryResult = Apollo.QueryResult<GetBuiltDatesQuery, GetBuiltDatesQueryVariables>;
export const GetBodyTypesDocument = gql`
    query getBodyTypes($manufacturerId: String!, $mainTypeId: String!, $builtDate: String!, $locale: String, $country: String) {
  getBodyTypes(
    locale: $locale
    manufacturerId: $manufacturerId
    mainTypeId: $mainTypeId
    builtDate: $builtDate
    country: $country
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetBodyTypesQuery__
 *
 * To run a query within a React component, call `useGetBodyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBodyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBodyTypesQuery({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      mainTypeId: // value for 'mainTypeId'
 *      builtDate: // value for 'builtDate'
 *      locale: // value for 'locale'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetBodyTypesQuery(baseOptions: Apollo.QueryHookOptions<GetBodyTypesQuery, GetBodyTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBodyTypesQuery, GetBodyTypesQueryVariables>(GetBodyTypesDocument, options);
      }
export function useGetBodyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBodyTypesQuery, GetBodyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBodyTypesQuery, GetBodyTypesQueryVariables>(GetBodyTypesDocument, options);
        }
export type GetBodyTypesQueryHookResult = ReturnType<typeof useGetBodyTypesQuery>;
export type GetBodyTypesLazyQueryHookResult = ReturnType<typeof useGetBodyTypesLazyQuery>;
export type GetBodyTypesQueryResult = Apollo.QueryResult<GetBodyTypesQuery, GetBodyTypesQueryVariables>;
export const GetMainTypeDetailsDocument = gql`
    query getMainTypeDetails($manufacturerId: String!, $mainTypeId: String!, $builtDate: String!, $bodyType: String!, $locale: String, $country: String) {
  getMainTypeDetails(
    locale: $locale
    manufacturerId: $manufacturerId
    mainTypeId: $mainTypeId
    builtDate: $builtDate
    bodyTypeId: $bodyType
    country: $country
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetMainTypeDetailsQuery__
 *
 * To run a query within a React component, call `useGetMainTypeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainTypeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainTypeDetailsQuery({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      mainTypeId: // value for 'mainTypeId'
 *      builtDate: // value for 'builtDate'
 *      bodyType: // value for 'bodyType'
 *      locale: // value for 'locale'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetMainTypeDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMainTypeDetailsQuery, GetMainTypeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainTypeDetailsQuery, GetMainTypeDetailsQueryVariables>(GetMainTypeDetailsDocument, options);
      }
export function useGetMainTypeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainTypeDetailsQuery, GetMainTypeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainTypeDetailsQuery, GetMainTypeDetailsQueryVariables>(GetMainTypeDetailsDocument, options);
        }
export type GetMainTypeDetailsQueryHookResult = ReturnType<typeof useGetMainTypeDetailsQuery>;
export type GetMainTypeDetailsLazyQueryHookResult = ReturnType<typeof useGetMainTypeDetailsLazyQuery>;
export type GetMainTypeDetailsQueryResult = Apollo.QueryResult<GetMainTypeDetailsQuery, GetMainTypeDetailsQueryVariables>;
export const GetMainTypeSubsDocument = gql`
    query getMainTypeSubs($manufacturerId: String!, $mainTypeId: String!, $builtDate: String!, $bodyType: String!, $mainTypeDetailId: String!, $locale: String, $country: String) {
  getMainTypeSubs(
    locale: $locale
    manufacturerId: $manufacturerId
    mainTypeId: $mainTypeId
    builtDate: $builtDate
    bodyTypeId: $bodyType
    mainTypeDetailId: $mainTypeDetailId
    country: $country
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetMainTypeSubsQuery__
 *
 * To run a query within a React component, call `useGetMainTypeSubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainTypeSubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainTypeSubsQuery({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      mainTypeId: // value for 'mainTypeId'
 *      builtDate: // value for 'builtDate'
 *      bodyType: // value for 'bodyType'
 *      mainTypeDetailId: // value for 'mainTypeDetailId'
 *      locale: // value for 'locale'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetMainTypeSubsQuery(baseOptions: Apollo.QueryHookOptions<GetMainTypeSubsQuery, GetMainTypeSubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainTypeSubsQuery, GetMainTypeSubsQueryVariables>(GetMainTypeSubsDocument, options);
      }
export function useGetMainTypeSubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainTypeSubsQuery, GetMainTypeSubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainTypeSubsQuery, GetMainTypeSubsQueryVariables>(GetMainTypeSubsDocument, options);
        }
export type GetMainTypeSubsQueryHookResult = ReturnType<typeof useGetMainTypeSubsQuery>;
export type GetMainTypeSubsLazyQueryHookResult = ReturnType<typeof useGetMainTypeSubsLazyQuery>;
export type GetMainTypeSubsQueryResult = Apollo.QueryResult<GetMainTypeSubsQuery, GetMainTypeSubsQueryVariables>;
export const ManualFlowInitialDataDocument = gql`
    query manualFlowInitialData($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    branch {
      id
      country
      licensePlateCallEnabled
    }
    vehicle {
      identifiers {
        licensePlate
        externalId
        vin
      }
    }
  }
}
    `;

/**
 * __useManualFlowInitialDataQuery__
 *
 * To run a query within a React component, call `useManualFlowInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualFlowInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualFlowInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useManualFlowInitialDataQuery(baseOptions: Apollo.QueryHookOptions<ManualFlowInitialDataQuery, ManualFlowInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualFlowInitialDataQuery, ManualFlowInitialDataQueryVariables>(ManualFlowInitialDataDocument, options);
      }
export function useManualFlowInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualFlowInitialDataQuery, ManualFlowInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualFlowInitialDataQuery, ManualFlowInitialDataQueryVariables>(ManualFlowInitialDataDocument, options);
        }
export type ManualFlowInitialDataQueryHookResult = ReturnType<typeof useManualFlowInitialDataQuery>;
export type ManualFlowInitialDataLazyQueryHookResult = ReturnType<typeof useManualFlowInitialDataLazyQuery>;
export type ManualFlowInitialDataQueryResult = Apollo.QueryResult<ManualFlowInitialDataQuery, ManualFlowInitialDataQueryVariables>;
export const PdfUpdateEcodeDocument = gql`
    mutation pdfUpdateEcode($vin: String!, $inspectionId: Int, $ecode: String!, $year: Int!, $branch: Int!, $licensePlate: String, $externalId: String) {
  msiPdfSubmitEcode(
    vin: $vin
    inspectionId: $inspectionId
    ecode: $ecode
    year: $year
    branch: $branch
    licensePlate: $licensePlate
    externalId: $externalId
  ) {
    inspectionId
    branch {
      id
      country
    }
    car {
      stockNumber
      vin
    }
    vehicle {
      identifiers {
        vin
        licensePlate
        externalId
      }
      model {
        make
        model
        subModel
        buildDate
        bodyTypeTranslationKey
        gearBoxTranslationKey
        driveTypeTranslationKey
      }
      engine {
        fuelTypeTranslationKey
        hp
        kw
        cylinder
        cubicCapacity
        co2Emission
        emissionNorm
      }
    }
    meta {
      evaluation {
        engineName
      }
      equipment {
        featureRef
        description
        isOriginal
        source
      }
    }
  }
}
    `;
export type PdfUpdateEcodeMutationFn = Apollo.MutationFunction<PdfUpdateEcodeMutation, PdfUpdateEcodeMutationVariables>;

/**
 * __usePdfUpdateEcodeMutation__
 *
 * To run a mutation, you first call `usePdfUpdateEcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdfUpdateEcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdfUpdateEcodeMutation, { data, loading, error }] = usePdfUpdateEcodeMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      inspectionId: // value for 'inspectionId'
 *      ecode: // value for 'ecode'
 *      year: // value for 'year'
 *      branch: // value for 'branch'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function usePdfUpdateEcodeMutation(baseOptions?: Apollo.MutationHookOptions<PdfUpdateEcodeMutation, PdfUpdateEcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdfUpdateEcodeMutation, PdfUpdateEcodeMutationVariables>(PdfUpdateEcodeDocument, options);
      }
export type PdfUpdateEcodeMutationHookResult = ReturnType<typeof usePdfUpdateEcodeMutation>;
export type PdfUpdateEcodeMutationResult = Apollo.MutationResult<PdfUpdateEcodeMutation>;
export type PdfUpdateEcodeMutationOptions = Apollo.BaseMutationOptions<PdfUpdateEcodeMutation, PdfUpdateEcodeMutationVariables>;
export const UpdateEcodeDocument = gql`
    mutation updateEcode($vin: String!, $inspectionId: Int, $ecode: String!, $year: Int!, $branch: Int!, $licensePlate: String, $externalId: String) {
  msiSubmitEcode(
    vin: $vin
    inspectionId: $inspectionId
    ecode: $ecode
    year: $year
    branch: $branch
    licensePlate: $licensePlate
    externalId: $externalId
  ) {
    inspectionId
    branch {
      id
      country
    }
    car {
      stockNumber
      vin
    }
    vehicle {
      identifiers {
        vin
        licensePlate
        externalId
      }
      model {
        make
        model
        subModel
        buildDate
        bodyTypeTranslationKey
        gearBoxTranslationKey
        driveTypeTranslationKey
      }
      engine {
        fuelTypeTranslationKey
        fuelType
        hp
        kw
        cylinder
        cubicCapacity
        co2Emission
        emissionNorm
      }
      condition {
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    meta {
      evaluation {
        engineName
      }
      equipment {
        featureRef
        description
        isOriginal
        source
      }
    }
    fields {
      vehicle {
        paintThickness {
          area
          canBePlastic
          canBeFabric
        }
      }
    }
  }
}
    `;
export type UpdateEcodeMutationFn = Apollo.MutationFunction<UpdateEcodeMutation, UpdateEcodeMutationVariables>;

/**
 * __useUpdateEcodeMutation__
 *
 * To run a mutation, you first call `useUpdateEcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcodeMutation, { data, loading, error }] = useUpdateEcodeMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      inspectionId: // value for 'inspectionId'
 *      ecode: // value for 'ecode'
 *      year: // value for 'year'
 *      branch: // value for 'branch'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useUpdateEcodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcodeMutation, UpdateEcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcodeMutation, UpdateEcodeMutationVariables>(UpdateEcodeDocument, options);
      }
export type UpdateEcodeMutationHookResult = ReturnType<typeof useUpdateEcodeMutation>;
export type UpdateEcodeMutationResult = Apollo.MutationResult<UpdateEcodeMutation>;
export type UpdateEcodeMutationOptions = Apollo.BaseMutationOptions<UpdateEcodeMutation, UpdateEcodeMutationVariables>;
export const TechnicalInspectionCompaniesDocument = gql`
    query technicalInspectionCompanies($inspectionId: Int!) {
  technicalInspectionCompanies(inspectionId: $inspectionId) {
    id
    name
  }
}
    `;

/**
 * __useTechnicalInspectionCompaniesQuery__
 *
 * To run a query within a React component, call `useTechnicalInspectionCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalInspectionCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalInspectionCompaniesQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useTechnicalInspectionCompaniesQuery(baseOptions: Apollo.QueryHookOptions<TechnicalInspectionCompaniesQuery, TechnicalInspectionCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalInspectionCompaniesQuery, TechnicalInspectionCompaniesQueryVariables>(TechnicalInspectionCompaniesDocument, options);
      }
export function useTechnicalInspectionCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalInspectionCompaniesQuery, TechnicalInspectionCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalInspectionCompaniesQuery, TechnicalInspectionCompaniesQueryVariables>(TechnicalInspectionCompaniesDocument, options);
        }
export type TechnicalInspectionCompaniesQueryHookResult = ReturnType<typeof useTechnicalInspectionCompaniesQuery>;
export type TechnicalInspectionCompaniesLazyQueryHookResult = ReturnType<typeof useTechnicalInspectionCompaniesLazyQuery>;
export type TechnicalInspectionCompaniesQueryResult = Apollo.QueryResult<TechnicalInspectionCompaniesQuery, TechnicalInspectionCompaniesQueryVariables>;
export const PdfServiceDocumentsUpdaterDocument = gql`
    mutation pdfServiceDocumentsUpdater($inspectionId: Int!, $service: MsiServiceInput!, $accidents: [MsiAccidentInput!]!, $hasHadAccident: Boolean, $otherNote: String!, $inspectionReport: VehicleFileInput, $companyId: Int, $incomplete: Boolean) {
  msiPdfSubmitService(
    inspectionId: $inspectionId
    data: $service
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        hasServiceBook
        serviceBookType
        lastServiceAtDate
        lastServiceAtMileage
        lastDriveBeltChangeDate
        lastDriveBeltChangeMileage
        isUnroadworthy
        cannotBeRolled
        technicalInspectionCertificateExpiryAtDate
      }
      engine {
        engineList {
          isOriginal
        }
      }
    }
    meta {
      evaluation {
        serviceBookAppointments
        serviceBookAppointmentsAvailable
        kmEngineExchange
        serviceBookImages {
          absoluteUrl
          mimeType
        }
        driveBeltChanged
        isMileageManipulated
        mileageManipulatedReason
      }
    }
  }
  evaReplaceAccidents(
    inspectionId: $inspectionId
    accidents: $accidents
    hasHadAccident: $hasHadAccident
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        hasHadAccident
      }
      damages {
        isAccidentReason
      }
    }
    meta {
      accidents {
        repairStatus
        repairedBy
        repairCost
        isRepairCostsAvailable
        invoiceImages {
          absoluteUrl
          mimeType
        }
      }
    }
  }
  msiPdfSubmitTechnicalInspection(
    inspectionId: $inspectionId
    inspectionReport: $inspectionReport
    companyId: $companyId
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      evaluation {
        technicalInspectionReport {
          absoluteUrl
          mimeType
          type
        }
        technicalInspectionCompanyId
      }
    }
  }
  submitOtherNote(inspectionId: $inspectionId, otherNote: $otherNote) {
    inspectionId
    meta {
      evaluation {
        otherNote
      }
    }
  }
}
    `;
export type PdfServiceDocumentsUpdaterMutationFn = Apollo.MutationFunction<PdfServiceDocumentsUpdaterMutation, PdfServiceDocumentsUpdaterMutationVariables>;

/**
 * __usePdfServiceDocumentsUpdaterMutation__
 *
 * To run a mutation, you first call `usePdfServiceDocumentsUpdaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdfServiceDocumentsUpdaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdfServiceDocumentsUpdaterMutation, { data, loading, error }] = usePdfServiceDocumentsUpdaterMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      service: // value for 'service'
 *      accidents: // value for 'accidents'
 *      hasHadAccident: // value for 'hasHadAccident'
 *      otherNote: // value for 'otherNote'
 *      inspectionReport: // value for 'inspectionReport'
 *      companyId: // value for 'companyId'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function usePdfServiceDocumentsUpdaterMutation(baseOptions?: Apollo.MutationHookOptions<PdfServiceDocumentsUpdaterMutation, PdfServiceDocumentsUpdaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdfServiceDocumentsUpdaterMutation, PdfServiceDocumentsUpdaterMutationVariables>(PdfServiceDocumentsUpdaterDocument, options);
      }
export type PdfServiceDocumentsUpdaterMutationHookResult = ReturnType<typeof usePdfServiceDocumentsUpdaterMutation>;
export type PdfServiceDocumentsUpdaterMutationResult = Apollo.MutationResult<PdfServiceDocumentsUpdaterMutation>;
export type PdfServiceDocumentsUpdaterMutationOptions = Apollo.BaseMutationOptions<PdfServiceDocumentsUpdaterMutation, PdfServiceDocumentsUpdaterMutationVariables>;
export const ServiceDocumentsInitialDataDocument = gql`
    query serviceDocumentsInitialData($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    car {
      stockNumber
    }
    vehicle {
      condition {
        hasHadAccident
        hasServiceBook
        serviceBookType
        lastServiceAtDate
        lastServiceAtMileage
        lastDriveBeltChangeDate
        lastDriveBeltChangeMileage
        isUnroadworthy
        cannotBeRolled
        inspectionExpiryDate: technicalInspectionCertificateExpiryAtDate
      }
      engine {
        engineList {
          isOriginal
        }
      }
      damages {
        isAccidentReason
      }
    }
    meta {
      accidents {
        repairStatus
        repairedBy
        repairCost
        isRepairCostsAvailable
        invoiceImages {
          absoluteUrl
          mimeType
        }
      }
      evaluation {
        serviceBookAppointments
        serviceBookAppointmentsAvailable
        kmEngineExchange
        serviceBookImages {
          absoluteUrl
          mimeType
        }
        driveBeltChanged
        technicalInspectionReport {
          absoluteUrl
          mimeType
          type
        }
        otherNote
        technicalInspectionCompanyId
      }
    }
  }
}
    `;

/**
 * __useServiceDocumentsInitialDataQuery__
 *
 * To run a query within a React component, call `useServiceDocumentsInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDocumentsInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDocumentsInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useServiceDocumentsInitialDataQuery(baseOptions: Apollo.QueryHookOptions<ServiceDocumentsInitialDataQuery, ServiceDocumentsInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDocumentsInitialDataQuery, ServiceDocumentsInitialDataQueryVariables>(ServiceDocumentsInitialDataDocument, options);
      }
export function useServiceDocumentsInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDocumentsInitialDataQuery, ServiceDocumentsInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDocumentsInitialDataQuery, ServiceDocumentsInitialDataQueryVariables>(ServiceDocumentsInitialDataDocument, options);
        }
export type ServiceDocumentsInitialDataQueryHookResult = ReturnType<typeof useServiceDocumentsInitialDataQuery>;
export type ServiceDocumentsInitialDataLazyQueryHookResult = ReturnType<typeof useServiceDocumentsInitialDataLazyQuery>;
export type ServiceDocumentsInitialDataQueryResult = Apollo.QueryResult<ServiceDocumentsInitialDataQuery, ServiceDocumentsInitialDataQueryVariables>;
export const ServiceDocumentsUpdaterDocument = gql`
    mutation serviceDocumentsUpdater($inspectionId: Int!, $service: MsiServiceInput!, $accidents: [MsiAccidentInput!]!, $hasHadAccident: Boolean, $otherNote: String!, $inspectionReport: VehicleFileInput, $companyId: Int, $incomplete: Boolean) {
  msiSubmitService(
    inspectionId: $inspectionId
    data: $service
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        hasServiceBook
        serviceBookType
        lastServiceAtDate
        lastServiceAtMileage
        lastDriveBeltChangeDate
        lastDriveBeltChangeMileage
        isUnroadworthy
        cannotBeRolled
        technicalInspectionCertificateExpiryAtDate
      }
      engine {
        engineList {
          isOriginal
        }
      }
    }
    meta {
      evaluation {
        serviceBookAppointments
        serviceBookAppointmentsAvailable
        kmEngineExchange
        serviceBookImages {
          absoluteUrl
          mimeType
        }
        driveBeltChanged
      }
    }
  }
  evaReplaceAccidents(
    inspectionId: $inspectionId
    accidents: $accidents
    hasHadAccident: $hasHadAccident
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        hasHadAccident
      }
      damages {
        isAccidentReason
      }
    }
    meta {
      accidents {
        repairStatus
        repairedBy
        repairCost
        isRepairCostsAvailable
        invoiceImages {
          absoluteUrl
          mimeType
        }
      }
    }
  }
  msiSubmitTechnicalInspection(
    inspectionId: $inspectionId
    inspectionReport: $inspectionReport
    companyId: $companyId
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      evaluation {
        technicalInspectionReport {
          absoluteUrl
          mimeType
          type
        }
        technicalInspectionCompanyId
      }
    }
  }
  submitOtherNote(inspectionId: $inspectionId, otherNote: $otherNote) {
    inspectionId
    meta {
      evaluation {
        otherNote
      }
    }
  }
}
    `;
export type ServiceDocumentsUpdaterMutationFn = Apollo.MutationFunction<ServiceDocumentsUpdaterMutation, ServiceDocumentsUpdaterMutationVariables>;

/**
 * __useServiceDocumentsUpdaterMutation__
 *
 * To run a mutation, you first call `useServiceDocumentsUpdaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceDocumentsUpdaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceDocumentsUpdaterMutation, { data, loading, error }] = useServiceDocumentsUpdaterMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      service: // value for 'service'
 *      accidents: // value for 'accidents'
 *      hasHadAccident: // value for 'hasHadAccident'
 *      otherNote: // value for 'otherNote'
 *      inspectionReport: // value for 'inspectionReport'
 *      companyId: // value for 'companyId'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useServiceDocumentsUpdaterMutation(baseOptions?: Apollo.MutationHookOptions<ServiceDocumentsUpdaterMutation, ServiceDocumentsUpdaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ServiceDocumentsUpdaterMutation, ServiceDocumentsUpdaterMutationVariables>(ServiceDocumentsUpdaterDocument, options);
      }
export type ServiceDocumentsUpdaterMutationHookResult = ReturnType<typeof useServiceDocumentsUpdaterMutation>;
export type ServiceDocumentsUpdaterMutationResult = Apollo.MutationResult<ServiceDocumentsUpdaterMutation>;
export type ServiceDocumentsUpdaterMutationOptions = Apollo.BaseMutationOptions<ServiceDocumentsUpdaterMutation, ServiceDocumentsUpdaterMutationVariables>;
export const GetInspectionByStockNumberDocument = gql`
    query getInspectionByStockNumber($stockNumberOrVin: String!) {
  search(stockNumberOrVin: $stockNumberOrVin) {
    inspectionId
    lastChangedTime
    sourceType
    actions {
      name
    }
    branch {
      id
      name
    }
    car {
      stockNumber
    }
    vehicle {
      identifiers {
        vin
      }
      model {
        subModel
        make
        model
      }
      engine {
        fuelType
      }
      images {
        absoluteUrl
        area
        part
      }
    }
  }
}
    `;

/**
 * __useGetInspectionByStockNumberQuery__
 *
 * To run a query within a React component, call `useGetInspectionByStockNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionByStockNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionByStockNumberQuery({
 *   variables: {
 *      stockNumberOrVin: // value for 'stockNumberOrVin'
 *   },
 * });
 */
export function useGetInspectionByStockNumberQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionByStockNumberQuery, GetInspectionByStockNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionByStockNumberQuery, GetInspectionByStockNumberQueryVariables>(GetInspectionByStockNumberDocument, options);
      }
export function useGetInspectionByStockNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionByStockNumberQuery, GetInspectionByStockNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionByStockNumberQuery, GetInspectionByStockNumberQueryVariables>(GetInspectionByStockNumberDocument, options);
        }
export type GetInspectionByStockNumberQueryHookResult = ReturnType<typeof useGetInspectionByStockNumberQuery>;
export type GetInspectionByStockNumberLazyQueryHookResult = ReturnType<typeof useGetInspectionByStockNumberLazyQuery>;
export type GetInspectionByStockNumberQueryResult = Apollo.QueryResult<GetInspectionByStockNumberQuery, GetInspectionByStockNumberQueryVariables>;
export const EvaSubmitToAuctionDocument = gql`
    mutation evaSubmitToAuction($inspectionId: Int!, $termsAccepted: Boolean!, $expectedPrice: Int!, $failedReasons: [Int!], $auctionTypeId: Int, $startPrice: Int) {
  evaSubmitToAuction(
    inspectionId: $inspectionId
    data: {termsAccepted: $termsAccepted, expectedPrice: $expectedPrice, startPrice: $startPrice, failedReasons: $failedReasons, auctionTypeId: $auctionTypeId}
  ) {
    inspectionId
  }
}
    `;
export type EvaSubmitToAuctionMutationFn = Apollo.MutationFunction<EvaSubmitToAuctionMutation, EvaSubmitToAuctionMutationVariables>;

/**
 * __useEvaSubmitToAuctionMutation__
 *
 * To run a mutation, you first call `useEvaSubmitToAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaSubmitToAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaSubmitToAuctionMutation, { data, loading, error }] = useEvaSubmitToAuctionMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      termsAccepted: // value for 'termsAccepted'
 *      expectedPrice: // value for 'expectedPrice'
 *      failedReasons: // value for 'failedReasons'
 *      auctionTypeId: // value for 'auctionTypeId'
 *      startPrice: // value for 'startPrice'
 *   },
 * });
 */
export function useEvaSubmitToAuctionMutation(baseOptions?: Apollo.MutationHookOptions<EvaSubmitToAuctionMutation, EvaSubmitToAuctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaSubmitToAuctionMutation, EvaSubmitToAuctionMutationVariables>(EvaSubmitToAuctionDocument, options);
      }
export type EvaSubmitToAuctionMutationHookResult = ReturnType<typeof useEvaSubmitToAuctionMutation>;
export type EvaSubmitToAuctionMutationResult = Apollo.MutationResult<EvaSubmitToAuctionMutation>;
export type EvaSubmitToAuctionMutationOptions = Apollo.BaseMutationOptions<EvaSubmitToAuctionMutation, EvaSubmitToAuctionMutationVariables>;
export const EvaSubmitToDirectAuctionDocument = gql`
    mutation evaSubmitToDirectAuction($inspectionId: Int!, $expectedPrice: Int!, $startPrice: Int, $termsAccepted: Boolean!, $failedReasons: [Int!]) {
  evaSubmitToDirectAuction(
    inspectionId: $inspectionId
    data: {expectedPrice: $expectedPrice, startPrice: $startPrice, termsAccepted: $termsAccepted, failedReasons: $failedReasons}
  ) {
    inspectionId
  }
}
    `;
export type EvaSubmitToDirectAuctionMutationFn = Apollo.MutationFunction<EvaSubmitToDirectAuctionMutation, EvaSubmitToDirectAuctionMutationVariables>;

/**
 * __useEvaSubmitToDirectAuctionMutation__
 *
 * To run a mutation, you first call `useEvaSubmitToDirectAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaSubmitToDirectAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaSubmitToDirectAuctionMutation, { data, loading, error }] = useEvaSubmitToDirectAuctionMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      expectedPrice: // value for 'expectedPrice'
 *      startPrice: // value for 'startPrice'
 *      termsAccepted: // value for 'termsAccepted'
 *      failedReasons: // value for 'failedReasons'
 *   },
 * });
 */
export function useEvaSubmitToDirectAuctionMutation(baseOptions?: Apollo.MutationHookOptions<EvaSubmitToDirectAuctionMutation, EvaSubmitToDirectAuctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaSubmitToDirectAuctionMutation, EvaSubmitToDirectAuctionMutationVariables>(EvaSubmitToDirectAuctionDocument, options);
      }
export type EvaSubmitToDirectAuctionMutationHookResult = ReturnType<typeof useEvaSubmitToDirectAuctionMutation>;
export type EvaSubmitToDirectAuctionMutationResult = Apollo.MutationResult<EvaSubmitToDirectAuctionMutation>;
export type EvaSubmitToDirectAuctionMutationOptions = Apollo.BaseMutationOptions<EvaSubmitToDirectAuctionMutation, EvaSubmitToDirectAuctionMutationVariables>;
export const SellerDocument = gql`
    query seller($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    seller {
      companyName
      firstName
      lastName
      email
      phoneNumber
      address {
        city
        country
        street
        zipCode
      }
    }
  }
}
    `;

/**
 * __useSellerQuery__
 *
 * To run a query within a React component, call `useSellerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useSellerQuery(baseOptions: Apollo.QueryHookOptions<SellerQuery, SellerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerQuery, SellerQueryVariables>(SellerDocument, options);
      }
export function useSellerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerQuery, SellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerQuery, SellerQueryVariables>(SellerDocument, options);
        }
export type SellerQueryHookResult = ReturnType<typeof useSellerQuery>;
export type SellerLazyQueryHookResult = ReturnType<typeof useSellerLazyQuery>;
export type SellerQueryResult = Apollo.QueryResult<SellerQuery, SellerQueryVariables>;
export const AutoPriceDocument = gql`
    query autoPrice($inspectionId: Int!) {
  getAutoPrice(inspectionId: $inspectionId) {
    priceInMinorUnits
    status
  }
}
    `;

/**
 * __useAutoPriceQuery__
 *
 * To run a query within a React component, call `useAutoPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoPriceQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useAutoPriceQuery(baseOptions: Apollo.QueryHookOptions<AutoPriceQuery, AutoPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoPriceQuery, AutoPriceQueryVariables>(AutoPriceDocument, options);
      }
export function useAutoPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoPriceQuery, AutoPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoPriceQuery, AutoPriceQueryVariables>(AutoPriceDocument, options);
        }
export type AutoPriceQueryHookResult = ReturnType<typeof useAutoPriceQuery>;
export type AutoPriceLazyQueryHookResult = ReturnType<typeof useAutoPriceLazyQuery>;
export type AutoPriceQueryResult = Apollo.QueryResult<AutoPriceQuery, AutoPriceQueryVariables>;
export const CheckBeforeSubmitToAuctionDocument = gql`
    query checkBeforeSubmitToAuction($inspectionId: Int!) {
  checkBeforeSubmitToAuction(inspectionId: $inspectionId) {
    vinStatus
    relatedInspection {
      inspectionId
      lastChangedTime
      sourceType
      actions {
        name
      }
      branch {
        id
        name
      }
      car {
        stockNumber
      }
      vehicle {
        images {
          area
          part
          absoluteUrl
        }
        model {
          make
          model
          subModel
        }
        identifiers {
          vin
          licensePlate
          externalId
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBeforeSubmitToAuctionQuery__
 *
 * To run a query within a React component, call `useCheckBeforeSubmitToAuctionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBeforeSubmitToAuctionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBeforeSubmitToAuctionQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useCheckBeforeSubmitToAuctionQuery(baseOptions: Apollo.QueryHookOptions<CheckBeforeSubmitToAuctionQuery, CheckBeforeSubmitToAuctionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBeforeSubmitToAuctionQuery, CheckBeforeSubmitToAuctionQueryVariables>(CheckBeforeSubmitToAuctionDocument, options);
      }
export function useCheckBeforeSubmitToAuctionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBeforeSubmitToAuctionQuery, CheckBeforeSubmitToAuctionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBeforeSubmitToAuctionQuery, CheckBeforeSubmitToAuctionQueryVariables>(CheckBeforeSubmitToAuctionDocument, options);
        }
export type CheckBeforeSubmitToAuctionQueryHookResult = ReturnType<typeof useCheckBeforeSubmitToAuctionQuery>;
export type CheckBeforeSubmitToAuctionLazyQueryHookResult = ReturnType<typeof useCheckBeforeSubmitToAuctionLazyQuery>;
export type CheckBeforeSubmitToAuctionQueryResult = Apollo.QueryResult<CheckBeforeSubmitToAuctionQuery, CheckBeforeSubmitToAuctionQueryVariables>;
export const EvaSubmitToBatchAuctionDocument = gql`
    mutation evaSubmitToBatchAuction($inspectionId: Int!, $auctionTypeId: Int, $expectedPrice: Int!, $startPrice: Int, $failedReasons: [Int!], $termsAccepted: Boolean!) {
  evaSubmitToBatchAuction(
    inspectionId: $inspectionId
    data: {auctionTypeId: $auctionTypeId, expectedPrice: $expectedPrice, startPrice: $startPrice, failedReasons: $failedReasons, termsAccepted: $termsAccepted}
  ) {
    inspectionId
  }
}
    `;
export type EvaSubmitToBatchAuctionMutationFn = Apollo.MutationFunction<EvaSubmitToBatchAuctionMutation, EvaSubmitToBatchAuctionMutationVariables>;

/**
 * __useEvaSubmitToBatchAuctionMutation__
 *
 * To run a mutation, you first call `useEvaSubmitToBatchAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaSubmitToBatchAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaSubmitToBatchAuctionMutation, { data, loading, error }] = useEvaSubmitToBatchAuctionMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      auctionTypeId: // value for 'auctionTypeId'
 *      expectedPrice: // value for 'expectedPrice'
 *      startPrice: // value for 'startPrice'
 *      failedReasons: // value for 'failedReasons'
 *      termsAccepted: // value for 'termsAccepted'
 *   },
 * });
 */
export function useEvaSubmitToBatchAuctionMutation(baseOptions?: Apollo.MutationHookOptions<EvaSubmitToBatchAuctionMutation, EvaSubmitToBatchAuctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaSubmitToBatchAuctionMutation, EvaSubmitToBatchAuctionMutationVariables>(EvaSubmitToBatchAuctionDocument, options);
      }
export type EvaSubmitToBatchAuctionMutationHookResult = ReturnType<typeof useEvaSubmitToBatchAuctionMutation>;
export type EvaSubmitToBatchAuctionMutationResult = Apollo.MutationResult<EvaSubmitToBatchAuctionMutation>;
export type EvaSubmitToBatchAuctionMutationOptions = Apollo.BaseMutationOptions<EvaSubmitToBatchAuctionMutation, EvaSubmitToBatchAuctionMutationVariables>;
export const GetStartPriceDocument = gql`
    query getStartPrice($inspectionId: Int!, $expectedPrice: Int!, $currency: Currency) {
  getStartPrice(
    inspectionId: $inspectionId
    data: {expectedPrice: $expectedPrice, currency: $currency}
  ) {
    amount
  }
}
    `;

/**
 * __useGetStartPriceQuery__
 *
 * To run a query within a React component, call `useGetStartPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStartPriceQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      expectedPrice: // value for 'expectedPrice'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetStartPriceQuery(baseOptions: Apollo.QueryHookOptions<GetStartPriceQuery, GetStartPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStartPriceQuery, GetStartPriceQueryVariables>(GetStartPriceDocument, options);
      }
export function useGetStartPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStartPriceQuery, GetStartPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStartPriceQuery, GetStartPriceQueryVariables>(GetStartPriceDocument, options);
        }
export type GetStartPriceQueryHookResult = ReturnType<typeof useGetStartPriceQuery>;
export type GetStartPriceLazyQueryHookResult = ReturnType<typeof useGetStartPriceLazyQuery>;
export type GetStartPriceQueryResult = Apollo.QueryResult<GetStartPriceQuery, GetStartPriceQueryVariables>;
export const SubmitToInstantPriceDocument = gql`
    mutation submitToInstantPrice($inspectionId: Int!, $termsAccepted: Boolean!) {
  submitToInstantPrice(inspectionId: $inspectionId, termsAccepted: $termsAccepted) {
    inspectionId
  }
}
    `;
export type SubmitToInstantPriceMutationFn = Apollo.MutationFunction<SubmitToInstantPriceMutation, SubmitToInstantPriceMutationVariables>;

/**
 * __useSubmitToInstantPriceMutation__
 *
 * To run a mutation, you first call `useSubmitToInstantPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitToInstantPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitToInstantPriceMutation, { data, loading, error }] = useSubmitToInstantPriceMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      termsAccepted: // value for 'termsAccepted'
 *   },
 * });
 */
export function useSubmitToInstantPriceMutation(baseOptions?: Apollo.MutationHookOptions<SubmitToInstantPriceMutation, SubmitToInstantPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitToInstantPriceMutation, SubmitToInstantPriceMutationVariables>(SubmitToInstantPriceDocument, options);
      }
export type SubmitToInstantPriceMutationHookResult = ReturnType<typeof useSubmitToInstantPriceMutation>;
export type SubmitToInstantPriceMutationResult = Apollo.MutationResult<SubmitToInstantPriceMutation>;
export type SubmitToInstantPriceMutationOptions = Apollo.BaseMutationOptions<SubmitToInstantPriceMutation, SubmitToInstantPriceMutationVariables>;
export const SummaryInitialDataDocument = gql`
    query summaryInitialData($inspectionId: Int!) {
  getMandatoryEquipment(inspectionId: $inspectionId) {
    name
    exists
    items {
      description
      exists
    }
  }
  getAuctionOptions(inspectionId: $inspectionId) {
    id
    duration
  }
  msiGetCheckoutTypes(inspectionId: $inspectionId) {
    enabled
    type
    reason
  }
  inspection(inspectionId: $inspectionId) {
    inspectionId
    lastChangedTime
    status
    car {
      stockNumber
    }
    meta {
      accidents {
        repairStatus
      }
      verification {
        failedReasons {
          id
          reasonName
          comment
        }
      }
      evaluation {
        serviceBookAppointmentsAvailable
        serviceBookAppointments
        countryOfRegistration
        isBatteryConditionReportAvailable
        priceIndicatorPrice {
          originalPrice
          minPrice
          maxPrice
          fixedPrice
        }
        expectedPrice
      }
      highlights {
        files: images {
          absoluteUrl
          mimeType
        }
      }
    }
    vehicle {
      images {
        absoluteUrl
        mimeType
        area
      }
      identifiers {
        vin
      }
      interior {
        upholstery
      }
      features {
        hasAirConditioning
        hasAutomaticAirCondition
      }
      condition {
        firstRegistrationDate
        keyCount
        mileage
        commercialTypes
        totalOwnerCount
        hasHadAccident
        hasServiceBook
        lastServiceAtMileage
        lastServiceAtDate
        technicalInspectionCertificateExpiryAtDate
      }
      model {
        make
        model
        subModel
        gearBox: gearBoxTranslationKey
      }
      engine {
        batteryCapacity
        batteryOwnership
        fuelType
        kw
        hp
        engineList {
          isOriginal
          batteryCapacity
          batteryOwnership
          engineFuelType
        }
      }
      damages {
        files: images {
          absoluteUrl
          mimeType
        }
      }
    }
    branch {
      id
      country
    }
    flags {
      totalOwnersNumberAvailable
      wasInCommercialUse
    }
  }
  userMerchant {
    country
  }
}
    `;

/**
 * __useSummaryInitialDataQuery__
 *
 * To run a query within a React component, call `useSummaryInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useSummaryInitialDataQuery(baseOptions: Apollo.QueryHookOptions<SummaryInitialDataQuery, SummaryInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryInitialDataQuery, SummaryInitialDataQueryVariables>(SummaryInitialDataDocument, options);
      }
export function useSummaryInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryInitialDataQuery, SummaryInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryInitialDataQuery, SummaryInitialDataQueryVariables>(SummaryInitialDataDocument, options);
        }
export type SummaryInitialDataQueryHookResult = ReturnType<typeof useSummaryInitialDataQuery>;
export type SummaryInitialDataLazyQueryHookResult = ReturnType<typeof useSummaryInitialDataLazyQuery>;
export type SummaryInitialDataQueryResult = Apollo.QueryResult<SummaryInitialDataQuery, SummaryInitialDataQueryVariables>;
export const SubmitTestDriveDocument = gql`
    mutation submitTestDrive($inspectionId: Int!, $mileage: Int, $skipSubmitMileageManipulationSuspicions: Boolean!, $mileageSuspicions: MileageManipulationSuspicionsInput, $answers: [Int!]!, $incomplete: Boolean) {
  submitMileage(
    inspectionId: $inspectionId
    mileage: $mileage
    canReadMileage: true
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        mileage
      }
    }
  }
  submitMileageManipulationSuspicions(
    inspectionId: $inspectionId
    mileageManipulationSuspicions: $mileageSuspicions
    incomplete: $incomplete
  ) @skip(if: $skipSubmitMileageManipulationSuspicions) {
    inspectionId
    meta {
      evaluation {
        isMileageManipulated
        mileageManipulationSuspicions {
          isMileageConflictingCarCondition
          isOdometerBroken
          isMileageConflictingServiceHistory
          isMileageConflictingDatabase
          isTachometerReplaced
          tachometerReplacementMileage
          isTachometerReplacementMileageAvailable
        }
      }
    }
  }
  submitTestDriveAnswers(
    inspectionId: $inspectionId
    answers: $answers
    incomplete: $incomplete
  ) {
    inspectionId
    meta {
      testDrive {
        answers
      }
    }
  }
}
    `;
export type SubmitTestDriveMutationFn = Apollo.MutationFunction<SubmitTestDriveMutation, SubmitTestDriveMutationVariables>;

/**
 * __useSubmitTestDriveMutation__
 *
 * To run a mutation, you first call `useSubmitTestDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTestDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTestDriveMutation, { data, loading, error }] = useSubmitTestDriveMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      mileage: // value for 'mileage'
 *      skipSubmitMileageManipulationSuspicions: // value for 'skipSubmitMileageManipulationSuspicions'
 *      mileageSuspicions: // value for 'mileageSuspicions'
 *      answers: // value for 'answers'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useSubmitTestDriveMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTestDriveMutation, SubmitTestDriveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTestDriveMutation, SubmitTestDriveMutationVariables>(SubmitTestDriveDocument, options);
      }
export type SubmitTestDriveMutationHookResult = ReturnType<typeof useSubmitTestDriveMutation>;
export type SubmitTestDriveMutationResult = Apollo.MutationResult<SubmitTestDriveMutation>;
export type SubmitTestDriveMutationOptions = Apollo.BaseMutationOptions<SubmitTestDriveMutation, SubmitTestDriveMutationVariables>;
export const TestDriveInitialDataDocument = gql`
    query TestDriveInitialData($inspectionId: Int!) {
  testDriveQuestions(inspectionId: $inspectionId) {
    ...questionOptionFragment
    options {
      ...questionOptionFragment
      options {
        ...questionOptionFragment
        options {
          ...questionOptionFragment
          options {
            ...questionOptionFragment
            options {
              ...questionOptionFragment
              options {
                ...questionOptionFragment
                options {
                  ...questionOptionFragment
                  options {
                    ...questionOptionFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  inspection(inspectionId: $inspectionId) {
    inspectionId
    vehicle {
      condition {
        mileage
      }
    }
    meta {
      testDrive {
        answers
      }
      evaluation {
        isMileageManipulated
        mileageManipulationSuspicions {
          isMileageConflictingCarCondition
          isOdometerBroken
          isMileageConflictingServiceHistory
          isMileageConflictingDatabase
          isTachometerReplaced
          tachometerReplacementMileage
          isTachometerReplacementMileageAvailable
        }
      }
    }
  }
}
    ${QuestionOptionFragmentFragmentDoc}`;

/**
 * __useTestDriveInitialDataQuery__
 *
 * To run a query within a React component, call `useTestDriveInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDriveInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestDriveInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useTestDriveInitialDataQuery(baseOptions: Apollo.QueryHookOptions<TestDriveInitialDataQuery, TestDriveInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestDriveInitialDataQuery, TestDriveInitialDataQueryVariables>(TestDriveInitialDataDocument, options);
      }
export function useTestDriveInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestDriveInitialDataQuery, TestDriveInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestDriveInitialDataQuery, TestDriveInitialDataQueryVariables>(TestDriveInitialDataDocument, options);
        }
export type TestDriveInitialDataQueryHookResult = ReturnType<typeof useTestDriveInitialDataQuery>;
export type TestDriveInitialDataLazyQueryHookResult = ReturnType<typeof useTestDriveInitialDataLazyQuery>;
export type TestDriveInitialDataQueryResult = Apollo.QueryResult<TestDriveInitialDataQuery, TestDriveInitialDataQueryVariables>;
export const TiresBrakesInitialDataDocument = gql`
    query tiresBrakesInitialData($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    vehicle {
      condition {
        brakes {
          area
          condition
        }
      }
      exterior {
        wheelSets {
          isPrimarySet
          wheelDetails {
            profileDepth
            area
            rimType
            tireType
            dotNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTiresBrakesInitialDataQuery__
 *
 * To run a query within a React component, call `useTiresBrakesInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiresBrakesInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiresBrakesInitialDataQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useTiresBrakesInitialDataQuery(baseOptions: Apollo.QueryHookOptions<TiresBrakesInitialDataQuery, TiresBrakesInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TiresBrakesInitialDataQuery, TiresBrakesInitialDataQueryVariables>(TiresBrakesInitialDataDocument, options);
      }
export function useTiresBrakesInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TiresBrakesInitialDataQuery, TiresBrakesInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TiresBrakesInitialDataQuery, TiresBrakesInitialDataQueryVariables>(TiresBrakesInitialDataDocument, options);
        }
export type TiresBrakesInitialDataQueryHookResult = ReturnType<typeof useTiresBrakesInitialDataQuery>;
export type TiresBrakesInitialDataLazyQueryHookResult = ReturnType<typeof useTiresBrakesInitialDataLazyQuery>;
export type TiresBrakesInitialDataQueryResult = Apollo.QueryResult<TiresBrakesInitialDataQuery, TiresBrakesInitialDataQueryVariables>;
export const UpdateTiresBreaksDocument = gql`
    mutation updateTiresBreaks($inspectionId: Int!, $wheels: [VehicleExteriorWheelDetailInput!]!, $extraWheels: [VehicleExteriorWheelDetailInput!]!, $brakesCondition: [VehicleConditionBrakeInput!]!, $isPrimarySet: Boolean!, $isExtraSet: Boolean!, $incomplete: Boolean) {
  submitMainWheels: submitWheels(
    inspectionId: $inspectionId
    wheels: $wheels
    isPrimarySet: $isPrimarySet
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      exterior {
        wheelSets {
          isPrimarySet
          wheelDetails {
            profileDepth
            area
            rimType
            tireType
            dotNumber
          }
        }
      }
    }
  }
  msiReplaceBrakeConditions(
    inspectionId: $inspectionId
    brakeConditions: $brakesCondition
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      condition {
        brakes {
          area
          condition
        }
      }
    }
  }
  submitExtraWheels: submitWheels(
    inspectionId: $inspectionId
    wheels: $extraWheels
    isPrimarySet: $isExtraSet
    incomplete: $incomplete
  ) {
    inspectionId
    vehicle {
      exterior {
        wheelSets {
          isPrimarySet
          wheelDetails {
            profileDepth
            area
            rimType
            tireType
            dotNumber
          }
        }
      }
    }
  }
}
    `;
export type UpdateTiresBreaksMutationFn = Apollo.MutationFunction<UpdateTiresBreaksMutation, UpdateTiresBreaksMutationVariables>;

/**
 * __useUpdateTiresBreaksMutation__
 *
 * To run a mutation, you first call `useUpdateTiresBreaksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTiresBreaksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTiresBreaksMutation, { data, loading, error }] = useUpdateTiresBreaksMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      wheels: // value for 'wheels'
 *      extraWheels: // value for 'extraWheels'
 *      brakesCondition: // value for 'brakesCondition'
 *      isPrimarySet: // value for 'isPrimarySet'
 *      isExtraSet: // value for 'isExtraSet'
 *      incomplete: // value for 'incomplete'
 *   },
 * });
 */
export function useUpdateTiresBreaksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTiresBreaksMutation, UpdateTiresBreaksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTiresBreaksMutation, UpdateTiresBreaksMutationVariables>(UpdateTiresBreaksDocument, options);
      }
export type UpdateTiresBreaksMutationHookResult = ReturnType<typeof useUpdateTiresBreaksMutation>;
export type UpdateTiresBreaksMutationResult = Apollo.MutationResult<UpdateTiresBreaksMutation>;
export type UpdateTiresBreaksMutationOptions = Apollo.BaseMutationOptions<UpdateTiresBreaksMutation, UpdateTiresBreaksMutationVariables>;
export const BranchDocument = gql`
    query branch($id: Int!) {
  branch(id: $id) {
    id
    name
    street
    zipcode
    city
    country
    phone
    email
  }
}
    `;

/**
 * __useBranchQuery__
 *
 * To run a query within a React component, call `useBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBranchQuery(baseOptions: Apollo.QueryHookOptions<BranchQuery, BranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchQuery, BranchQueryVariables>(BranchDocument, options);
      }
export function useBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchQuery, BranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchQuery, BranchQueryVariables>(BranchDocument, options);
        }
export type BranchQueryHookResult = ReturnType<typeof useBranchQuery>;
export type BranchLazyQueryHookResult = ReturnType<typeof useBranchLazyQuery>;
export type BranchQueryResult = Apollo.QueryResult<BranchQuery, BranchQueryVariables>;
export const CreateBranchDocument = gql`
    mutation createBranch($branch: BranchInput!) {
  createBranch(branch: $branch) {
    id
    name
    street
    zipcode
    city
  }
}
    `;
export type CreateBranchMutationFn = Apollo.MutationFunction<CreateBranchMutation, CreateBranchMutationVariables>;

/**
 * __useCreateBranchMutation__
 *
 * To run a mutation, you first call `useCreateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBranchMutation, { data, loading, error }] = useCreateBranchMutation({
 *   variables: {
 *      branch: // value for 'branch'
 *   },
 * });
 */
export function useCreateBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBranchMutation, CreateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBranchMutation, CreateBranchMutationVariables>(CreateBranchDocument, options);
      }
export type CreateBranchMutationHookResult = ReturnType<typeof useCreateBranchMutation>;
export type CreateBranchMutationResult = Apollo.MutationResult<CreateBranchMutation>;
export type CreateBranchMutationOptions = Apollo.BaseMutationOptions<CreateBranchMutation, CreateBranchMutationVariables>;
export const UpdateBranchDocument = gql`
    mutation updateBranch($id: Int!, $branch: BranchInput!) {
  updateBranch(branch: $branch, id: $id) {
    id
    name
    street
    zipcode
    city
  }
}
    `;
export type UpdateBranchMutationFn = Apollo.MutationFunction<UpdateBranchMutation, UpdateBranchMutationVariables>;

/**
 * __useUpdateBranchMutation__
 *
 * To run a mutation, you first call `useUpdateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchMutation, { data, loading, error }] = useUpdateBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      branch: // value for 'branch'
 *   },
 * });
 */
export function useUpdateBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchMutation, UpdateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchMutation, UpdateBranchMutationVariables>(UpdateBranchDocument, options);
      }
export type UpdateBranchMutationHookResult = ReturnType<typeof useUpdateBranchMutation>;
export type UpdateBranchMutationResult = Apollo.MutationResult<UpdateBranchMutation>;
export type UpdateBranchMutationOptions = Apollo.BaseMutationOptions<UpdateBranchMutation, UpdateBranchMutationVariables>;
export const UserBranchesDocument = gql`
    query userBranches {
  userBranches {
    value: id
    label: name
    country
    licensePlateCallEnabled
    street
    zipcode
    city
  }
  userMerchant {
    defaultBranchId
  }
}
    `;

/**
 * __useUserBranchesQuery__
 *
 * To run a query within a React component, call `useUserBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserBranchesQuery(baseOptions?: Apollo.QueryHookOptions<UserBranchesQuery, UserBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBranchesQuery, UserBranchesQueryVariables>(UserBranchesDocument, options);
      }
export function useUserBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBranchesQuery, UserBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBranchesQuery, UserBranchesQueryVariables>(UserBranchesDocument, options);
        }
export type UserBranchesQueryHookResult = ReturnType<typeof useUserBranchesQuery>;
export type UserBranchesLazyQueryHookResult = ReturnType<typeof useUserBranchesLazyQuery>;
export type UserBranchesQueryResult = Apollo.QueryResult<UserBranchesQuery, UserBranchesQueryVariables>;
export const UserBranchesPaginatedDocument = gql`
    query userBranchesPaginated($pageSize: Int, $page: Int, $name: String) {
  userBranchesPaginated(pageSize: $pageSize, page: $page, name: $name) {
    name
    page
    pageSize
    totalPageCount
    entities {
      value: id
      label: name
      country
      licensePlateCallEnabled
      street
      zipcode
      city
    }
  }
  userMerchant {
    defaultBranchId
  }
}
    `;

/**
 * __useUserBranchesPaginatedQuery__
 *
 * To run a query within a React component, call `useUserBranchesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBranchesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBranchesPaginatedQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUserBranchesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<UserBranchesPaginatedQuery, UserBranchesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBranchesPaginatedQuery, UserBranchesPaginatedQueryVariables>(UserBranchesPaginatedDocument, options);
      }
export function useUserBranchesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBranchesPaginatedQuery, UserBranchesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBranchesPaginatedQuery, UserBranchesPaginatedQueryVariables>(UserBranchesPaginatedDocument, options);
        }
export type UserBranchesPaginatedQueryHookResult = ReturnType<typeof useUserBranchesPaginatedQuery>;
export type UserBranchesPaginatedLazyQueryHookResult = ReturnType<typeof useUserBranchesPaginatedLazyQuery>;
export type UserBranchesPaginatedQueryResult = Apollo.QueryResult<UserBranchesPaginatedQuery, UserBranchesPaginatedQueryVariables>;
export const TopBannerDocument = gql`
    query topBanner($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    branch {
      id
      name
    }
    car {
      stockNumber
    }
    vehicle {
      images {
        area
        part
        absoluteUrl
      }
      model {
        make
        model
        subModel
      }
      identifiers {
        vin
      }
    }
  }
}
    `;

/**
 * __useTopBannerQuery__
 *
 * To run a query within a React component, call `useTopBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopBannerQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useTopBannerQuery(baseOptions: Apollo.QueryHookOptions<TopBannerQuery, TopBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopBannerQuery, TopBannerQueryVariables>(TopBannerDocument, options);
      }
export function useTopBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopBannerQuery, TopBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopBannerQuery, TopBannerQueryVariables>(TopBannerDocument, options);
        }
export type TopBannerQueryHookResult = ReturnType<typeof useTopBannerQuery>;
export type TopBannerLazyQueryHookResult = ReturnType<typeof useTopBannerLazyQuery>;
export type TopBannerQueryResult = Apollo.QueryResult<TopBannerQuery, TopBannerQueryVariables>;
export const InspectionDocument = gql`
    query inspection($inspectionId: Int!) {
  inspection(inspectionId: $inspectionId) {
    inspectionId
    editable
    sourceType
    actions {
      name
    }
    branch {
      id
      country
      name
    }
    car {
      stockNumber
      vin
    }
    vehicle {
      condition {
        brakes {
          area
          condition
        }
        countryOfOrigin
        commercialUseType: commercialTypes
        firstRegistrationDate
        keyCount
        mileage
        totalOwnerCount
        hasHadAccident
        hasServiceBook
        serviceBookType
        lastServiceAtDate
        lastServiceAtMileage
        lastDriveBeltChangeDate
        lastDriveBeltChangeMileage
        isUnroadworthy
        technicalInspectionCertificateExpiryAtDate
      }
      damages {
        area
        part
        type
        files: images {
          absoluteUrl
          mimeType
        }
        isAccidentReason
      }
      engine {
        cubicCapacity
        cylinder
        co2Emission
        envClass: emissionNorm
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          isOriginal
          batteryHealth
          batteryOwnership
          engineFuelType
        }
        hp
        kw
      }
      exterior {
        colorDetails {
          isOriginal
          effects
        }
        mainColor
        wheelSets {
          isPrimarySet
          wheelDetails {
            profileDepth
            area
            rimType
            tireType
            dotNumber
          }
        }
      }
      identifiers {
        licensePlate
        externalId
        vin
      }
      images {
        area
        part
        absoluteUrl
        mimeType
      }
      interior {
        seatCount
        upholstery
        isUpholsteryOriginal
      }
      model {
        make
        model
        subModel
        buildDate
        bodyType
        driveType
        gearBox
      }
    }
    flags {
      carRegistrationAvailable
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
    meta {
      accidents {
        repairStatus
        repairedBy
        repairCost
        isRepairCostsAvailable
        invoiceImages {
          absoluteUrl
          mimeType
        }
      }
      evaluation {
        engineName
        countryOfRegistration
        inventoryType
        otherNote
        paintThickness {
          left
          right
          hood
          roof
          back
        }
        vatType
        hasTuning
        tuningNote
        lpgNote
        hasLpg
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
        serviceBookAppointments
        serviceBookAppointmentsAvailable
        kmEngineExchange
        serviceBookImages {
          absoluteUrl
          mimeType
        }
        driveBeltChanged
        isMileageManipulated
        mileageManipulatedReason
        technicalInspectionReport {
          absoluteUrl
          mimeType
          type
        }
        otherNote
        technicalInspectionCompanyId
      }
      highlights {
        area
        part
        files: images {
          absoluteUrl
        }
      }
      testDrive {
        answers
      }
    }
  }
  testDriveQuestions(inspectionId: $inspectionId) {
    ...questionOptionFragment
    options {
      ...questionOptionFragment
      options {
        ...questionOptionFragment
        options {
          ...questionOptionFragment
          options {
            ...questionOptionFragment
            options {
              ...questionOptionFragment
              options {
                ...questionOptionFragment
                options {
                  ...questionOptionFragment
                  options {
                    ...questionOptionFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  getMandatoryEquipment(inspectionId: $inspectionId) {
    translationKey
    exists
    name
    items {
      id
      description
      source
      exists
    }
  }
}
    ${QuestionOptionFragmentFragmentDoc}`;

/**
 * __useInspectionQuery__
 *
 * To run a query within a React component, call `useInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionQuery({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useInspectionQuery(baseOptions: Apollo.QueryHookOptions<InspectionQuery, InspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionQuery, InspectionQueryVariables>(InspectionDocument, options);
      }
export function useInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionQuery, InspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionQuery, InspectionQueryVariables>(InspectionDocument, options);
        }
export type InspectionQueryHookResult = ReturnType<typeof useInspectionQuery>;
export type InspectionLazyQueryHookResult = ReturnType<typeof useInspectionLazyQuery>;
export type InspectionQueryResult = Apollo.QueryResult<InspectionQuery, InspectionQueryVariables>;
export const LayoutViewerDocument = gql`
    query layoutViewer {
  viewer @client {
    userName
    userEmail
    userImage
  }
}
    `;

/**
 * __useLayoutViewerQuery__
 *
 * To run a query within a React component, call `useLayoutViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useLayoutViewerQuery(baseOptions?: Apollo.QueryHookOptions<LayoutViewerQuery, LayoutViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutViewerQuery, LayoutViewerQueryVariables>(LayoutViewerDocument, options);
      }
export function useLayoutViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutViewerQuery, LayoutViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutViewerQuery, LayoutViewerQueryVariables>(LayoutViewerDocument, options);
        }
export type LayoutViewerQueryHookResult = ReturnType<typeof useLayoutViewerQuery>;
export type LayoutViewerLazyQueryHookResult = ReturnType<typeof useLayoutViewerLazyQuery>;
export type LayoutViewerQueryResult = Apollo.QueryResult<LayoutViewerQuery, LayoutViewerQueryVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout @client {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const CreateInspectionFromPdfDocument = gql`
    mutation createInspectionFromPdf($pdfUrl: URL!, $branch: Int!, $vin: String, $licensePlate: String, $externalId: String) {
  createInspectionFromPdf(
    pdfUrl: $pdfUrl
    branch: $branch
    vin: $vin
    licensePlate: $licensePlate
    externalId: $externalId
  ) {
    status
    inspectionId
  }
}
    `;
export type CreateInspectionFromPdfMutationFn = Apollo.MutationFunction<CreateInspectionFromPdfMutation, CreateInspectionFromPdfMutationVariables>;

/**
 * __useCreateInspectionFromPdfMutation__
 *
 * To run a mutation, you first call `useCreateInspectionFromPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionFromPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionFromPdfMutation, { data, loading, error }] = useCreateInspectionFromPdfMutation({
 *   variables: {
 *      pdfUrl: // value for 'pdfUrl'
 *      branch: // value for 'branch'
 *      vin: // value for 'vin'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useCreateInspectionFromPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateInspectionFromPdfMutation, CreateInspectionFromPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInspectionFromPdfMutation, CreateInspectionFromPdfMutationVariables>(CreateInspectionFromPdfDocument, options);
      }
export type CreateInspectionFromPdfMutationHookResult = ReturnType<typeof useCreateInspectionFromPdfMutation>;
export type CreateInspectionFromPdfMutationResult = Apollo.MutationResult<CreateInspectionFromPdfMutation>;
export type CreateInspectionFromPdfMutationOptions = Apollo.BaseMutationOptions<CreateInspectionFromPdfMutation, CreateInspectionFromPdfMutationVariables>;
export const MsiPdfSubmitVinDocument = gql`
    mutation msiPdfSubmitVin($vin: String!, $branch: Int, $inspectionId: Int, $licensePlate: String, $externalId: String) {
  msiPdfSubmitVin(
    vin: $vin
    branch: $branch
    inspectionId: $inspectionId
    licensePlate: $licensePlate
    externalId: $externalId
  ) {
    inspectionId
    branch {
      id
      name
      country
    }
    vehicle {
      identifiers {
        vin
        licensePlate
        externalId
      }
      model {
        make
        model
        subModel
        buildDate
        bodyType: bodyTypeTranslationKey
        gearBox: gearBoxTranslationKey
        driveType: driveTypeTranslationKey
      }
      engine {
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          batteryHealth
          batteryOwnership
          engineFuelType
        }
        fuelTypeTranslationKey
        hp
        kw
        cylinder
        cubicCapacity
        co2Emission
        emissionNorm
      }
      images {
        part
        area
        absoluteUrl
        mimeType
      }
      condition {
        countryOfOrigin
        firstRegistrationDate
        commercialUseType: commercialTypes
        totalOwnerCount
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    flags {
      carRegistrationAvailable
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
    car {
      stockNumber
      vin
    }
    meta {
      evaluation {
        countryOfRegistration
        vatType
        inventoryType
        otherNote
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
      }
      equipment {
        featureRef
        description
        isOriginal
        source
      }
    }
    fields {
      vehicle {
        paintThickness {
          area
          canBePlastic
          canBeFabric
        }
      }
    }
  }
}
    `;
export type MsiPdfSubmitVinMutationFn = Apollo.MutationFunction<MsiPdfSubmitVinMutation, MsiPdfSubmitVinMutationVariables>;

/**
 * __useMsiPdfSubmitVinMutation__
 *
 * To run a mutation, you first call `useMsiPdfSubmitVinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMsiPdfSubmitVinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [msiPdfSubmitVinMutation, { data, loading, error }] = useMsiPdfSubmitVinMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      branch: // value for 'branch'
 *      inspectionId: // value for 'inspectionId'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useMsiPdfSubmitVinMutation(baseOptions?: Apollo.MutationHookOptions<MsiPdfSubmitVinMutation, MsiPdfSubmitVinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MsiPdfSubmitVinMutation, MsiPdfSubmitVinMutationVariables>(MsiPdfSubmitVinDocument, options);
      }
export type MsiPdfSubmitVinMutationHookResult = ReturnType<typeof useMsiPdfSubmitVinMutation>;
export type MsiPdfSubmitVinMutationResult = Apollo.MutationResult<MsiPdfSubmitVinMutation>;
export type MsiPdfSubmitVinMutationOptions = Apollo.BaseMutationOptions<MsiPdfSubmitVinMutation, MsiPdfSubmitVinMutationVariables>;
export const MsiSubmitVinDocument = gql`
    mutation msiSubmitVin($vin: String!, $branch: Int, $inspectionId: Int, $licensePlate: String, $externalId: String) {
  msiSubmitVin(
    vin: $vin
    branch: $branch
    inspectionId: $inspectionId
    licensePlate: $licensePlate
    externalId: $externalId
  ) {
    inspectionId
    branch {
      id
      name
      country
    }
    vehicle {
      identifiers {
        vin
        licensePlate
        externalId
      }
      model {
        make
        model
        subModel
        buildDate
        bodyType: bodyTypeTranslationKey
        gearBox: gearBoxTranslationKey
        driveType: driveTypeTranslationKey
      }
      engine {
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          batteryHealth
          batteryOwnership
          engineFuelType
        }
        fuelTypeTranslationKey
        hp
        kw
        cylinder
        cubicCapacity
        co2Emission
        emissionNorm
      }
      images {
        part
        area
        absoluteUrl
        mimeType
      }
      condition {
        countryOfOrigin
        firstRegistrationDate
        commercialUseType: commercialTypes
        totalOwnerCount
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    flags {
      carRegistrationAvailable
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
    car {
      stockNumber
      vin
    }
    meta {
      evaluation {
        countryOfRegistration
        engineName
        vatType
        currentOwnerType
        inventoryType
        otherNote
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
      }
      equipment {
        featureRef
        description
        isOriginal
        source
      }
    }
    fields {
      vehicle {
        paintThickness {
          area
          canBePlastic
          canBeFabric
        }
      }
    }
  }
}
    `;
export type MsiSubmitVinMutationFn = Apollo.MutationFunction<MsiSubmitVinMutation, MsiSubmitVinMutationVariables>;

/**
 * __useMsiSubmitVinMutation__
 *
 * To run a mutation, you first call `useMsiSubmitVinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMsiSubmitVinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [msiSubmitVinMutation, { data, loading, error }] = useMsiSubmitVinMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      branch: // value for 'branch'
 *      inspectionId: // value for 'inspectionId'
 *      licensePlate: // value for 'licensePlate'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useMsiSubmitVinMutation(baseOptions?: Apollo.MutationHookOptions<MsiSubmitVinMutation, MsiSubmitVinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MsiSubmitVinMutation, MsiSubmitVinMutationVariables>(MsiSubmitVinDocument, options);
      }
export type MsiSubmitVinMutationHookResult = ReturnType<typeof useMsiSubmitVinMutation>;
export type MsiSubmitVinMutationResult = Apollo.MutationResult<MsiSubmitVinMutation>;
export type MsiSubmitVinMutationOptions = Apollo.BaseMutationOptions<MsiSubmitVinMutation, MsiSubmitVinMutationVariables>;
export const SubmitLicensePlateDocument = gql`
    mutation submitLicensePlate($branch: Int!, $licensePlate: LicensePlateInput!, $inspectionId: Int, $externalId: String) {
  submitLicensePlate(
    branch: $branch
    licensePlate: $licensePlate
    inspectionId: $inspectionId
    externalId: $externalId
  ) {
    inspectionId
    branch {
      id
      name
      country
    }
    vehicle {
      identifiers {
        vin
        licensePlate
        externalId
      }
      model {
        make
        model
        subModel
        buildDate
        bodyType: bodyTypeTranslationKey
        gearBox: gearBoxTranslationKey
        driveType: driveTypeTranslationKey
      }
      engine {
        fuelType
        batteryHealth
        batteryOwnership
        engineList {
          batteryHealth
          batteryOwnership
          engineFuelType
        }
        fuelTypeTranslationKey
        hp
        kw
        cylinder
        cubicCapacity
        co2Emission
        emissionNorm
      }
      images {
        part
        area
        absoluteUrl
        mimeType
      }
      condition {
        countryOfOrigin
        firstRegistrationDate
        commercialUseType: commercialTypes
        totalOwnerCount
        paintThicknesses {
          area
          value
          isNotMeasurable
        }
      }
    }
    flags {
      carRegistrationAvailable
      co2EmissionAvailable
      wasInCommercialUse
      totalOwnersNumberAvailable
    }
    car {
      stockNumber
      vin
    }
    meta {
      evaluation {
        countryOfRegistration
        vatType
        inventoryType
        otherNote
        engineName
        hasChargingCables
        batteryLeasingCostPerMonthInMinorUnits
        isBatteryLeasingCostAvailable
        isBatteryConditionReportAvailable
      }
    }
    fields {
      vehicle {
        paintThickness {
          area
          canBePlastic
          canBeFabric
        }
      }
    }
  }
}
    `;
export type SubmitLicensePlateMutationFn = Apollo.MutationFunction<SubmitLicensePlateMutation, SubmitLicensePlateMutationVariables>;

/**
 * __useSubmitLicensePlateMutation__
 *
 * To run a mutation, you first call `useSubmitLicensePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLicensePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLicensePlateMutation, { data, loading, error }] = useSubmitLicensePlateMutation({
 *   variables: {
 *      branch: // value for 'branch'
 *      licensePlate: // value for 'licensePlate'
 *      inspectionId: // value for 'inspectionId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useSubmitLicensePlateMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLicensePlateMutation, SubmitLicensePlateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLicensePlateMutation, SubmitLicensePlateMutationVariables>(SubmitLicensePlateDocument, options);
      }
export type SubmitLicensePlateMutationHookResult = ReturnType<typeof useSubmitLicensePlateMutation>;
export type SubmitLicensePlateMutationResult = Apollo.MutationResult<SubmitLicensePlateMutation>;
export type SubmitLicensePlateMutationOptions = Apollo.BaseMutationOptions<SubmitLicensePlateMutation, SubmitLicensePlateMutationVariables>;
export const GetFileUploadUrlDocument = gql`
    query getFileUploadUrl {
  getFileUploadUrl(s3FileType: EVA_TEMP, mimeType: PDF) {
    url
  }
}
    `;

/**
 * __useGetFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileUploadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileUploadUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetFileUploadUrlQuery, GetFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileUploadUrlQuery, GetFileUploadUrlQueryVariables>(GetFileUploadUrlDocument, options);
      }
export function useGetFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileUploadUrlQuery, GetFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileUploadUrlQuery, GetFileUploadUrlQueryVariables>(GetFileUploadUrlDocument, options);
        }
export type GetFileUploadUrlQueryHookResult = ReturnType<typeof useGetFileUploadUrlQuery>;
export type GetFileUploadUrlLazyQueryHookResult = ReturnType<typeof useGetFileUploadUrlLazyQuery>;
export type GetFileUploadUrlQueryResult = Apollo.QueryResult<GetFileUploadUrlQuery, GetFileUploadUrlQueryVariables>;